export default {
	"97002": {
		"pop":6070,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"Aurora",
		"centroid_lat":"45.4321436380584",
		"centroid_lng":"-122.797794586511",
		"cum_cases_start":"12",
		"cum_cases_end":"213",
		"data": [
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 0},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 11},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 17},
			{m: new Date(2020, 10, 29), cases: 18},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 14},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 14},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97003": {
		"pop":31615,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.6950759833053",
		"centroid_lng":"-122.866536509144",
		"cum_cases_start":"26",
		"cum_cases_end":"878",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 5},
			{m: new Date(2020, 4, 31), cases: 4},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 9},
			{m: new Date(2020, 5, 21), cases: 7},
			{m: new Date(2020, 5, 28), cases: 9},
			{m: new Date(2020, 6, 5), cases: 13},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 25},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 25},
			{m: new Date(2020, 7, 9), cases: 13},
			{m: new Date(2020, 7, 16), cases: 16},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 13},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 23},
			{m: new Date(2020, 9, 11), cases: 14},
			{m: new Date(2020, 9, 18), cases: 16},
			{m: new Date(2020, 9, 25), cases: 19},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 22},
			{m: new Date(2020, 10, 15), cases: 42},
			{m: new Date(2020, 10, 22), cases: 52},
			{m: new Date(2020, 10, 29), cases: 94},
			{m: new Date(2020, 11, 6), cases: 83},
			{m: new Date(2020, 11, 13), cases: 55},
			{m: new Date(2020, 11, 20), cases: 60},
			{m: new Date(2020, 11, 27), cases: 26},
			{m: new Date(2021, 0, 3), cases: 34},
			{m: new Date(2021, 0, 10), cases: 38},
			{m: new Date(2021, 0, 17), cases: 40}
		]
	},
	"97004": {
		"pop":4689,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Beavercreek",
		"centroid_lat":"45.4404662413013",
		"centroid_lng":"-122.455462394893",
		"cum_cases_start":"10",
		"cum_cases_end":"80",
		"data": [
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 10},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97005": {
		"pop":28309,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.6841819567753",
		"centroid_lng":"-122.805361739311",
		"cum_cases_start":"33",
		"cum_cases_end":"1216",
		"data": [
			{m: new Date(2020, 4, 16), cases: 5},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 9},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 18},
			{m: new Date(2020, 6, 12), cases: 18},
			{m: new Date(2020, 6, 19), cases: 30},
			{m: new Date(2020, 6, 26), cases: 41},
			{m: new Date(2020, 7, 2), cases: 21},
			{m: new Date(2020, 7, 9), cases: 26},
			{m: new Date(2020, 7, 16), cases: 44},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 11},
			{m: new Date(2020, 8, 7), cases: 14},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 17},
			{m: new Date(2020, 9, 11), cases: 18},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 22},
			{m: new Date(2020, 10, 1), cases: 33},
			{m: new Date(2020, 10, 8), cases: 25},
			{m: new Date(2020, 10, 15), cases: 60},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 118},
			{m: new Date(2020, 11, 6), cases: 79},
			{m: new Date(2020, 11, 13), cases: 106},
			{m: new Date(2020, 11, 20), cases: 113},
			{m: new Date(2020, 11, 27), cases: 58},
			{m: new Date(2021, 0, 3), cases: 60},
			{m: new Date(2021, 0, 10), cases: 86},
			{m: new Date(2021, 0, 17), cases: 36}
		]
	},
	"97006": {
		"pop":44790,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.7189299882286",
		"centroid_lng":"-122.856414572808",
		"cum_cases_start":"48",
		"cum_cases_end":"1509",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 4},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 6},
			{m: new Date(2020, 5, 21), cases: 9},
			{m: new Date(2020, 5, 28), cases: 25},
			{m: new Date(2020, 6, 5), cases: 34},
			{m: new Date(2020, 6, 12), cases: 16},
			{m: new Date(2020, 6, 19), cases: 32},
			{m: new Date(2020, 6, 26), cases: 23},
			{m: new Date(2020, 7, 2), cases: 32},
			{m: new Date(2020, 7, 9), cases: 24},
			{m: new Date(2020, 7, 16), cases: 24},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 14},
			{m: new Date(2020, 8, 7), cases: 15},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 11},
			{m: new Date(2020, 8, 27), cases: 16},
			{m: new Date(2020, 9, 4), cases: 33},
			{m: new Date(2020, 9, 11), cases: 16},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 40},
			{m: new Date(2020, 10, 1), cases: 57},
			{m: new Date(2020, 10, 8), cases: 56},
			{m: new Date(2020, 10, 15), cases: 81},
			{m: new Date(2020, 10, 22), cases: 77},
			{m: new Date(2020, 10, 29), cases: 136},
			{m: new Date(2020, 11, 6), cases: 124},
			{m: new Date(2020, 11, 13), cases: 98},
			{m: new Date(2020, 11, 20), cases: 116},
			{m: new Date(2020, 11, 27), cases: 87},
			{m: new Date(2021, 0, 3), cases: 64},
			{m: new Date(2021, 0, 10), cases: 95},
			{m: new Date(2021, 0, 17), cases: 51}
		]
	},
	"97007": {
		"pop":48506,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.6363112107353",
		"centroid_lng":"-122.869258403186",
		"cum_cases_start":"46",
		"cum_cases_end":"1482",
		"data": [
			{m: new Date(2020, 4, 16), cases: 8},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 13},
			{m: new Date(2020, 5, 28), cases: 13},
			{m: new Date(2020, 6, 5), cases: 13},
			{m: new Date(2020, 6, 12), cases: 20},
			{m: new Date(2020, 6, 19), cases: 25},
			{m: new Date(2020, 6, 26), cases: 11},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 21},
			{m: new Date(2020, 7, 16), cases: 41},
			{m: new Date(2020, 7, 23), cases: 15},
			{m: new Date(2020, 7, 30), cases: 15},
			{m: new Date(2020, 8, 7), cases: 24},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 30},
			{m: new Date(2020, 8, 27), cases: 18},
			{m: new Date(2020, 9, 4), cases: 20},
			{m: new Date(2020, 9, 11), cases: 22},
			{m: new Date(2020, 9, 18), cases: 24},
			{m: new Date(2020, 9, 25), cases: 28},
			{m: new Date(2020, 10, 1), cases: 39},
			{m: new Date(2020, 10, 8), cases: 74},
			{m: new Date(2020, 10, 15), cases: 87},
			{m: new Date(2020, 10, 22), cases: 95},
			{m: new Date(2020, 10, 29), cases: 147},
			{m: new Date(2020, 11, 6), cases: 132},
			{m: new Date(2020, 11, 13), cases: 92},
			{m: new Date(2020, 11, 20), cases: 86},
			{m: new Date(2020, 11, 27), cases: 71},
			{m: new Date(2021, 0, 3), cases: 69},
			{m: new Date(2021, 0, 10), cases: 90},
			{m: new Date(2021, 0, 17), cases: 67}
		]
	},
	"97008": {
		"pop":30336,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.6521892510169",
		"centroid_lng":"-122.803413328916",
		"cum_cases_start":"16",
		"cum_cases_end":"850",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 15},
			{m: new Date(2020, 6, 12), cases: 14},
			{m: new Date(2020, 6, 19), cases: 16},
			{m: new Date(2020, 6, 26), cases: 24},
			{m: new Date(2020, 7, 2), cases: 25},
			{m: new Date(2020, 7, 9), cases: 17},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 15},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 18},
			{m: new Date(2020, 10, 1), cases: 14},
			{m: new Date(2020, 10, 8), cases: 38},
			{m: new Date(2020, 10, 15), cases: 29},
			{m: new Date(2020, 10, 22), cases: 60},
			{m: new Date(2020, 10, 29), cases: 92},
			{m: new Date(2020, 11, 6), cases: 89},
			{m: new Date(2020, 11, 13), cases: 60},
			{m: new Date(2020, 11, 20), cases: 53},
			{m: new Date(2020, 11, 27), cases: 44},
			{m: new Date(2021, 0, 3), cases: 35},
			{m: new Date(2021, 0, 10), cases: 55},
			{m: new Date(2021, 0, 17), cases: 26}
		]
	},
	"97009": {
		"pop":8151,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Boring",
		"centroid_lat":"45.6159224481265",
		"centroid_lng":"-122.340770580876",
		"cum_cases_start":"14",
		"cum_cases_end":"304",
		"data": [
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 2},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 11},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 8},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 13},
			{m: new Date(2020, 10, 1), cases: 5},
			{m: new Date(2020, 10, 8), cases: 11},
			{m: new Date(2020, 10, 15), cases: 19},
			{m: new Date(2020, 10, 22), cases: 28},
			{m: new Date(2020, 10, 29), cases: 28},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 13},
			{m: new Date(2020, 11, 20), cases: 26},
			{m: new Date(2020, 11, 27), cases: 19},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97013": {
		"pop":25353,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Canby",
		"centroid_lat":"45.411621604832",
		"centroid_lng":"-122.671751388218",
		"cum_cases_start":"29",
		"cum_cases_end":"1032",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 5},
			{m: new Date(2020, 5, 7), cases: 29},
			{m: new Date(2020, 5, 14), cases: 34},
			{m: new Date(2020, 5, 21), cases: 13},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 15},
			{m: new Date(2020, 6, 19), cases: 17},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 13},
			{m: new Date(2020, 7, 30), cases: 27},
			{m: new Date(2020, 8, 7), cases: 19},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 7},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 19},
			{m: new Date(2020, 9, 25), cases: 21},
			{m: new Date(2020, 10, 1), cases: 30},
			{m: new Date(2020, 10, 8), cases: 35},
			{m: new Date(2020, 10, 15), cases: 41},
			{m: new Date(2020, 10, 22), cases: 48},
			{m: new Date(2020, 10, 29), cases: 106},
			{m: new Date(2020, 11, 6), cases: 88},
			{m: new Date(2020, 11, 13), cases: 73},
			{m: new Date(2020, 11, 20), cases: 52},
			{m: new Date(2020, 11, 27), cases: 57},
			{m: new Date(2021, 0, 3), cases: 67},
			{m: new Date(2021, 0, 10), cases: 66},
			{m: new Date(2021, 0, 17), cases: 34}
		]
	},
	"97014": {
		"pop":1327,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Cascade Locks",
		"centroid_lat":"45.8250546558315",
		"centroid_lng":"-121.846575786213",
		"cum_cases_start":"13",
		"cum_cases_end":"30",
		"data": [
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97015": {
		"pop":22633,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Clackamas",
		"centroid_lat":"45.606832894155",
		"centroid_lng":"-122.538486056051",
		"cum_cases_start":"18",
		"cum_cases_end":"958",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 2},
			{m: new Date(2020, 5, 21), cases: 5},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 13},
			{m: new Date(2020, 7, 2), cases: 19},
			{m: new Date(2020, 7, 9), cases: 9},
			{m: new Date(2020, 7, 16), cases: 16},
			{m: new Date(2020, 7, 23), cases: 14},
			{m: new Date(2020, 7, 30), cases: 13},
			{m: new Date(2020, 8, 7), cases: 10},
			{m: new Date(2020, 8, 13), cases: 15},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 22},
			{m: new Date(2020, 9, 4), cases: 11},
			{m: new Date(2020, 9, 11), cases: 15},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 20},
			{m: new Date(2020, 10, 1), cases: 32},
			{m: new Date(2020, 10, 8), cases: 53},
			{m: new Date(2020, 10, 15), cases: 65},
			{m: new Date(2020, 10, 22), cases: 80},
			{m: new Date(2020, 10, 29), cases: 117},
			{m: new Date(2020, 11, 6), cases: 69},
			{m: new Date(2020, 11, 13), cases: 81},
			{m: new Date(2020, 11, 20), cases: 57},
			{m: new Date(2020, 11, 27), cases: 36},
			{m: new Date(2021, 0, 3), cases: 43},
			{m: new Date(2021, 0, 10), cases: 46},
			{m: new Date(2021, 0, 17), cases: 24}
		]
	},
	"97016": {
		"pop":6258,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"Clatskanie",
		"centroid_lat":"46.2492443831267",
		"centroid_lng":"-123.279819446751",
		"cum_cases_start":"16",
		"cum_cases_end":"110",
		"data": [
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 7},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 9},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 9},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97017": {
		"pop":2988,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Colton",
		"centroid_lat":"45.3440533191518",
		"centroid_lng":"-122.361969066152",
		"cum_cases_start":"11",
		"cum_cases_end":"57",
		"data": [
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 9},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97018": {
		"pop":2153,
		"first_date":"9/27",
		"last_date":"1/17",
		"name":"Columbia City",
		"centroid_lat":"46.0916741236951",
		"centroid_lng":"-122.825126461085",
		"cum_cases_start":"10",
		"cum_cases_end":"48",
		"data": [
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 13},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97019": {
		"pop":3443,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Corbett",
		"centroid_lat":"45.7040911875841",
		"centroid_lng":"-122.209678683967",
		"cum_cases_start":"21",
		"cum_cases_end":"88",
		"data": [
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97021": {
		"pop":1416,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Dufur",
		"centroid_lat":"45.5642396372894",
		"centroid_lng":"-121.181137832727",
		"cum_cases_start":"19",
		"cum_cases_end":"28",
		"data": [
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97022": {
		"pop":3852,
		"first_date":"8/23",
		"last_date":"1/17",
		"name":"Eagle Creek",
		"centroid_lat":"45.539595283806",
		"centroid_lng":"-122.32764232451",
		"cum_cases_start":"15",
		"cum_cases_end":"96",
		"data": [
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 7},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 14},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97023": {
		"pop":11650,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Estacada",
		"centroid_lat":"45.2912405654331",
		"centroid_lng":"-122.030127948573",
		"cum_cases_start":"10",
		"cum_cases_end":"291",
		"data": [
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 0},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 3},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 10},
			{m: new Date(2020, 10, 8), cases: 15},
			{m: new Date(2020, 10, 15), cases: 15},
			{m: new Date(2020, 10, 22), cases: 19},
			{m: new Date(2020, 10, 29), cases: 30},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 27},
			{m: new Date(2020, 11, 27), cases: 24},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 15},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97024": {
		"pop":11648,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Fairview",
		"centroid_lat":"45.738239458827",
		"centroid_lng":"-122.44274627793",
		"cum_cases_start":"31",
		"cum_cases_end":"708",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 39},
			{m: new Date(2020, 5, 7), cases: 17},
			{m: new Date(2020, 5, 14), cases: 4},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 15},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 9},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 14},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 22},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 15},
			{m: new Date(2020, 10, 8), cases: 23},
			{m: new Date(2020, 10, 15), cases: 47},
			{m: new Date(2020, 10, 22), cases: 39},
			{m: new Date(2020, 10, 29), cases: 59},
			{m: new Date(2020, 11, 6), cases: 47},
			{m: new Date(2020, 11, 13), cases: 44},
			{m: new Date(2020, 11, 20), cases: 33},
			{m: new Date(2020, 11, 27), cases: 30},
			{m: new Date(2021, 0, 3), cases: 32},
			{m: new Date(2021, 0, 10), cases: 29},
			{m: new Date(2021, 0, 17), cases: 23}
		]
	},
	"97026": {
		"pop":4153,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Gervais",
		"centroid_lat":"45.3001689114329",
		"centroid_lng":"-122.951922741184",
		"cum_cases_start":"43",
		"cum_cases_end":"353",
		"data": [
			{m: new Date(2020, 4, 16), cases: 5},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 12},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 19},
			{m: new Date(2020, 11, 13), cases: 30},
			{m: new Date(2020, 11, 20), cases: 27},
			{m: new Date(2020, 11, 27), cases: 30},
			{m: new Date(2021, 0, 3), cases: 23},
			{m: new Date(2021, 0, 10), cases: 28},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97027": {
		"pop":12999,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Gladstone",
		"centroid_lat":"45.5791290858341",
		"centroid_lng":"-122.592037405701",
		"cum_cases_start":"14",
		"cum_cases_end":"304",
		"data": [
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 3},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 3},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 11},
			{m: new Date(2020, 10, 15), cases: 13},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 29},
			{m: new Date(2020, 11, 6), cases: 29},
			{m: new Date(2020, 11, 13), cases: 28},
			{m: new Date(2020, 11, 20), cases: 28},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 26},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 11}
		]
	},
	"97030": {
		"pop":40367,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Gresham",
		"centroid_lat":"45.7005742037048",
		"centroid_lng":"-122.431832098979",
		"cum_cases_start":"84",
		"cum_cases_end":"2082",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 10},
			{m: new Date(2020, 5, 21), cases: 7},
			{m: new Date(2020, 5, 28), cases: 18},
			{m: new Date(2020, 6, 5), cases: 32},
			{m: new Date(2020, 6, 12), cases: 19},
			{m: new Date(2020, 6, 19), cases: 40},
			{m: new Date(2020, 6, 26), cases: 34},
			{m: new Date(2020, 7, 2), cases: 45},
			{m: new Date(2020, 7, 9), cases: 37},
			{m: new Date(2020, 7, 16), cases: 39},
			{m: new Date(2020, 7, 23), cases: 31},
			{m: new Date(2020, 7, 30), cases: 24},
			{m: new Date(2020, 8, 7), cases: 20},
			{m: new Date(2020, 8, 13), cases: 17},
			{m: new Date(2020, 8, 20), cases: 26},
			{m: new Date(2020, 8, 27), cases: 24},
			{m: new Date(2020, 9, 4), cases: 27},
			{m: new Date(2020, 9, 11), cases: 24},
			{m: new Date(2020, 9, 18), cases: 31},
			{m: new Date(2020, 9, 25), cases: 60},
			{m: new Date(2020, 10, 1), cases: 71},
			{m: new Date(2020, 10, 8), cases: 85},
			{m: new Date(2020, 10, 15), cases: 116},
			{m: new Date(2020, 10, 22), cases: 187},
			{m: new Date(2020, 10, 29), cases: 226},
			{m: new Date(2020, 11, 6), cases: 138},
			{m: new Date(2020, 11, 13), cases: 160},
			{m: new Date(2020, 11, 20), cases: 102},
			{m: new Date(2020, 11, 27), cases: 88},
			{m: new Date(2021, 0, 3), cases: 107},
			{m: new Date(2021, 0, 10), cases: 78},
			{m: new Date(2021, 0, 17), cases: 68}
		]
	},
	"97031": {
		"pop":19663,
		"first_date":"6/7",
		"last_date":"1/17",
		"name":"Hood River",
		"centroid_lat":"45.7954550361638",
		"centroid_lng":"-121.618681709066",
		"cum_cases_start":"51",
		"cum_cases_end":"786",
		"data": [
			{m: new Date(2020, 5, 7), cases: 39},
			{m: new Date(2020, 5, 14), cases: 20},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 9},
			{m: new Date(2020, 6, 19), cases: 18},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 12},
			{m: new Date(2020, 7, 9), cases: 19},
			{m: new Date(2020, 7, 16), cases: 21},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 14},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 16},
			{m: new Date(2020, 10, 22), cases: 38},
			{m: new Date(2020, 10, 29), cases: 51},
			{m: new Date(2020, 11, 6), cases: 74},
			{m: new Date(2020, 11, 13), cases: 94},
			{m: new Date(2020, 11, 20), cases: 107},
			{m: new Date(2020, 11, 27), cases: 54},
			{m: new Date(2021, 0, 3), cases: 36},
			{m: new Date(2021, 0, 10), cases: 51},
			{m: new Date(2021, 0, 17), cases: 34}
		]
	},
	"97032": {
		"pop":5433,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Hubbard",
		"centroid_lat":"45.3742520882319",
		"centroid_lng":"-122.789971864187",
		"cum_cases_start":"21",
		"cum_cases_end":"310",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 16},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 6},
			{m: new Date(2020, 10, 15), cases: 13},
			{m: new Date(2020, 10, 22), cases: 17},
			{m: new Date(2020, 10, 29), cases: 23},
			{m: new Date(2020, 11, 6), cases: 30},
			{m: new Date(2020, 11, 13), cases: 30},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 12}
		]
	},
	"97034": {
		"pop":20264,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Lake Oswego",
		"centroid_lat":"45.6018197729475",
		"centroid_lng":"-122.68472864375",
		"cum_cases_start":"22",
		"cum_cases_end":"375",
		"data": [
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 4},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 7},
			{m: new Date(2020, 6, 26), cases: 7},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 19},
			{m: new Date(2020, 10, 8), cases: 16},
			{m: new Date(2020, 10, 15), cases: 28},
			{m: new Date(2020, 10, 22), cases: 27},
			{m: new Date(2020, 10, 29), cases: 34},
			{m: new Date(2020, 11, 6), cases: 20},
			{m: new Date(2020, 11, 13), cases: 26},
			{m: new Date(2020, 11, 20), cases: 33},
			{m: new Date(2020, 11, 27), cases: 21},
			{m: new Date(2021, 0, 3), cases: 14},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 20}
		]
	},
	"97035": {
		"pop":24948,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"Lake Oswego",
		"centroid_lat":"45.6052684856585",
		"centroid_lng":"-122.722896158437",
		"cum_cases_start":"24",
		"cum_cases_end":"454",
		"data": [
			{m: new Date(2020, 5, 21), cases: 13},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 11},
			{m: new Date(2020, 6, 19), cases: 9},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 9},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 18},
			{m: new Date(2020, 10, 15), cases: 35},
			{m: new Date(2020, 10, 22), cases: 44},
			{m: new Date(2020, 10, 29), cases: 31},
			{m: new Date(2020, 11, 6), cases: 41},
			{m: new Date(2020, 11, 13), cases: 32},
			{m: new Date(2020, 11, 20), cases: 22},
			{m: new Date(2020, 11, 27), cases: 19},
			{m: new Date(2021, 0, 3), cases: 24},
			{m: new Date(2021, 0, 10), cases: 35},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97038": {
		"pop":17181,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Molalla",
		"centroid_lat":"45.2216187332477",
		"centroid_lng":"-122.448326925154",
		"cum_cases_start":"32",
		"cum_cases_end":"477",
		"data": [
			{m: new Date(2020, 4, 16), cases: 4},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 2},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 9},
			{m: new Date(2020, 10, 1), cases: 13},
			{m: new Date(2020, 10, 8), cases: 24},
			{m: new Date(2020, 10, 15), cases: 21},
			{m: new Date(2020, 10, 22), cases: 28},
			{m: new Date(2020, 10, 29), cases: 48},
			{m: new Date(2020, 11, 6), cases: 35},
			{m: new Date(2020, 11, 13), cases: 50},
			{m: new Date(2020, 11, 20), cases: 32},
			{m: new Date(2020, 11, 27), cases: 18},
			{m: new Date(2021, 0, 3), cases: 40},
			{m: new Date(2021, 0, 10), cases: 17},
			{m: new Date(2021, 0, 17), cases: 21}
		]
	},
	"97040": {
		"pop":1411,
		"first_date":"9/20",
		"last_date":"1/17",
		"name":"Mosier",
		"centroid_lat":"45.8140196899419",
		"centroid_lng":"-121.384805273145",
		"cum_cases_start":"10",
		"cum_cases_end":"35",
		"data": [
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97041": {
		"pop":3231,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Mount Hood Parkdale",
		"centroid_lat":"45.6146057390362",
		"centroid_lng":"-121.62902604686",
		"cum_cases_start":"16",
		"cum_cases_end":"96",
		"data": [
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97042": {
		"pop":2837,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Mulino",
		"centroid_lat":"45.401478122946",
		"centroid_lng":"-122.536628854644",
		"cum_cases_start":"12",
		"cum_cases_end":"73",
		"data": [
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 7},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97045": {
		"pop":56808,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Oregon City",
		"centroid_lat":"45.5216056689954",
		"centroid_lng":"-122.526805992649",
		"cum_cases_start":"23",
		"cum_cases_end":"1672",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 10},
			{m: new Date(2020, 5, 14), cases: 17},
			{m: new Date(2020, 5, 21), cases: 31},
			{m: new Date(2020, 5, 28), cases: 21},
			{m: new Date(2020, 6, 5), cases: 32},
			{m: new Date(2020, 6, 12), cases: 21},
			{m: new Date(2020, 6, 19), cases: 13},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 13},
			{m: new Date(2020, 7, 9), cases: 14},
			{m: new Date(2020, 7, 16), cases: 16},
			{m: new Date(2020, 7, 23), cases: 22},
			{m: new Date(2020, 7, 30), cases: 17},
			{m: new Date(2020, 8, 7), cases: 17},
			{m: new Date(2020, 8, 13), cases: 10},
			{m: new Date(2020, 8, 20), cases: 18},
			{m: new Date(2020, 8, 27), cases: 37},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 28},
			{m: new Date(2020, 9, 18), cases: 27},
			{m: new Date(2020, 9, 25), cases: 14},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 38},
			{m: new Date(2020, 10, 15), cases: 81},
			{m: new Date(2020, 10, 22), cases: 120},
			{m: new Date(2020, 10, 29), cases: 234},
			{m: new Date(2020, 11, 6), cases: 134},
			{m: new Date(2020, 11, 13), cases: 137},
			{m: new Date(2020, 11, 20), cases: 113},
			{m: new Date(2020, 11, 27), cases: 77},
			{m: new Date(2021, 0, 3), cases: 108},
			{m: new Date(2021, 0, 10), cases: 115},
			{m: new Date(2021, 0, 17), cases: 65}
		]
	},
	"97048": {
		"pop":6928,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Rainier",
		"centroid_lat":"46.2336171586529",
		"centroid_lng":"-122.985432964456",
		"cum_cases_start":"13",
		"cum_cases_end":"141",
		"data": [
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 10},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 13},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 9},
			{m: new Date(2021, 0, 10), cases: 8},
			{m: new Date(2021, 0, 17), cases: 9}
		]
	},
	"97049": {
		"pop":2251,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Rhododendron",
		"centroid_lat":"45.5812096607873",
		"centroid_lng":"-121.863431657118",
		"cum_cases_start":"16",
		"cum_cases_end":"26",
		"data": [
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97051": {
		"pop":17072,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Saint Helens",
		"centroid_lat":"46.0768468105738",
		"centroid_lng":"-122.922187833518",
		"cum_cases_start":"12",
		"cum_cases_end":"349",
		"data": [
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 9},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 18},
			{m: new Date(2020, 10, 22), cases: 23},
			{m: new Date(2020, 10, 29), cases: 26},
			{m: new Date(2020, 11, 6), cases: 31},
			{m: new Date(2020, 11, 13), cases: 34},
			{m: new Date(2020, 11, 20), cases: 30},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 29},
			{m: new Date(2021, 0, 10), cases: 18},
			{m: new Date(2021, 0, 17), cases: 25}
		]
	},
	"97053": {
		"pop":3343,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Warren",
		"centroid_lat":"46.0162708760443",
		"centroid_lng":"-122.880600151042",
		"cum_cases_start":"15",
		"cum_cases_end":"45",
		"data": [
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97055": {
		"pop":19698,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Sandy",
		"centroid_lat":"45.5676346485825",
		"centroid_lng":"-122.150225274764",
		"cum_cases_start":"16",
		"cum_cases_end":"673",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 0},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 18},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 23},
			{m: new Date(2020, 10, 8), cases: 39},
			{m: new Date(2020, 10, 15), cases: 52},
			{m: new Date(2020, 10, 22), cases: 38},
			{m: new Date(2020, 10, 29), cases: 81},
			{m: new Date(2020, 11, 6), cases: 66},
			{m: new Date(2020, 11, 13), cases: 51},
			{m: new Date(2020, 11, 20), cases: 55},
			{m: new Date(2020, 11, 27), cases: 43},
			{m: new Date(2021, 0, 3), cases: 55},
			{m: new Date(2021, 0, 10), cases: 53},
			{m: new Date(2021, 0, 17), cases: 22}
		]
	},
	"97056": {
		"pop":12276,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Scappoose",
		"centroid_lat":"45.9683468832131",
		"centroid_lng":"-122.956942281007",
		"cum_cases_start":"10",
		"cum_cases_end":"275",
		"data": [
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 9},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 7},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 31},
			{m: new Date(2020, 10, 29), cases: 44},
			{m: new Date(2020, 11, 6), cases: 19},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 14},
			{m: new Date(2021, 0, 3), cases: 20},
			{m: new Date(2021, 0, 10), cases: 25},
			{m: new Date(2021, 0, 17), cases: 19}
		]
	},
	"97058": {
		"pop":21206,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"The Dalles",
		"centroid_lat":"45.734144434447",
		"centroid_lng":"-121.164850698879",
		"cum_cases_start":"17",
		"cum_cases_end":"989",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 6},
			{m: new Date(2020, 5, 7), cases: 9},
			{m: new Date(2020, 5, 14), cases: 6},
			{m: new Date(2020, 5, 21), cases: 7},
			{m: new Date(2020, 5, 28), cases: 19},
			{m: new Date(2020, 6, 5), cases: 21},
			{m: new Date(2020, 6, 12), cases: 18},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 15},
			{m: new Date(2020, 7, 2), cases: 21},
			{m: new Date(2020, 7, 9), cases: 26},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 15},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 16},
			{m: new Date(2020, 8, 27), cases: 31},
			{m: new Date(2020, 9, 4), cases: 11},
			{m: new Date(2020, 9, 11), cases: 25},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 15},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 12},
			{m: new Date(2020, 10, 15), cases: 33},
			{m: new Date(2020, 10, 22), cases: 57},
			{m: new Date(2020, 10, 29), cases: 59},
			{m: new Date(2020, 11, 6), cases: 91},
			{m: new Date(2020, 11, 13), cases: 56},
			{m: new Date(2020, 11, 20), cases: 103},
			{m: new Date(2020, 11, 27), cases: 76},
			{m: new Date(2021, 0, 3), cases: 40},
			{m: new Date(2021, 0, 10), cases: 74},
			{m: new Date(2021, 0, 17), cases: 60}
		]
	},
	"97060": {
		"pop":22075,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Troutdale",
		"centroid_lat":"45.7237649771128",
		"centroid_lng":"-122.374842020274",
		"cum_cases_start":"38",
		"cum_cases_end":"989",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 11},
			{m: new Date(2020, 5, 28), cases: 12},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 16},
			{m: new Date(2020, 6, 19), cases: 27},
			{m: new Date(2020, 6, 26), cases: 14},
			{m: new Date(2020, 7, 2), cases: 29},
			{m: new Date(2020, 7, 9), cases: 15},
			{m: new Date(2020, 7, 16), cases: 10},
			{m: new Date(2020, 7, 23), cases: 13},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 9},
			{m: new Date(2020, 8, 13), cases: 14},
			{m: new Date(2020, 8, 20), cases: 10},
			{m: new Date(2020, 8, 27), cases: 13},
			{m: new Date(2020, 9, 4), cases: 21},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 22},
			{m: new Date(2020, 9, 25), cases: 34},
			{m: new Date(2020, 10, 1), cases: 46},
			{m: new Date(2020, 10, 8), cases: 34},
			{m: new Date(2020, 10, 15), cases: 48},
			{m: new Date(2020, 10, 22), cases: 61},
			{m: new Date(2020, 10, 29), cases: 107},
			{m: new Date(2020, 11, 6), cases: 65},
			{m: new Date(2020, 11, 13), cases: 66},
			{m: new Date(2020, 11, 20), cases: 47},
			{m: new Date(2020, 11, 27), cases: 32},
			{m: new Date(2021, 0, 3), cases: 54},
			{m: new Date(2021, 0, 10), cases: 48},
			{m: new Date(2021, 0, 17), cases: 31}
		]
	},
	"97062": {
		"pop":30007,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Tualatin",
		"centroid_lat":"45.5604384364283",
		"centroid_lng":"-122.762032568972",
		"cum_cases_start":"24",
		"cum_cases_end":"1119",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 7},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 7},
			{m: new Date(2020, 5, 21), cases: 24},
			{m: new Date(2020, 5, 28), cases: 25},
			{m: new Date(2020, 6, 5), cases: 14},
			{m: new Date(2020, 6, 12), cases: 23},
			{m: new Date(2020, 6, 19), cases: 13},
			{m: new Date(2020, 6, 26), cases: 8},
			{m: new Date(2020, 7, 2), cases: 34},
			{m: new Date(2020, 7, 9), cases: 18},
			{m: new Date(2020, 7, 16), cases: 18},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 15},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 7},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 19},
			{m: new Date(2020, 9, 18), cases: 24},
			{m: new Date(2020, 9, 25), cases: 50},
			{m: new Date(2020, 10, 1), cases: 25},
			{m: new Date(2020, 10, 8), cases: 28},
			{m: new Date(2020, 10, 15), cases: 39},
			{m: new Date(2020, 10, 22), cases: 80},
			{m: new Date(2020, 10, 29), cases: 106},
			{m: new Date(2020, 11, 6), cases: 110},
			{m: new Date(2020, 11, 13), cases: 69},
			{m: new Date(2020, 11, 20), cases: 68},
			{m: new Date(2020, 11, 27), cases: 42},
			{m: new Date(2021, 0, 3), cases: 68},
			{m: new Date(2021, 0, 10), cases: 60},
			{m: new Date(2021, 0, 17), cases: 50}
		]
	},
	"97064": {
		"pop":3732,
		"first_date":"9/27",
		"last_date":"1/17",
		"name":"Vernonia",
		"centroid_lat":"46.0701162223736",
		"centroid_lng":"-123.207313723133",
		"cum_cases_start":"12",
		"cum_cases_end":"51",
		"data": [
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97067": {
		"pop":2046,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Welches",
		"centroid_lat":"45.4839936245737",
		"centroid_lng":"-121.935044579638",
		"cum_cases_start":"13",
		"cum_cases_end":"40",
		"data": [
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97068": {
		"pop":30486,
		"first_date":"5/24",
		"last_date":"1/17",
		"name":"West Linn",
		"centroid_lat":"45.5433643876684",
		"centroid_lng":"-122.668326969991",
		"cum_cases_start":"10",
		"cum_cases_end":"580",
		"data": [
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 3},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 17},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 9},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 10},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 26},
			{m: new Date(2020, 10, 15), cases: 45},
			{m: new Date(2020, 10, 22), cases: 47},
			{m: new Date(2020, 10, 29), cases: 52},
			{m: new Date(2020, 11, 6), cases: 35},
			{m: new Date(2020, 11, 13), cases: 42},
			{m: new Date(2020, 11, 20), cases: 51},
			{m: new Date(2020, 11, 27), cases: 32},
			{m: new Date(2021, 0, 3), cases: 35},
			{m: new Date(2021, 0, 10), cases: 43},
			{m: new Date(2021, 0, 17), cases: 26}
		]
	},
	"97070": {
		"pop":25311,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Wilsonville",
		"centroid_lat":"45.5003901614268",
		"centroid_lng":"-122.769380388965",
		"cum_cases_start":"16",
		"cum_cases_end":"813",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 3},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 15},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 14},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 15},
			{m: new Date(2020, 7, 16), cases: 11},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 7},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 12},
			{m: new Date(2020, 10, 1), cases: 16},
			{m: new Date(2020, 10, 8), cases: 30},
			{m: new Date(2020, 10, 15), cases: 37},
			{m: new Date(2020, 10, 22), cases: 42},
			{m: new Date(2020, 10, 29), cases: 49},
			{m: new Date(2020, 11, 6), cases: 52},
			{m: new Date(2020, 11, 13), cases: 67},
			{m: new Date(2020, 11, 20), cases: 68},
			{m: new Date(2020, 11, 27), cases: 39},
			{m: new Date(2021, 0, 3), cases: 70},
			{m: new Date(2021, 0, 10), cases: 80},
			{m: new Date(2021, 0, 17), cases: 65}
		]
	},
	"97071": {
		"pop":31603,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Woodburn",
		"centroid_lat":"45.3308337979637",
		"centroid_lng":"-122.838565854834",
		"cum_cases_start":"193",
		"cum_cases_end":"2687",
		"data": [
			{m: new Date(2020, 4, 16), cases: 19},
			{m: new Date(2020, 4, 24), cases: 9},
			{m: new Date(2020, 4, 31), cases: 10},
			{m: new Date(2020, 5, 7), cases: 7},
			{m: new Date(2020, 5, 14), cases: 19},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 36},
			{m: new Date(2020, 6, 5), cases: 39},
			{m: new Date(2020, 6, 12), cases: 41},
			{m: new Date(2020, 6, 19), cases: 69},
			{m: new Date(2020, 6, 26), cases: 70},
			{m: new Date(2020, 7, 2), cases: 43},
			{m: new Date(2020, 7, 9), cases: 75},
			{m: new Date(2020, 7, 16), cases: 57},
			{m: new Date(2020, 7, 23), cases: 97},
			{m: new Date(2020, 7, 30), cases: 101},
			{m: new Date(2020, 8, 7), cases: 58},
			{m: new Date(2020, 8, 13), cases: 48},
			{m: new Date(2020, 8, 20), cases: 37},
			{m: new Date(2020, 8, 27), cases: 35},
			{m: new Date(2020, 9, 4), cases: 37},
			{m: new Date(2020, 9, 11), cases: 23},
			{m: new Date(2020, 9, 18), cases: 34},
			{m: new Date(2020, 9, 25), cases: 51},
			{m: new Date(2020, 10, 1), cases: 76},
			{m: new Date(2020, 10, 8), cases: 81},
			{m: new Date(2020, 10, 15), cases: 100},
			{m: new Date(2020, 10, 22), cases: 121},
			{m: new Date(2020, 10, 29), cases: 188},
			{m: new Date(2020, 11, 6), cases: 197},
			{m: new Date(2020, 11, 13), cases: 157},
			{m: new Date(2020, 11, 20), cases: 121},
			{m: new Date(2020, 11, 27), cases: 126},
			{m: new Date(2021, 0, 3), cases: 128},
			{m: new Date(2021, 0, 10), cases: 125},
			{m: new Date(2021, 0, 17), cases: 66}
		]
	},
	"97078": {
		"pop":25803,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Beaverton",
		"centroid_lat":"45.6710277649528",
		"centroid_lng":"-122.893547196134",
		"cum_cases_start":"36",
		"cum_cases_end":"912",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 23},
			{m: new Date(2020, 6, 5), cases: 17},
			{m: new Date(2020, 6, 12), cases: 14},
			{m: new Date(2020, 6, 19), cases: 29},
			{m: new Date(2020, 6, 26), cases: 16},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 17},
			{m: new Date(2020, 7, 16), cases: 14},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 16},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 8},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 14},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 20},
			{m: new Date(2020, 9, 18), cases: 14},
			{m: new Date(2020, 9, 25), cases: 13},
			{m: new Date(2020, 10, 1), cases: 13},
			{m: new Date(2020, 10, 8), cases: 53},
			{m: new Date(2020, 10, 15), cases: 62},
			{m: new Date(2020, 10, 22), cases: 49},
			{m: new Date(2020, 10, 29), cases: 75},
			{m: new Date(2020, 11, 6), cases: 65},
			{m: new Date(2020, 11, 13), cases: 59},
			{m: new Date(2020, 11, 20), cases: 51},
			{m: new Date(2020, 11, 27), cases: 35},
			{m: new Date(2021, 0, 3), cases: 30},
			{m: new Date(2021, 0, 10), cases: 63},
			{m: new Date(2021, 0, 17), cases: 35}
		]
	},
	"97080": {
		"pop":46125,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Gresham",
		"centroid_lat":"45.6707773793203",
		"centroid_lng":"-122.387348479951",
		"cum_cases_start":"66",
		"cum_cases_end":"2006",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 12},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 14},
			{m: new Date(2020, 5, 21), cases: 16},
			{m: new Date(2020, 5, 28), cases: 30},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 27},
			{m: new Date(2020, 6, 19), cases: 64},
			{m: new Date(2020, 6, 26), cases: 36},
			{m: new Date(2020, 7, 2), cases: 41},
			{m: new Date(2020, 7, 9), cases: 64},
			{m: new Date(2020, 7, 16), cases: 42},
			{m: new Date(2020, 7, 23), cases: 14},
			{m: new Date(2020, 7, 30), cases: 15},
			{m: new Date(2020, 8, 7), cases: 24},
			{m: new Date(2020, 8, 13), cases: 17},
			{m: new Date(2020, 8, 20), cases: 26},
			{m: new Date(2020, 8, 27), cases: 25},
			{m: new Date(2020, 9, 4), cases: 24},
			{m: new Date(2020, 9, 11), cases: 36},
			{m: new Date(2020, 9, 18), cases: 39},
			{m: new Date(2020, 9, 25), cases: 47},
			{m: new Date(2020, 10, 1), cases: 59},
			{m: new Date(2020, 10, 8), cases: 73},
			{m: new Date(2020, 10, 15), cases: 91},
			{m: new Date(2020, 10, 22), cases: 137},
			{m: new Date(2020, 10, 29), cases: 185},
			{m: new Date(2020, 11, 6), cases: 126},
			{m: new Date(2020, 11, 13), cases: 154},
			{m: new Date(2020, 11, 20), cases: 133},
			{m: new Date(2020, 11, 27), cases: 89},
			{m: new Date(2021, 0, 3), cases: 98},
			{m: new Date(2021, 0, 10), cases: 102},
			{m: new Date(2021, 0, 17), cases: 65}
		]
	},
	"97086": {
		"pop":32685,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Happy Valley",
		"centroid_lat":"45.6373206507001",
		"centroid_lng":"-122.52938807624",
		"cum_cases_start":"29",
		"cum_cases_end":"1103",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 4},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 12},
			{m: new Date(2020, 6, 19), cases: 17},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 18},
			{m: new Date(2020, 7, 9), cases: 19},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 16},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 16},
			{m: new Date(2020, 8, 20), cases: 16},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 13},
			{m: new Date(2020, 9, 11), cases: 19},
			{m: new Date(2020, 9, 18), cases: 23},
			{m: new Date(2020, 9, 25), cases: 19},
			{m: new Date(2020, 10, 1), cases: 50},
			{m: new Date(2020, 10, 8), cases: 69},
			{m: new Date(2020, 10, 15), cases: 54},
			{m: new Date(2020, 10, 22), cases: 67},
			{m: new Date(2020, 10, 29), cases: 121},
			{m: new Date(2020, 11, 6), cases: 87},
			{m: new Date(2020, 11, 13), cases: 65},
			{m: new Date(2020, 11, 20), cases: 65},
			{m: new Date(2020, 11, 27), cases: 63},
			{m: new Date(2021, 0, 3), cases: 70},
			{m: new Date(2021, 0, 10), cases: 53},
			{m: new Date(2021, 0, 17), cases: 39}
		]
	},
	"97089": {
		"pop":13975,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"Damascus",
		"centroid_lat":"45.6177794585898",
		"centroid_lng":"-122.443844418986",
		"cum_cases_start":"16",
		"cum_cases_end":"429",
		"data": [
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 4},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 7},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 11},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 9},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 21},
			{m: new Date(2020, 10, 15), cases: 15},
			{m: new Date(2020, 10, 22), cases: 39},
			{m: new Date(2020, 10, 29), cases: 64},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 28},
			{m: new Date(2020, 11, 20), cases: 27},
			{m: new Date(2020, 11, 27), cases: 13},
			{m: new Date(2021, 0, 3), cases: 16},
			{m: new Date(2021, 0, 10), cases: 30},
			{m: new Date(2021, 0, 17), cases: 13}
		]
	},
	"97101": {
		"pop":4017,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"Amity",
		"centroid_lat":"45.2868216872144",
		"centroid_lng":"-123.216923071976",
		"cum_cases_start":"13",
		"cum_cases_end":"106",
		"data": [
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97103": {
		"pop":18266,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Astoria",
		"centroid_lat":"46.3115134620605",
		"centroid_lng":"-123.66789427329",
		"cum_cases_start":"19",
		"cum_cases_end":"280",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 4},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 16},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 17},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 16},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 22},
			{m: new Date(2021, 0, 3), cases: 34},
			{m: new Date(2021, 0, 10), cases: 27},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97106": {
		"pop":5269,
		"first_date":"9/7",
		"last_date":"1/17",
		"name":"Banks",
		"centroid_lat":"45.8498717588079",
		"centroid_lng":"-123.135567214211",
		"cum_cases_start":"22",
		"cum_cases_end":"89",
		"data": [
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 13},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97107": {
		"pop":1587,
		"first_date":"12/27",
		"last_date":"1/17",
		"name":"Bay City",
		"centroid_lat":"45.753648593941",
		"centroid_lng":"-123.858609170068",
		"cum_cases_start":"12",
		"cum_cases_end":"26",
		"data": [
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97110": {
		"pop":1713,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Cannon Beach",
		"centroid_lat":"46.100831454185",
		"centroid_lng":"-123.95028431241",
		"cum_cases_start":"15",
		"cum_cases_end":"24",
		"data": [
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97111": {
		"pop":3554,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Carlton",
		"centroid_lat":"45.4825555390081",
		"centroid_lng":"-123.196132183823",
		"cum_cases_start":"11",
		"cum_cases_end":"115",
		"data": [
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 6},
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 9},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 21},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 18},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97112": {
		"pop":2263,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Cloverdale",
		"centroid_lat":"45.4522168763347",
		"centroid_lng":"-123.869220940157",
		"cum_cases_start":"16",
		"cum_cases_end":"37",
		"data": [
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97113": {
		"pop":15182,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Cornelius",
		"centroid_lat":"45.7010154230403",
		"centroid_lng":"-123.046856135529",
		"cum_cases_start":"46",
		"cum_cases_end":"1033",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 5},
			{m: new Date(2020, 4, 31), cases: 9},
			{m: new Date(2020, 5, 7), cases: 12},
			{m: new Date(2020, 5, 14), cases: 9},
			{m: new Date(2020, 5, 21), cases: 10},
			{m: new Date(2020, 5, 28), cases: 25},
			{m: new Date(2020, 6, 5), cases: 24},
			{m: new Date(2020, 6, 12), cases: 16},
			{m: new Date(2020, 6, 19), cases: 18},
			{m: new Date(2020, 6, 26), cases: 19},
			{m: new Date(2020, 7, 2), cases: 14},
			{m: new Date(2020, 7, 9), cases: 6},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 14},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 8},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 20},
			{m: new Date(2020, 9, 4), cases: 15},
			{m: new Date(2020, 9, 11), cases: 36},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 24},
			{m: new Date(2020, 10, 1), cases: 31},
			{m: new Date(2020, 10, 8), cases: 40},
			{m: new Date(2020, 10, 15), cases: 46},
			{m: new Date(2020, 10, 22), cases: 45},
			{m: new Date(2020, 10, 29), cases: 103},
			{m: new Date(2020, 11, 6), cases: 76},
			{m: new Date(2020, 11, 13), cases: 51},
			{m: new Date(2020, 11, 20), cases: 61},
			{m: new Date(2020, 11, 27), cases: 54},
			{m: new Date(2021, 0, 3), cases: 23},
			{m: new Date(2021, 0, 10), cases: 68},
			{m: new Date(2021, 0, 17), cases: 62}
		]
	},
	"97114": {
		"pop":5447,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Dayton",
		"centroid_lat":"45.3731383969554",
		"centroid_lng":"-123.074116528323",
		"cum_cases_start":"16",
		"cum_cases_end":"219",
		"data": [
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 21},
			{m: new Date(2020, 10, 15), cases: 19},
			{m: new Date(2020, 10, 22), cases: 28},
			{m: new Date(2020, 10, 29), cases: 15},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 16},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97115": {
		"pop":4642,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Dundee",
		"centroid_lat":"45.4607569373619",
		"centroid_lng":"-123.027953187528",
		"cum_cases_start":"17",
		"cum_cases_end":"101",
		"data": [
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 15},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97116": {
		"pop":28983,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Forest Grove",
		"centroid_lat":"45.7689890385737",
		"centroid_lng":"-123.166172177039",
		"cum_cases_start":"67",
		"cum_cases_end":"1240",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 14},
			{m: new Date(2020, 4, 31), cases: 6},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 7},
			{m: new Date(2020, 5, 21), cases: 8},
			{m: new Date(2020, 5, 28), cases: 13},
			{m: new Date(2020, 6, 5), cases: 20},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 16},
			{m: new Date(2020, 6, 26), cases: 18},
			{m: new Date(2020, 7, 2), cases: 21},
			{m: new Date(2020, 7, 9), cases: 13},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 10},
			{m: new Date(2020, 7, 30), cases: 20},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 25},
			{m: new Date(2020, 9, 4), cases: 18},
			{m: new Date(2020, 9, 11), cases: 21},
			{m: new Date(2020, 9, 18), cases: 25},
			{m: new Date(2020, 9, 25), cases: 35},
			{m: new Date(2020, 10, 1), cases: 42},
			{m: new Date(2020, 10, 8), cases: 46},
			{m: new Date(2020, 10, 15), cases: 45},
			{m: new Date(2020, 10, 22), cases: 52},
			{m: new Date(2020, 10, 29), cases: 119},
			{m: new Date(2020, 11, 6), cases: 134},
			{m: new Date(2020, 11, 13), cases: 86},
			{m: new Date(2020, 11, 20), cases: 100},
			{m: new Date(2020, 11, 27), cases: 56},
			{m: new Date(2021, 0, 3), cases: 54},
			{m: new Date(2021, 0, 10), cases: 71},
			{m: new Date(2021, 0, 17), cases: 40}
		]
	},
	"97119": {
		"pop":4342,
		"first_date":"8/23",
		"last_date":"1/17",
		"name":"Gaston",
		"centroid_lat":"45.6620188331633",
		"centroid_lng":"-123.265343883192",
		"cum_cases_start":"11",
		"cum_cases_end":"115",
		"data": [
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 11},
			{m: new Date(2020, 11, 6), cases: 23},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 9},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97121": {
		"pop":1678,
		"first_date":"10/4",
		"last_date":"1/17",
		"name":"Hammond",
		"centroid_lat":"46.3969974099702",
		"centroid_lng":"-123.976887648565",
		"cum_cases_start":"12",
		"cum_cases_end":"36",
		"data": [
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97123": {
		"pop":49610,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Hillsboro",
		"centroid_lat":"45.6366696918586",
		"centroid_lng":"-122.980786423562",
		"cum_cases_start":"95",
		"cum_cases_end":"2251",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 7},
			{m: new Date(2020, 4, 31), cases: 11},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 19},
			{m: new Date(2020, 5, 21), cases: 38},
			{m: new Date(2020, 5, 28), cases: 29},
			{m: new Date(2020, 6, 5), cases: 53},
			{m: new Date(2020, 6, 12), cases: 39},
			{m: new Date(2020, 6, 19), cases: 37},
			{m: new Date(2020, 6, 26), cases: 28},
			{m: new Date(2020, 7, 2), cases: 21},
			{m: new Date(2020, 7, 9), cases: 43},
			{m: new Date(2020, 7, 16), cases: 10},
			{m: new Date(2020, 7, 23), cases: 37},
			{m: new Date(2020, 7, 30), cases: 33},
			{m: new Date(2020, 8, 7), cases: 33},
			{m: new Date(2020, 8, 13), cases: 25},
			{m: new Date(2020, 8, 20), cases: 24},
			{m: new Date(2020, 8, 27), cases: 31},
			{m: new Date(2020, 9, 4), cases: 24},
			{m: new Date(2020, 9, 11), cases: 35},
			{m: new Date(2020, 9, 18), cases: 39},
			{m: new Date(2020, 9, 25), cases: 41},
			{m: new Date(2020, 10, 1), cases: 65},
			{m: new Date(2020, 10, 8), cases: 86},
			{m: new Date(2020, 10, 15), cases: 116},
			{m: new Date(2020, 10, 22), cases: 118},
			{m: new Date(2020, 10, 29), cases: 242},
			{m: new Date(2020, 11, 6), cases: 200},
			{m: new Date(2020, 11, 13), cases: 159},
			{m: new Date(2020, 11, 20), cases: 94},
			{m: new Date(2020, 11, 27), cases: 63},
			{m: new Date(2021, 0, 3), cases: 135},
			{m: new Date(2021, 0, 10), cases: 133},
			{m: new Date(2021, 0, 17), cases: 84}
		]
	},
	"97124": {
		"pop":54765,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Hillsboro",
		"centroid_lat":"45.7613946060237",
		"centroid_lng":"-122.947782741751",
		"cum_cases_start":"46",
		"cum_cases_end":"1553",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 7},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 12},
			{m: new Date(2020, 5, 21), cases: 23},
			{m: new Date(2020, 5, 28), cases: 12},
			{m: new Date(2020, 6, 5), cases: 26},
			{m: new Date(2020, 6, 12), cases: 24},
			{m: new Date(2020, 6, 19), cases: 35},
			{m: new Date(2020, 6, 26), cases: 34},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 26},
			{m: new Date(2020, 7, 16), cases: 10},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 17},
			{m: new Date(2020, 8, 7), cases: 19},
			{m: new Date(2020, 8, 13), cases: 11},
			{m: new Date(2020, 8, 20), cases: 15},
			{m: new Date(2020, 8, 27), cases: 22},
			{m: new Date(2020, 9, 4), cases: 25},
			{m: new Date(2020, 9, 11), cases: 16},
			{m: new Date(2020, 9, 18), cases: 27},
			{m: new Date(2020, 9, 25), cases: 32},
			{m: new Date(2020, 10, 1), cases: 40},
			{m: new Date(2020, 10, 8), cases: 48},
			{m: new Date(2020, 10, 15), cases: 79},
			{m: new Date(2020, 10, 22), cases: 94},
			{m: new Date(2020, 10, 29), cases: 157},
			{m: new Date(2020, 11, 6), cases: 143},
			{m: new Date(2020, 11, 13), cases: 109},
			{m: new Date(2020, 11, 20), cases: 93},
			{m: new Date(2020, 11, 27), cases: 87},
			{m: new Date(2021, 0, 3), cases: 94},
			{m: new Date(2021, 0, 10), cases: 86},
			{m: new Date(2021, 0, 17), cases: 53}
		]
	},
	"97127": {
		"pop":4486,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Lafayette",
		"centroid_lat":"45.4390752071102",
		"centroid_lng":"-123.11121664057",
		"cum_cases_start":"14",
		"cum_cases_end":"136",
		"data": [
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 11},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97128": {
		"pop":39572,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Mcminnville",
		"centroid_lat":"45.3924641105146",
		"centroid_lng":"-123.26871706367",
		"cum_cases_start":"16",
		"cum_cases_end":"1440",
		"data": [
			{m: new Date(2020, 4, 16), cases: 4},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 14},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 8},
			{m: new Date(2020, 6, 12), cases: 19},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 73},
			{m: new Date(2020, 7, 9), cases: 61},
			{m: new Date(2020, 7, 16), cases: 27},
			{m: new Date(2020, 7, 23), cases: 49},
			{m: new Date(2020, 7, 30), cases: 21},
			{m: new Date(2020, 8, 7), cases: 22},
			{m: new Date(2020, 8, 13), cases: 28},
			{m: new Date(2020, 8, 20), cases: 13},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 30},
			{m: new Date(2020, 9, 11), cases: 39},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 28},
			{m: new Date(2020, 10, 1), cases: 14},
			{m: new Date(2020, 10, 8), cases: 60},
			{m: new Date(2020, 10, 15), cases: 79},
			{m: new Date(2020, 10, 22), cases: 80},
			{m: new Date(2020, 10, 29), cases: 84},
			{m: new Date(2020, 11, 6), cases: 98},
			{m: new Date(2020, 11, 13), cases: 105},
			{m: new Date(2020, 11, 20), cases: 66},
			{m: new Date(2020, 11, 27), cases: 51},
			{m: new Date(2021, 0, 3), cases: 79},
			{m: new Date(2021, 0, 10), cases: 108},
			{m: new Date(2021, 0, 17), cases: 95}
		]
	},
	"97131": {
		"pop":2830,
		"first_date":"12/20",
		"last_date":"1/17",
		"name":"Nehalem",
		"centroid_lat":"45.9006381390188",
		"centroid_lng":"-123.683285623732",
		"cum_cases_start":"11",
		"cum_cases_end":"13",
		"data": [
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97132": {
		"pop":31379,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Newberg",
		"centroid_lat":"45.5144244793673",
		"centroid_lng":"-122.988199657834",
		"cum_cases_start":"28",
		"cum_cases_end":"776",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 4},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 30},
			{m: new Date(2020, 6, 19), cases: 15},
			{m: new Date(2020, 6, 26), cases: 8},
			{m: new Date(2020, 7, 2), cases: 13},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 9},
			{m: new Date(2020, 7, 23), cases: 15},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 20},
			{m: new Date(2020, 9, 18), cases: 24},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 11},
			{m: new Date(2020, 10, 8), cases: 31},
			{m: new Date(2020, 10, 15), cases: 47},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 79},
			{m: new Date(2020, 11, 6), cases: 75},
			{m: new Date(2020, 11, 13), cases: 46},
			{m: new Date(2020, 11, 20), cases: 50},
			{m: new Date(2020, 11, 27), cases: 30},
			{m: new Date(2021, 0, 3), cases: 45},
			{m: new Date(2021, 0, 10), cases: 51},
			{m: new Date(2021, 0, 17), cases: 22}
		]
	},
	"97133": {
		"pop":5387,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"North Plains",
		"centroid_lat":"45.8734803195574",
		"centroid_lng":"-123.015661500541",
		"cum_cases_start":"13",
		"cum_cases_end":"105",
		"data": [
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 8},
			{m: new Date(2020, 10, 15), cases: 10},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 8},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97136": {
		"pop":1895,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Rockaway Beach",
		"centroid_lat":"45.8207336294663",
		"centroid_lng":"-123.909151082259",
		"cum_cases_start":"10",
		"cum_cases_end":"15",
		"data": [
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97137": {
		"pop":1250,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Saint Paul",
		"centroid_lat":"45.4152958125609",
		"centroid_lng":"-122.957622727402",
		"cum_cases_start":"15",
		"cum_cases_end":"50",
		"data": [
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97138": {
		"pop":11004,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Seaside",
		"centroid_lat":"46.0965458614935",
		"centroid_lng":"-123.65613009693",
		"cum_cases_start":"12",
		"cum_cases_end":"184",
		"data": [
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 18},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 12},
			{m: new Date(2020, 10, 29), cases: 19},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 13},
			{m: new Date(2020, 11, 27), cases: 13},
			{m: new Date(2021, 0, 3), cases: 16},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 14}
		]
	},
	"97140": {
		"pop":28791,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Sherwood",
		"centroid_lat":"45.5456219238687",
		"centroid_lng":"-122.864453944927",
		"cum_cases_start":"16",
		"cum_cases_end":"606",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 2},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 10},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 19},
			{m: new Date(2020, 10, 15), cases: 29},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 77},
			{m: new Date(2020, 11, 6), cases: 50},
			{m: new Date(2020, 11, 13), cases: 46},
			{m: new Date(2020, 11, 20), cases: 46},
			{m: new Date(2020, 11, 27), cases: 43},
			{m: new Date(2021, 0, 3), cases: 34},
			{m: new Date(2021, 0, 10), cases: 40},
			{m: new Date(2021, 0, 17), cases: 25}
		]
	},
	"97141": {
		"pop":13872,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Tillamook",
		"centroid_lat":"45.6784648795327",
		"centroid_lng":"-123.669791449451",
		"cum_cases_start":"13",
		"cum_cases_end":"199",
		"data": [
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 4},
			{m: new Date(2020, 10, 29), cases: 23},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 24},
			{m: new Date(2020, 11, 20), cases: 40},
			{m: new Date(2020, 11, 27), cases: 17},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97146": {
		"pop":6424,
		"first_date":"5/31",
		"last_date":"1/17",
		"name":"Warrenton",
		"centroid_lat":"46.3217682124117",
		"centroid_lng":"-123.920977416012",
		"cum_cases_start":"13",
		"cum_cases_end":"146",
		"data": [
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 50},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97148": {
		"pop":3676,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Yamhill",
		"centroid_lat":"45.5574882126171",
		"centroid_lng":"-123.314957421105",
		"cum_cases_start":"12",
		"cum_cases_end":"75",
		"data": [
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97201": {
		"pop":17534,
		"first_date":"5/31",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7006801712234",
		"centroid_lng":"-122.691283759126",
		"cum_cases_start":"13",
		"cum_cases_end":"322",
		"data": [
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 10},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 11},
			{m: new Date(2020, 9, 18), cases: 10},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 13},
			{m: new Date(2020, 10, 22), cases: 26},
			{m: new Date(2020, 10, 29), cases: 24},
			{m: new Date(2020, 11, 6), cases: 23},
			{m: new Date(2020, 11, 13), cases: 28},
			{m: new Date(2020, 11, 20), cases: 13},
			{m: new Date(2020, 11, 27), cases: 14},
			{m: new Date(2021, 0, 3), cases: 19},
			{m: new Date(2021, 0, 10), cases: 31},
			{m: new Date(2021, 0, 17), cases: 9}
		]
	},
	"97202": {
		"pop":43023,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6744843267423",
		"centroid_lng":"-122.641354720766",
		"cum_cases_start":"20",
		"cum_cases_end":"669",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 11},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 15},
			{m: new Date(2020, 7, 16), cases: 20},
			{m: new Date(2020, 7, 23), cases: 17},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 7},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 14},
			{m: new Date(2020, 10, 1), cases: 27},
			{m: new Date(2020, 10, 8), cases: 24},
			{m: new Date(2020, 10, 15), cases: 33},
			{m: new Date(2020, 10, 22), cases: 51},
			{m: new Date(2020, 10, 29), cases: 81},
			{m: new Date(2020, 11, 6), cases: 44},
			{m: new Date(2020, 11, 13), cases: 48},
			{m: new Date(2020, 11, 20), cases: 24},
			{m: new Date(2020, 11, 27), cases: 24},
			{m: new Date(2021, 0, 3), cases: 36},
			{m: new Date(2021, 0, 10), cases: 45},
			{m: new Date(2021, 0, 17), cases: 31}
		]
	},
	"97203": {
		"pop":35659,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7995993012208",
		"centroid_lng":"-122.748569617324",
		"cum_cases_start":"39",
		"cum_cases_end":"1177",
		"data": [
			{m: new Date(2020, 4, 16), cases: 12},
			{m: new Date(2020, 4, 24), cases: 6},
			{m: new Date(2020, 4, 31), cases: 10},
			{m: new Date(2020, 5, 7), cases: 6},
			{m: new Date(2020, 5, 14), cases: 9},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 15},
			{m: new Date(2020, 6, 5), cases: 20},
			{m: new Date(2020, 6, 12), cases: 34},
			{m: new Date(2020, 6, 19), cases: 34},
			{m: new Date(2020, 6, 26), cases: 35},
			{m: new Date(2020, 7, 2), cases: 16},
			{m: new Date(2020, 7, 9), cases: 16},
			{m: new Date(2020, 7, 16), cases: 20},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 14},
			{m: new Date(2020, 8, 7), cases: 10},
			{m: new Date(2020, 8, 13), cases: 11},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 27},
			{m: new Date(2020, 9, 18), cases: 19},
			{m: new Date(2020, 9, 25), cases: 18},
			{m: new Date(2020, 10, 1), cases: 44},
			{m: new Date(2020, 10, 8), cases: 55},
			{m: new Date(2020, 10, 15), cases: 66},
			{m: new Date(2020, 10, 22), cases: 90},
			{m: new Date(2020, 10, 29), cases: 96},
			{m: new Date(2020, 11, 6), cases: 73},
			{m: new Date(2020, 11, 13), cases: 73},
			{m: new Date(2020, 11, 20), cases: 81},
			{m: new Date(2020, 11, 27), cases: 53},
			{m: new Date(2021, 0, 3), cases: 63},
			{m: new Date(2021, 0, 10), cases: 40},
			{m: new Date(2021, 0, 17), cases: 38}
		]
	},
	"97204": {
		"pop":1147,
		"first_date":"10/25",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7102258889826",
		"centroid_lng":"-122.674812647316",
		"cum_cases_start":"11",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97205": {
		"pop":8554,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7109549459331",
		"centroid_lng":"-122.700020782866",
		"cum_cases_start":"13",
		"cum_cases_end":"124",
		"data": [
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 8},
			{m: new Date(2020, 10, 29), cases: 8},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 17},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97206": {
		"pop":51323,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6737087603106",
		"centroid_lng":"-122.598743132065",
		"cum_cases_start":"35",
		"cum_cases_end":"1294",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 8},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 17},
			{m: new Date(2020, 5, 21), cases: 13},
			{m: new Date(2020, 5, 28), cases: 14},
			{m: new Date(2020, 6, 5), cases: 20},
			{m: new Date(2020, 6, 12), cases: 25},
			{m: new Date(2020, 6, 19), cases: 27},
			{m: new Date(2020, 6, 26), cases: 16},
			{m: new Date(2020, 7, 2), cases: 31},
			{m: new Date(2020, 7, 9), cases: 10},
			{m: new Date(2020, 7, 16), cases: 19},
			{m: new Date(2020, 7, 23), cases: 18},
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 11},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 13},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 23},
			{m: new Date(2020, 9, 18), cases: 19},
			{m: new Date(2020, 9, 25), cases: 28},
			{m: new Date(2020, 10, 1), cases: 49},
			{m: new Date(2020, 10, 8), cases: 79},
			{m: new Date(2020, 10, 15), cases: 95},
			{m: new Date(2020, 10, 22), cases: 91},
			{m: new Date(2020, 10, 29), cases: 133},
			{m: new Date(2020, 11, 6), cases: 101},
			{m: new Date(2020, 11, 13), cases: 82},
			{m: new Date(2020, 11, 20), cases: 64},
			{m: new Date(2020, 11, 27), cases: 42},
			{m: new Date(2021, 0, 3), cases: 66},
			{m: new Date(2021, 0, 10), cases: 71},
			{m: new Date(2021, 0, 17), cases: 42}
		]
	},
	"97209": {
		"pop":20613,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7223840808843",
		"centroid_lng":"-122.685101655844",
		"cum_cases_start":"14",
		"cum_cases_end":"799",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 6},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 12},
			{m: new Date(2020, 6, 19), cases: 22},
			{m: new Date(2020, 6, 26), cases: 16},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 8},
			{m: new Date(2020, 9, 18), cases: 14},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 32},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 34},
			{m: new Date(2020, 10, 22), cases: 109},
			{m: new Date(2020, 10, 29), cases: 153},
			{m: new Date(2020, 11, 6), cases: 64},
			{m: new Date(2020, 11, 13), cases: 95},
			{m: new Date(2020, 11, 20), cases: 36},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 15},
			{m: new Date(2021, 0, 10), cases: 36},
			{m: new Date(2021, 0, 17), cases: 30}
		]
	},
	"97210": {
		"pop":12559,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7409915432496",
		"centroid_lng":"-122.736549211999",
		"cum_cases_start":"18",
		"cum_cases_end":"187",
		"data": [
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 14},
			{m: new Date(2020, 10, 29), cases: 10},
			{m: new Date(2020, 11, 6), cases: 18},
			{m: new Date(2020, 11, 13), cases: 17},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 10},
			{m: new Date(2021, 0, 3), cases: 9},
			{m: new Date(2021, 0, 10), cases: 14},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97211": {
		"pop":34085,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7680279291609",
		"centroid_lng":"-122.645508152832",
		"cum_cases_start":"21",
		"cum_cases_end":"884",
		"data": [
			{m: new Date(2020, 4, 16), cases: 4},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 8},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 15},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 15},
			{m: new Date(2020, 6, 12), cases: 10},
			{m: new Date(2020, 6, 19), cases: 20},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 16},
			{m: new Date(2020, 7, 23), cases: 13},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 7},
			{m: new Date(2020, 9, 11), cases: 14},
			{m: new Date(2020, 9, 18), cases: 25},
			{m: new Date(2020, 9, 25), cases: 9},
			{m: new Date(2020, 10, 1), cases: 22},
			{m: new Date(2020, 10, 8), cases: 41},
			{m: new Date(2020, 10, 15), cases: 33},
			{m: new Date(2020, 10, 22), cases: 51},
			{m: new Date(2020, 10, 29), cases: 91},
			{m: new Date(2020, 11, 6), cases: 51},
			{m: new Date(2020, 11, 13), cases: 53},
			{m: new Date(2020, 11, 20), cases: 92},
			{m: new Date(2020, 11, 27), cases: 59},
			{m: new Date(2021, 0, 3), cases: 46},
			{m: new Date(2021, 0, 10), cases: 60},
			{m: new Date(2021, 0, 17), cases: 41}
		]
	},
	"97212": {
		"pop":26886,
		"first_date":"6/7",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7361985299799",
		"centroid_lng":"-122.643395669679",
		"cum_cases_start":"15",
		"cum_cases_end":"405",
		"data": [
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 6},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 5},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 22},
			{m: new Date(2020, 10, 22), cases: 32},
			{m: new Date(2020, 10, 29), cases: 37},
			{m: new Date(2020, 11, 6), cases: 18},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 33},
			{m: new Date(2020, 11, 27), cases: 22},
			{m: new Date(2021, 0, 3), cases: 37},
			{m: new Date(2021, 0, 10), cases: 20},
			{m: new Date(2021, 0, 17), cases: 23}
		]
	},
	"97213": {
		"pop":31570,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7298697582919",
		"centroid_lng":"-122.599794993347",
		"cum_cases_start":"34",
		"cum_cases_end":"663",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 5},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 16},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 14},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 16},
			{m: new Date(2020, 9, 18), cases: 12},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 34},
			{m: new Date(2020, 10, 15), cases: 24},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 82},
			{m: new Date(2020, 11, 6), cases: 40},
			{m: new Date(2020, 11, 13), cases: 35},
			{m: new Date(2020, 11, 20), cases: 54},
			{m: new Date(2020, 11, 27), cases: 47},
			{m: new Date(2021, 0, 3), cases: 20},
			{m: new Date(2021, 0, 10), cases: 44},
			{m: new Date(2021, 0, 17), cases: 18}
		]
	},
	"97214": {
		"pop":28573,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7063909528562",
		"centroid_lng":"-122.643246446049",
		"cum_cases_start":"41",
		"cum_cases_end":"461",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 11},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 20},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 3},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 10},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 11},
			{m: new Date(2020, 10, 8), cases: 12},
			{m: new Date(2020, 10, 15), cases: 24},
			{m: new Date(2020, 10, 22), cases: 29},
			{m: new Date(2020, 10, 29), cases: 35},
			{m: new Date(2020, 11, 6), cases: 30},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 22},
			{m: new Date(2020, 11, 27), cases: 16},
			{m: new Date(2021, 0, 3), cases: 33},
			{m: new Date(2021, 0, 10), cases: 29},
			{m: new Date(2021, 0, 17), cases: 24}
		]
	},
	"97215": {
		"pop":18096,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7066215168746",
		"centroid_lng":"-122.599655353153",
		"cum_cases_start":"13",
		"cum_cases_end":"356",
		"data": [
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 7},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 20},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 17},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 10},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 18},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 33},
			{m: new Date(2020, 10, 29), cases: 37},
			{m: new Date(2020, 11, 6), cases: 27},
			{m: new Date(2020, 11, 13), cases: 18},
			{m: new Date(2020, 11, 20), cases: 25},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 15},
			{m: new Date(2021, 0, 10), cases: 20},
			{m: new Date(2021, 0, 17), cases: 6}
		]
	},
	"97216": {
		"pop":17405,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7057419882558",
		"centroid_lng":"-122.558858254132",
		"cum_cases_start":"11",
		"cum_cases_end":"750",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 4},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 8},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 4},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 10},
			{m: new Date(2020, 6, 26), cases: 15},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 12},
			{m: new Date(2020, 7, 16), cases: 17},
			{m: new Date(2020, 7, 23), cases: 14},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 8},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 7},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 18},
			{m: new Date(2020, 9, 25), cases: 15},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 35},
			{m: new Date(2020, 10, 15), cases: 48},
			{m: new Date(2020, 10, 22), cases: 57},
			{m: new Date(2020, 10, 29), cases: 77},
			{m: new Date(2020, 11, 6), cases: 46},
			{m: new Date(2020, 11, 13), cases: 45},
			{m: new Date(2020, 11, 20), cases: 55},
			{m: new Date(2020, 11, 27), cases: 31},
			{m: new Date(2021, 0, 3), cases: 40},
			{m: new Date(2021, 0, 10), cases: 46},
			{m: new Date(2021, 0, 17), cases: 30}
		]
	},
	"97217": {
		"pop":36211,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7816601586408",
		"centroid_lng":"-122.69328958014",
		"cum_cases_start":"26",
		"cum_cases_end":"890",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 6},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 11},
			{m: new Date(2020, 5, 21), cases: 5},
			{m: new Date(2020, 5, 28), cases: 13},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 9},
			{m: new Date(2020, 6, 19), cases: 23},
			{m: new Date(2020, 6, 26), cases: 13},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 9},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 11},
			{m: new Date(2020, 8, 7), cases: 12},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 11},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 20},
			{m: new Date(2020, 10, 1), cases: 24},
			{m: new Date(2020, 10, 8), cases: 34},
			{m: new Date(2020, 10, 15), cases: 57},
			{m: new Date(2020, 10, 22), cases: 71},
			{m: new Date(2020, 10, 29), cases: 82},
			{m: new Date(2020, 11, 6), cases: 59},
			{m: new Date(2020, 11, 13), cases: 62},
			{m: new Date(2020, 11, 20), cases: 62},
			{m: new Date(2020, 11, 27), cases: 35},
			{m: new Date(2021, 0, 3), cases: 60},
			{m: new Date(2021, 0, 10), cases: 59},
			{m: new Date(2021, 0, 17), cases: 33}
		]
	},
	"97218": {
		"pop":15828,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7692313924468",
		"centroid_lng":"-122.573312994843",
		"cum_cases_start":"13",
		"cum_cases_end":"777",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 15},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 20},
			{m: new Date(2020, 7, 9), cases: 23},
			{m: new Date(2020, 7, 16), cases: 34},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 11},
			{m: new Date(2020, 8, 7), cases: 12},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 22},
			{m: new Date(2020, 9, 25), cases: 18},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 70},
			{m: new Date(2020, 10, 15), cases: 59},
			{m: new Date(2020, 10, 22), cases: 76},
			{m: new Date(2020, 10, 29), cases: 71},
			{m: new Date(2020, 11, 6), cases: 46},
			{m: new Date(2020, 11, 13), cases: 47},
			{m: new Date(2020, 11, 20), cases: 37},
			{m: new Date(2020, 11, 27), cases: 33},
			{m: new Date(2021, 0, 3), cases: 32},
			{m: new Date(2021, 0, 10), cases: 31},
			{m: new Date(2021, 0, 17), cases: 21}
		]
	},
	"97219": {
		"pop":41628,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6462026320628",
		"centroid_lng":"-122.700459603291",
		"cum_cases_start":"28",
		"cum_cases_end":"747",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 9},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 25},
			{m: new Date(2020, 6, 5), cases: 10},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 12},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 14},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 12},
			{m: new Date(2020, 9, 18), cases: 23},
			{m: new Date(2020, 9, 25), cases: 18},
			{m: new Date(2020, 10, 1), cases: 23},
			{m: new Date(2020, 10, 8), cases: 30},
			{m: new Date(2020, 10, 15), cases: 41},
			{m: new Date(2020, 10, 22), cases: 57},
			{m: new Date(2020, 10, 29), cases: 72},
			{m: new Date(2020, 11, 6), cases: 38},
			{m: new Date(2020, 11, 13), cases: 45},
			{m: new Date(2020, 11, 20), cases: 40},
			{m: new Date(2020, 11, 27), cases: 43},
			{m: new Date(2021, 0, 3), cases: 43},
			{m: new Date(2021, 0, 10), cases: 42},
			{m: new Date(2021, 0, 17), cases: 35}
		]
	},
	"97220": {
		"pop":33340,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7425536554364",
		"centroid_lng":"-122.558968366273",
		"cum_cases_start":"44",
		"cum_cases_end":"1265",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 6},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 8},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 21},
			{m: new Date(2020, 6, 12), cases: 20},
			{m: new Date(2020, 6, 19), cases: 19},
			{m: new Date(2020, 6, 26), cases: 19},
			{m: new Date(2020, 7, 2), cases: 15},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 17},
			{m: new Date(2020, 7, 23), cases: 21},
			{m: new Date(2020, 7, 30), cases: 26},
			{m: new Date(2020, 8, 7), cases: 25},
			{m: new Date(2020, 8, 13), cases: 15},
			{m: new Date(2020, 8, 20), cases: 13},
			{m: new Date(2020, 8, 27), cases: 27},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 32},
			{m: new Date(2020, 9, 18), cases: 27},
			{m: new Date(2020, 9, 25), cases: 40},
			{m: new Date(2020, 10, 1), cases: 24},
			{m: new Date(2020, 10, 8), cases: 48},
			{m: new Date(2020, 10, 15), cases: 74},
			{m: new Date(2020, 10, 22), cases: 91},
			{m: new Date(2020, 10, 29), cases: 146},
			{m: new Date(2020, 11, 6), cases: 98},
			{m: new Date(2020, 11, 13), cases: 85},
			{m: new Date(2020, 11, 20), cases: 79},
			{m: new Date(2020, 11, 27), cases: 52},
			{m: new Date(2021, 0, 3), cases: 43},
			{m: new Date(2021, 0, 10), cases: 51},
			{m: new Date(2021, 0, 17), cases: 38}
		]
	},
	"97221": {
		"pop":12641,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6896590822273",
		"centroid_lng":"-122.728163858375",
		"cum_cases_start":"11",
		"cum_cases_end":"196",
		"data": [
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 7},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 6},
			{m: new Date(2020, 10, 15), cases: 13},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 15},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 15},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 11}
		]
	},
	"97222": {
		"pop":37253,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6332184607438",
		"centroid_lng":"-122.616466334714",
		"cum_cases_start":"34",
		"cum_cases_end":"965",
		"data": [
			{m: new Date(2020, 4, 16), cases: 8},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 4},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 15},
			{m: new Date(2020, 5, 21), cases: 9},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 18},
			{m: new Date(2020, 6, 19), cases: 15},
			{m: new Date(2020, 6, 26), cases: 18},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 8},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 9},
			{m: new Date(2020, 8, 20), cases: 11},
			{m: new Date(2020, 8, 27), cases: 15},
			{m: new Date(2020, 9, 4), cases: 11},
			{m: new Date(2020, 9, 11), cases: 18},
			{m: new Date(2020, 9, 18), cases: 15},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 34},
			{m: new Date(2020, 10, 8), cases: 46},
			{m: new Date(2020, 10, 15), cases: 54},
			{m: new Date(2020, 10, 22), cases: 73},
			{m: new Date(2020, 10, 29), cases: 93},
			{m: new Date(2020, 11, 6), cases: 88},
			{m: new Date(2020, 11, 13), cases: 64},
			{m: new Date(2020, 11, 20), cases: 47},
			{m: new Date(2020, 11, 27), cases: 31},
			{m: new Date(2021, 0, 3), cases: 47},
			{m: new Date(2021, 0, 10), cases: 67},
			{m: new Date(2021, 0, 17), cases: 36}
		]
	},
	"97223": {
		"pop":51228,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6329577856154",
		"centroid_lng":"-122.777873645343",
		"cum_cases_start":"47",
		"cum_cases_end":"1337",
		"data": [
			{m: new Date(2020, 4, 16), cases: 5},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 12},
			{m: new Date(2020, 5, 14), cases: 2},
			{m: new Date(2020, 5, 21), cases: 12},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 19},
			{m: new Date(2020, 6, 12), cases: 22},
			{m: new Date(2020, 6, 19), cases: 18},
			{m: new Date(2020, 6, 26), cases: 27},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 14},
			{m: new Date(2020, 7, 16), cases: 9},
			{m: new Date(2020, 7, 23), cases: 16},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 18},
			{m: new Date(2020, 8, 27), cases: 15},
			{m: new Date(2020, 9, 4), cases: 13},
			{m: new Date(2020, 9, 11), cases: 14},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 21},
			{m: new Date(2020, 10, 1), cases: 37},
			{m: new Date(2020, 10, 8), cases: 64},
			{m: new Date(2020, 10, 15), cases: 74},
			{m: new Date(2020, 10, 22), cases: 103},
			{m: new Date(2020, 10, 29), cases: 156},
			{m: new Date(2020, 11, 6), cases: 115},
			{m: new Date(2020, 11, 13), cases: 86},
			{m: new Date(2020, 11, 20), cases: 87},
			{m: new Date(2020, 11, 27), cases: 58},
			{m: new Date(2021, 0, 3), cases: 64},
			{m: new Date(2021, 0, 10), cases: 86},
			{m: new Date(2021, 0, 17), cases: 61}
		]
	},
	"97224": {
		"pop":37413,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.5983170850637",
		"centroid_lng":"-122.792832609935",
		"cum_cases_start":"25",
		"cum_cases_end":"833",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 8},
			{m: new Date(2020, 5, 28), cases: 15},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 11},
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 19},
			{m: new Date(2020, 7, 2), cases: 16},
			{m: new Date(2020, 7, 9), cases: 12},
			{m: new Date(2020, 7, 16), cases: 9},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 10},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 15},
			{m: new Date(2020, 9, 18), cases: 14},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 28},
			{m: new Date(2020, 10, 8), cases: 33},
			{m: new Date(2020, 10, 15), cases: 46},
			{m: new Date(2020, 10, 22), cases: 54},
			{m: new Date(2020, 10, 29), cases: 82},
			{m: new Date(2020, 11, 6), cases: 49},
			{m: new Date(2020, 11, 13), cases: 34},
			{m: new Date(2020, 11, 20), cases: 65},
			{m: new Date(2020, 11, 27), cases: 37},
			{m: new Date(2021, 0, 3), cases: 63},
			{m: new Date(2021, 0, 10), cases: 64},
			{m: new Date(2021, 0, 17), cases: 39}
		]
	},
	"97225": {
		"pop":26086,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6943113336654",
		"centroid_lng":"-122.770065473877",
		"cum_cases_start":"22",
		"cum_cases_end":"515",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 2},
			{m: new Date(2020, 5, 21), cases: 3},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 11},
			{m: new Date(2020, 6, 12), cases: 10},
			{m: new Date(2020, 6, 19), cases: 18},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 9},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 7},
			{m: new Date(2020, 8, 20), cases: 12},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 9},
			{m: new Date(2020, 9, 25), cases: 12},
			{m: new Date(2020, 10, 1), cases: 10},
			{m: new Date(2020, 10, 8), cases: 25},
			{m: new Date(2020, 10, 15), cases: 9},
			{m: new Date(2020, 10, 22), cases: 31},
			{m: new Date(2020, 10, 29), cases: 44},
			{m: new Date(2020, 11, 6), cases: 30},
			{m: new Date(2020, 11, 13), cases: 35},
			{m: new Date(2020, 11, 20), cases: 35},
			{m: new Date(2020, 11, 27), cases: 38},
			{m: new Date(2021, 0, 3), cases: 30},
			{m: new Date(2021, 0, 10), cases: 34},
			{m: new Date(2021, 0, 17), cases: 17}
		]
	},
	"97227": {
		"pop":5473,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7366257687266",
		"centroid_lng":"-122.677024831594",
		"cum_cases_start":"15",
		"cum_cases_end":"135",
		"data": [
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 9},
			{m: new Date(2020, 10, 22), cases: 17},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 10},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97229": {
		"pop":70680,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7422125748428",
		"centroid_lng":"-122.812038337833",
		"cum_cases_start":"31",
		"cum_cases_end":"1117",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 4},
			{m: new Date(2020, 5, 21), cases: 11},
			{m: new Date(2020, 5, 28), cases: 11},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 22},
			{m: new Date(2020, 6, 19), cases: 23},
			{m: new Date(2020, 6, 26), cases: 9},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 18},
			{m: new Date(2020, 7, 16), cases: 10},
			{m: new Date(2020, 7, 23), cases: 17},
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 17},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 16},
			{m: new Date(2020, 9, 18), cases: 19},
			{m: new Date(2020, 9, 25), cases: 20},
			{m: new Date(2020, 10, 1), cases: 29},
			{m: new Date(2020, 10, 8), cases: 41},
			{m: new Date(2020, 10, 15), cases: 62},
			{m: new Date(2020, 10, 22), cases: 60},
			{m: new Date(2020, 10, 29), cases: 131},
			{m: new Date(2020, 11, 6), cases: 84},
			{m: new Date(2020, 11, 13), cases: 67},
			{m: new Date(2020, 11, 20), cases: 52},
			{m: new Date(2020, 11, 27), cases: 67},
			{m: new Date(2021, 0, 3), cases: 67},
			{m: new Date(2021, 0, 10), cases: 82},
			{m: new Date(2021, 0, 17), cases: 65}
		]
	},
	"97230": {
		"pop":42349,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7343776215205",
		"centroid_lng":"-122.499192688629",
		"cum_cases_start":"73",
		"cum_cases_end":"2191",
		"data": [
			{m: new Date(2020, 4, 16), cases: 15},
			{m: new Date(2020, 4, 24), cases: 5},
			{m: new Date(2020, 4, 31), cases: 6},
			{m: new Date(2020, 5, 7), cases: 9},
			{m: new Date(2020, 5, 14), cases: 12},
			{m: new Date(2020, 5, 21), cases: 23},
			{m: new Date(2020, 5, 28), cases: 26},
			{m: new Date(2020, 6, 5), cases: 28},
			{m: new Date(2020, 6, 12), cases: 31},
			{m: new Date(2020, 6, 19), cases: 41},
			{m: new Date(2020, 6, 26), cases: 48},
			{m: new Date(2020, 7, 2), cases: 37},
			{m: new Date(2020, 7, 9), cases: 29},
			{m: new Date(2020, 7, 16), cases: 24},
			{m: new Date(2020, 7, 23), cases: 22},
			{m: new Date(2020, 7, 30), cases: 28},
			{m: new Date(2020, 8, 7), cases: 22},
			{m: new Date(2020, 8, 13), cases: 28},
			{m: new Date(2020, 8, 20), cases: 20},
			{m: new Date(2020, 8, 27), cases: 22},
			{m: new Date(2020, 9, 4), cases: 27},
			{m: new Date(2020, 9, 11), cases: 30},
			{m: new Date(2020, 9, 18), cases: 37},
			{m: new Date(2020, 9, 25), cases: 51},
			{m: new Date(2020, 10, 1), cases: 102},
			{m: new Date(2020, 10, 8), cases: 132},
			{m: new Date(2020, 10, 15), cases: 100},
			{m: new Date(2020, 10, 22), cases: 179},
			{m: new Date(2020, 10, 29), cases: 201},
			{m: new Date(2020, 11, 6), cases: 151},
			{m: new Date(2020, 11, 13), cases: 150},
			{m: new Date(2020, 11, 20), cases: 109},
			{m: new Date(2020, 11, 27), cases: 67},
			{m: new Date(2021, 0, 3), cases: 77},
			{m: new Date(2021, 0, 10), cases: 152},
			{m: new Date(2021, 0, 17), cases: 92}
		]
	},
	"97231": {
		"pop":4482,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.8627900574609",
		"centroid_lng":"-122.831516172358",
		"cum_cases_start":"12",
		"cum_cases_end":"65",
		"data": [
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97232": {
		"pop":14723,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.72130646291",
		"centroid_lng":"-122.643246105686",
		"cum_cases_start":"12",
		"cum_cases_end":"285",
		"data": [
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 8},
			{m: new Date(2020, 9, 18), cases: 7},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 14},
			{m: new Date(2020, 10, 8), cases: 12},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 29},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 16},
			{m: new Date(2020, 11, 20), cases: 32},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 18},
			{m: new Date(2021, 0, 10), cases: 18},
			{m: new Date(2021, 0, 17), cases: 14}
		]
	},
	"97233": {
		"pop":43364,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.7060564994924",
		"centroid_lng":"-122.498887113513",
		"cum_cases_start":"84",
		"cum_cases_end":"2864",
		"data": [
			{m: new Date(2020, 4, 16), cases: 14},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 9},
			{m: new Date(2020, 5, 7), cases: 14},
			{m: new Date(2020, 5, 14), cases: 49},
			{m: new Date(2020, 5, 21), cases: 49},
			{m: new Date(2020, 5, 28), cases: 37},
			{m: new Date(2020, 6, 5), cases: 48},
			{m: new Date(2020, 6, 12), cases: 65},
			{m: new Date(2020, 6, 19), cases: 66},
			{m: new Date(2020, 6, 26), cases: 51},
			{m: new Date(2020, 7, 2), cases: 44},
			{m: new Date(2020, 7, 9), cases: 48},
			{m: new Date(2020, 7, 16), cases: 44},
			{m: new Date(2020, 7, 23), cases: 38},
			{m: new Date(2020, 7, 30), cases: 15},
			{m: new Date(2020, 8, 7), cases: 39},
			{m: new Date(2020, 8, 13), cases: 39},
			{m: new Date(2020, 8, 20), cases: 48},
			{m: new Date(2020, 8, 27), cases: 40},
			{m: new Date(2020, 9, 4), cases: 63},
			{m: new Date(2020, 9, 11), cases: 52},
			{m: new Date(2020, 9, 18), cases: 65},
			{m: new Date(2020, 9, 25), cases: 100},
			{m: new Date(2020, 10, 1), cases: 65},
			{m: new Date(2020, 10, 8), cases: 130},
			{m: new Date(2020, 10, 15), cases: 167},
			{m: new Date(2020, 10, 22), cases: 195},
			{m: new Date(2020, 10, 29), cases: 251},
			{m: new Date(2020, 11, 6), cases: 208},
			{m: new Date(2020, 11, 13), cases: 225},
			{m: new Date(2020, 11, 20), cases: 133},
			{m: new Date(2020, 11, 27), cases: 95},
			{m: new Date(2021, 0, 3), cases: 111},
			{m: new Date(2021, 0, 10), cases: 111},
			{m: new Date(2021, 0, 17), cases: 63}
		]
	},
	"97236": {
		"pop":39729,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6769067944189",
		"centroid_lng":"-122.510350235016",
		"cum_cases_start":"181",
		"cum_cases_end":"2532",
		"data": [
			{m: new Date(2020, 4, 16), cases: 9},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 7},
			{m: new Date(2020, 5, 7), cases: 18},
			{m: new Date(2020, 5, 14), cases: 41},
			{m: new Date(2020, 5, 21), cases: 56},
			{m: new Date(2020, 5, 28), cases: 31},
			{m: new Date(2020, 6, 5), cases: 34},
			{m: new Date(2020, 6, 12), cases: 19},
			{m: new Date(2020, 6, 19), cases: 50},
			{m: new Date(2020, 6, 26), cases: 46},
			{m: new Date(2020, 7, 2), cases: 48},
			{m: new Date(2020, 7, 9), cases: 47},
			{m: new Date(2020, 7, 16), cases: 32},
			{m: new Date(2020, 7, 23), cases: 33},
			{m: new Date(2020, 7, 30), cases: 34},
			{m: new Date(2020, 8, 7), cases: 25},
			{m: new Date(2020, 8, 13), cases: 34},
			{m: new Date(2020, 8, 20), cases: 14},
			{m: new Date(2020, 8, 27), cases: 30},
			{m: new Date(2020, 9, 4), cases: 31},
			{m: new Date(2020, 9, 11), cases: 39},
			{m: new Date(2020, 9, 18), cases: 46},
			{m: new Date(2020, 9, 25), cases: 51},
			{m: new Date(2020, 10, 1), cases: 72},
			{m: new Date(2020, 10, 8), cases: 94},
			{m: new Date(2020, 10, 15), cases: 129},
			{m: new Date(2020, 10, 22), cases: 203},
			{m: new Date(2020, 10, 29), cases: 262},
			{m: new Date(2020, 11, 6), cases: 213},
			{m: new Date(2020, 11, 13), cases: 185},
			{m: new Date(2020, 11, 20), cases: 90},
			{m: new Date(2020, 11, 27), cases: 67},
			{m: new Date(2021, 0, 3), cases: 83},
			{m: new Date(2021, 0, 10), cases: 109},
			{m: new Date(2021, 0, 17), cases: 76}
		]
	},
	"97239": {
		"pop":18033,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6812450016814",
		"centroid_lng":"-122.691537119668",
		"cum_cases_start":"21",
		"cum_cases_end":"289",
		"data": [
			{m: new Date(2020, 6, 19), cases: 9},
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 15},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 12},
			{m: new Date(2020, 9, 25), cases: 11},
			{m: new Date(2020, 10, 1), cases: 15},
			{m: new Date(2020, 10, 8), cases: 11},
			{m: new Date(2020, 10, 15), cases: 14},
			{m: new Date(2020, 10, 22), cases: 23},
			{m: new Date(2020, 10, 29), cases: 21},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 15},
			{m: new Date(2020, 11, 20), cases: 19},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 23},
			{m: new Date(2021, 0, 17), cases: 6}
		]
	},
	"97266": {
		"pop":36872,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.6744299398974",
		"centroid_lng":"-122.55783733307",
		"cum_cases_start":"35",
		"cum_cases_end":"1710",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 6},
			{m: new Date(2020, 4, 31), cases: 15},
			{m: new Date(2020, 5, 7), cases: 9},
			{m: new Date(2020, 5, 14), cases: 16},
			{m: new Date(2020, 5, 21), cases: 9},
			{m: new Date(2020, 5, 28), cases: 19},
			{m: new Date(2020, 6, 5), cases: 21},
			{m: new Date(2020, 6, 12), cases: 26},
			{m: new Date(2020, 6, 19), cases: 21},
			{m: new Date(2020, 6, 26), cases: 33},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 25},
			{m: new Date(2020, 7, 16), cases: 20},
			{m: new Date(2020, 7, 23), cases: 23},
			{m: new Date(2020, 7, 30), cases: 23},
			{m: new Date(2020, 8, 7), cases: 16},
			{m: new Date(2020, 8, 13), cases: 19},
			{m: new Date(2020, 8, 20), cases: 17},
			{m: new Date(2020, 8, 27), cases: 27},
			{m: new Date(2020, 9, 4), cases: 31},
			{m: new Date(2020, 9, 11), cases: 22},
			{m: new Date(2020, 9, 18), cases: 17},
			{m: new Date(2020, 9, 25), cases: 26},
			{m: new Date(2020, 10, 1), cases: 43},
			{m: new Date(2020, 10, 8), cases: 81},
			{m: new Date(2020, 10, 15), cases: 109},
			{m: new Date(2020, 10, 22), cases: 178},
			{m: new Date(2020, 10, 29), cases: 206},
			{m: new Date(2020, 11, 6), cases: 163},
			{m: new Date(2020, 11, 13), cases: 113},
			{m: new Date(2020, 11, 20), cases: 98},
			{m: new Date(2020, 11, 27), cases: 42},
			{m: new Date(2021, 0, 3), cases: 86},
			{m: new Date(2021, 0, 10), cases: 47},
			{m: new Date(2021, 0, 17), cases: 51}
		]
	},
	"97267": {
		"pop":32656,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Portland",
		"centroid_lat":"45.5994979501819",
		"centroid_lng":"-122.615636498671",
		"cum_cases_start":"23",
		"cum_cases_end":"895",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 4},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 14},
			{m: new Date(2020, 5, 21), cases: 7},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 14},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 15},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 11},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 21},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 26},
			{m: new Date(2020, 10, 1), cases: 23},
			{m: new Date(2020, 10, 8), cases: 49},
			{m: new Date(2020, 10, 15), cases: 55},
			{m: new Date(2020, 10, 22), cases: 61},
			{m: new Date(2020, 10, 29), cases: 88},
			{m: new Date(2020, 11, 6), cases: 53},
			{m: new Date(2020, 11, 13), cases: 58},
			{m: new Date(2020, 11, 20), cases: 57},
			{m: new Date(2020, 11, 27), cases: 54},
			{m: new Date(2021, 0, 3), cases: 49},
			{m: new Date(2021, 0, 10), cases: 71},
			{m: new Date(2021, 0, 17), cases: 24}
		]
	},
	"97301": {
		"pop":57498,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.1413250005746",
		"centroid_lng":"-123.005196109974",
		"cum_cases_start":"81",
		"cum_cases_end":"2962",
		"data": [
			{m: new Date(2020, 4, 16), cases: 12},
			{m: new Date(2020, 4, 24), cases: 8},
			{m: new Date(2020, 4, 31), cases: 16},
			{m: new Date(2020, 5, 7), cases: 25},
			{m: new Date(2020, 5, 14), cases: 17},
			{m: new Date(2020, 5, 21), cases: 30},
			{m: new Date(2020, 5, 28), cases: 15},
			{m: new Date(2020, 6, 5), cases: 24},
			{m: new Date(2020, 6, 12), cases: 45},
			{m: new Date(2020, 6, 19), cases: 34},
			{m: new Date(2020, 6, 26), cases: 43},
			{m: new Date(2020, 7, 2), cases: 65},
			{m: new Date(2020, 7, 9), cases: 57},
			{m: new Date(2020, 7, 16), cases: 73},
			{m: new Date(2020, 7, 23), cases: 54},
			{m: new Date(2020, 7, 30), cases: 32},
			{m: new Date(2020, 8, 7), cases: 43},
			{m: new Date(2020, 8, 13), cases: 43},
			{m: new Date(2020, 8, 20), cases: 30},
			{m: new Date(2020, 8, 27), cases: 37},
			{m: new Date(2020, 9, 4), cases: 48},
			{m: new Date(2020, 9, 11), cases: 60},
			{m: new Date(2020, 9, 18), cases: 56},
			{m: new Date(2020, 9, 25), cases: 72},
			{m: new Date(2020, 10, 1), cases: 81},
			{m: new Date(2020, 10, 8), cases: 107},
			{m: new Date(2020, 10, 15), cases: 141},
			{m: new Date(2020, 10, 22), cases: 134},
			{m: new Date(2020, 10, 29), cases: 224},
			{m: new Date(2020, 11, 6), cases: 222},
			{m: new Date(2020, 11, 13), cases: 219},
			{m: new Date(2020, 11, 20), cases: 173},
			{m: new Date(2020, 11, 27), cases: 161},
			{m: new Date(2021, 0, 3), cases: 210},
			{m: new Date(2021, 0, 10), cases: 170},
			{m: new Date(2021, 0, 17), cases: 112}
		]
	},
	"97302": {
		"pop":40790,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.0934661261912",
		"centroid_lng":"-123.068653020533",
		"cum_cases_start":"44",
		"cum_cases_end":"1015",
		"data": [
			{m: new Date(2020, 4, 16), cases: 7},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 8},
			{m: new Date(2020, 5, 14), cases: 12},
			{m: new Date(2020, 5, 21), cases: 15},
			{m: new Date(2020, 5, 28), cases: 9},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 12},
			{m: new Date(2020, 6, 19), cases: 15},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 6},
			{m: new Date(2020, 7, 16), cases: 15},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 9},
			{m: new Date(2020, 8, 13), cases: 10},
			{m: new Date(2020, 8, 20), cases: 16},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 21},
			{m: new Date(2020, 9, 18), cases: 15},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 34},
			{m: new Date(2020, 10, 8), cases: 34},
			{m: new Date(2020, 10, 15), cases: 48},
			{m: new Date(2020, 10, 22), cases: 60},
			{m: new Date(2020, 10, 29), cases: 90},
			{m: new Date(2020, 11, 6), cases: 78},
			{m: new Date(2020, 11, 13), cases: 79},
			{m: new Date(2020, 11, 20), cases: 67},
			{m: new Date(2020, 11, 27), cases: 45},
			{m: new Date(2021, 0, 3), cases: 66},
			{m: new Date(2021, 0, 10), cases: 63},
			{m: new Date(2021, 0, 17), cases: 48}
		]
	},
	"97303": {
		"pop":42546,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.219890946395",
		"centroid_lng":"-123.022713285382",
		"cum_cases_start":"76",
		"cum_cases_end":"1725",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 6},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 3},
			{m: new Date(2020, 5, 14), cases: 24},
			{m: new Date(2020, 5, 21), cases: 33},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 24},
			{m: new Date(2020, 6, 12), cases: 19},
			{m: new Date(2020, 6, 19), cases: 36},
			{m: new Date(2020, 6, 26), cases: 25},
			{m: new Date(2020, 7, 2), cases: 35},
			{m: new Date(2020, 7, 9), cases: 21},
			{m: new Date(2020, 7, 16), cases: 15},
			{m: new Date(2020, 7, 23), cases: 20},
			{m: new Date(2020, 7, 30), cases: 24},
			{m: new Date(2020, 8, 7), cases: 25},
			{m: new Date(2020, 8, 13), cases: 8},
			{m: new Date(2020, 8, 20), cases: 20},
			{m: new Date(2020, 8, 27), cases: 26},
			{m: new Date(2020, 9, 4), cases: 21},
			{m: new Date(2020, 9, 11), cases: 24},
			{m: new Date(2020, 9, 18), cases: 29},
			{m: new Date(2020, 9, 25), cases: 25},
			{m: new Date(2020, 10, 1), cases: 62},
			{m: new Date(2020, 10, 8), cases: 49},
			{m: new Date(2020, 10, 15), cases: 81},
			{m: new Date(2020, 10, 22), cases: 94},
			{m: new Date(2020, 10, 29), cases: 128},
			{m: new Date(2020, 11, 6), cases: 120},
			{m: new Date(2020, 11, 13), cases: 120},
			{m: new Date(2020, 11, 20), cases: 118},
			{m: new Date(2020, 11, 27), cases: 100},
			{m: new Date(2021, 0, 3), cases: 107},
			{m: new Date(2021, 0, 10), cases: 112},
			{m: new Date(2021, 0, 17), cases: 86}
		]
	},
	"97304": {
		"pop":31835,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.2034849430857",
		"centroid_lng":"-123.108836166408",
		"cum_cases_start":"69",
		"cum_cases_end":"1070",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 12},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 4},
			{m: new Date(2020, 6, 5), cases: 10},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 18},
			{m: new Date(2020, 6, 26), cases: 28},
			{m: new Date(2020, 7, 2), cases: 15},
			{m: new Date(2020, 7, 9), cases: 18},
			{m: new Date(2020, 7, 16), cases: 22},
			{m: new Date(2020, 7, 23), cases: 16},
			{m: new Date(2020, 7, 30), cases: 10},
			{m: new Date(2020, 8, 7), cases: 12},
			{m: new Date(2020, 8, 13), cases: 17},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 12},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 28},
			{m: new Date(2020, 9, 25), cases: 9},
			{m: new Date(2020, 10, 1), cases: 17},
			{m: new Date(2020, 10, 8), cases: 51},
			{m: new Date(2020, 10, 15), cases: 36},
			{m: new Date(2020, 10, 22), cases: 61},
			{m: new Date(2020, 10, 29), cases: 100},
			{m: new Date(2020, 11, 6), cases: 52},
			{m: new Date(2020, 11, 13), cases: 68},
			{m: new Date(2020, 11, 20), cases: 61},
			{m: new Date(2020, 11, 27), cases: 53},
			{m: new Date(2021, 0, 3), cases: 93},
			{m: new Date(2021, 0, 10), cases: 68},
			{m: new Date(2021, 0, 17), cases: 51}
		]
	},
	"97305": {
		"pop":43553,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.2102428224959",
		"centroid_lng":"-122.927070348516",
		"cum_cases_start":"80",
		"cum_cases_end":"2639",
		"data": [
			{m: new Date(2020, 4, 16), cases: 9},
			{m: new Date(2020, 4, 24), cases: 10},
			{m: new Date(2020, 4, 31), cases: 15},
			{m: new Date(2020, 5, 7), cases: 16},
			{m: new Date(2020, 5, 14), cases: 20},
			{m: new Date(2020, 5, 21), cases: 17},
			{m: new Date(2020, 5, 28), cases: 34},
			{m: new Date(2020, 6, 5), cases: 35},
			{m: new Date(2020, 6, 12), cases: 33},
			{m: new Date(2020, 6, 19), cases: 35},
			{m: new Date(2020, 6, 26), cases: 44},
			{m: new Date(2020, 7, 2), cases: 43},
			{m: new Date(2020, 7, 9), cases: 46},
			{m: new Date(2020, 7, 16), cases: 77},
			{m: new Date(2020, 7, 23), cases: 72},
			{m: new Date(2020, 7, 30), cases: 53},
			{m: new Date(2020, 8, 7), cases: 48},
			{m: new Date(2020, 8, 13), cases: 39},
			{m: new Date(2020, 8, 20), cases: 41},
			{m: new Date(2020, 8, 27), cases: 53},
			{m: new Date(2020, 9, 4), cases: 41},
			{m: new Date(2020, 9, 11), cases: 50},
			{m: new Date(2020, 9, 18), cases: 47},
			{m: new Date(2020, 9, 25), cases: 61},
			{m: new Date(2020, 10, 1), cases: 72},
			{m: new Date(2020, 10, 8), cases: 92},
			{m: new Date(2020, 10, 15), cases: 111},
			{m: new Date(2020, 10, 22), cases: 138},
			{m: new Date(2020, 10, 29), cases: 178},
			{m: new Date(2020, 11, 6), cases: 183},
			{m: new Date(2020, 11, 13), cases: 186},
			{m: new Date(2020, 11, 20), cases: 159},
			{m: new Date(2020, 11, 27), cases: 128},
			{m: new Date(2021, 0, 3), cases: 156},
			{m: new Date(2021, 0, 10), cases: 120},
			{m: new Date(2021, 0, 17), cases: 106}
		]
	},
	"97306": {
		"pop":30391,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.0372579019777",
		"centroid_lng":"-123.079068106972",
		"cum_cases_start":"34",
		"cum_cases_end":"1019",
		"data": [
			{m: new Date(2020, 4, 16), cases: 8},
			{m: new Date(2020, 4, 24), cases: 3},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 4},
			{m: new Date(2020, 5, 21), cases: 36},
			{m: new Date(2020, 5, 28), cases: 9},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 15},
			{m: new Date(2020, 6, 19), cases: 26},
			{m: new Date(2020, 6, 26), cases: 16},
			{m: new Date(2020, 7, 2), cases: 17},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 15},
			{m: new Date(2020, 8, 20), cases: 17},
			{m: new Date(2020, 8, 27), cases: 17},
			{m: new Date(2020, 9, 4), cases: 13},
			{m: new Date(2020, 9, 11), cases: 11},
			{m: new Date(2020, 9, 18), cases: 18},
			{m: new Date(2020, 9, 25), cases: 21},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 32},
			{m: new Date(2020, 10, 15), cases: 42},
			{m: new Date(2020, 10, 22), cases: 47},
			{m: new Date(2020, 10, 29), cases: 90},
			{m: new Date(2020, 11, 6), cases: 68},
			{m: new Date(2020, 11, 13), cases: 87},
			{m: new Date(2020, 11, 20), cases: 73},
			{m: new Date(2020, 11, 27), cases: 66},
			{m: new Date(2021, 0, 3), cases: 69},
			{m: new Date(2021, 0, 10), cases: 70},
			{m: new Date(2021, 0, 17), cases: 37}
		]
	},
	"97317": {
		"pop":26164,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Salem",
		"centroid_lat":"45.0958437891074",
		"centroid_lng":"-122.907971447539",
		"cum_cases_start":"51",
		"cum_cases_end":"1138",
		"data": [
			{m: new Date(2020, 4, 16), cases: 7},
			{m: new Date(2020, 4, 24), cases: 4},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 6},
			{m: new Date(2020, 5, 14), cases: 6},
			{m: new Date(2020, 5, 21), cases: 10},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 16},
			{m: new Date(2020, 6, 19), cases: 12},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 15},
			{m: new Date(2020, 7, 9), cases: 13},
			{m: new Date(2020, 7, 16), cases: 24},
			{m: new Date(2020, 7, 23), cases: 19},
			{m: new Date(2020, 7, 30), cases: 17},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 13},
			{m: new Date(2020, 8, 27), cases: 16},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 42},
			{m: new Date(2020, 9, 25), cases: 28},
			{m: new Date(2020, 10, 1), cases: 47},
			{m: new Date(2020, 10, 8), cases: 67},
			{m: new Date(2020, 10, 15), cases: 57},
			{m: new Date(2020, 10, 22), cases: 69},
			{m: new Date(2020, 10, 29), cases: 95},
			{m: new Date(2020, 11, 6), cases: 71},
			{m: new Date(2020, 11, 13), cases: 55},
			{m: new Date(2020, 11, 20), cases: 68},
			{m: new Date(2020, 11, 27), cases: 51},
			{m: new Date(2021, 0, 3), cases: 78},
			{m: new Date(2021, 0, 10), cases: 63},
			{m: new Date(2021, 0, 17), cases: 35}
		]
	},
	"97321": {
		"pop":27837,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Albany",
		"centroid_lat":"44.8435533988688",
		"centroid_lng":"-123.137429236485",
		"cum_cases_start":"29",
		"cum_cases_end":"674",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 5},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 7},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 19},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 11},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 9},
			{m: new Date(2020, 9, 11), cases: 25},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 11},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 24},
			{m: new Date(2020, 10, 15), cases: 28},
			{m: new Date(2020, 10, 22), cases: 42},
			{m: new Date(2020, 10, 29), cases: 69},
			{m: new Date(2020, 11, 6), cases: 49},
			{m: new Date(2020, 11, 13), cases: 47},
			{m: new Date(2020, 11, 20), cases: 38},
			{m: new Date(2020, 11, 27), cases: 29},
			{m: new Date(2021, 0, 3), cases: 47},
			{m: new Date(2021, 0, 10), cases: 77},
			{m: new Date(2021, 0, 17), cases: 27}
		]
	},
	"97322": {
		"pop":37145,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Albany",
		"centroid_lat":"44.8149825134597",
		"centroid_lng":"-123.018849039085",
		"cum_cases_start":"38",
		"cum_cases_end":"1062",
		"data": [
			{m: new Date(2020, 4, 16), cases: 3},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 4},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 16},
			{m: new Date(2020, 7, 16), cases: 18},
			{m: new Date(2020, 7, 23), cases: 13},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 17},
			{m: new Date(2020, 8, 20), cases: 19},
			{m: new Date(2020, 8, 27), cases: 28},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 29},
			{m: new Date(2020, 9, 18), cases: 14},
			{m: new Date(2020, 9, 25), cases: 14},
			{m: new Date(2020, 10, 1), cases: 27},
			{m: new Date(2020, 10, 8), cases: 25},
			{m: new Date(2020, 10, 15), cases: 34},
			{m: new Date(2020, 10, 22), cases: 47},
			{m: new Date(2020, 10, 29), cases: 95},
			{m: new Date(2020, 11, 6), cases: 114},
			{m: new Date(2020, 11, 13), cases: 95},
			{m: new Date(2020, 11, 20), cases: 106},
			{m: new Date(2020, 11, 27), cases: 51},
			{m: new Date(2021, 0, 3), cases: 70},
			{m: new Date(2021, 0, 10), cases: 86},
			{m: new Date(2021, 0, 17), cases: 31}
		]
	},
	"97324": {
		"pop":1212,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Alsea",
		"centroid_lat":"44.5463189812209",
		"centroid_lng":"-123.617080036305",
		"cum_cases_start":"12",
		"cum_cases_end":"20",
		"data": [
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97325": {
		"pop":7403,
		"first_date":"5/24",
		"last_date":"1/17",
		"name":"Aumsville",
		"centroid_lat":"45.0258057539326",
		"centroid_lng":"-122.854228088104",
		"cum_cases_start":"10",
		"cum_cases_end":"229",
		"data": [
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 10},
			{m: new Date(2020, 10, 22), cases: 7},
			{m: new Date(2020, 10, 29), cases: 23},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 16},
			{m: new Date(2020, 11, 20), cases: 21},
			{m: new Date(2020, 11, 27), cases: 16},
			{m: new Date(2021, 0, 3), cases: 10},
			{m: new Date(2021, 0, 10), cases: 24},
			{m: new Date(2021, 0, 17), cases: 22}
		]
	},
	"97327": {
		"pop":3181,
		"first_date":"11/22",
		"last_date":"1/17",
		"name":"Brownsville",
		"centroid_lat":"44.556628458825",
		"centroid_lng":"-122.942374214185",
		"cum_cases_start":"15",
		"cum_cases_end":"66",
		"data": [
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97330": {
		"pop":44576,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Corvallis",
		"centroid_lat":"44.8326638923832",
		"centroid_lng":"-123.285848972734",
		"cum_cases_start":"38",
		"cum_cases_end":"826",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 4},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 9},
			{m: new Date(2020, 7, 16), cases: 12},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 8},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 14},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 7},
			{m: new Date(2020, 9, 18), cases: 21},
			{m: new Date(2020, 9, 25), cases: 15},
			{m: new Date(2020, 10, 1), cases: 11},
			{m: new Date(2020, 10, 8), cases: 25},
			{m: new Date(2020, 10, 15), cases: 52},
			{m: new Date(2020, 10, 22), cases: 48},
			{m: new Date(2020, 10, 29), cases: 45},
			{m: new Date(2020, 11, 6), cases: 56},
			{m: new Date(2020, 11, 13), cases: 94},
			{m: new Date(2020, 11, 20), cases: 68},
			{m: new Date(2020, 11, 27), cases: 38},
			{m: new Date(2021, 0, 3), cases: 48},
			{m: new Date(2021, 0, 10), cases: 76},
			{m: new Date(2021, 0, 17), cases: 56}
		]
	},
	"97331": {
		"pop":3290,
		"first_date":"9/27",
		"last_date":"1/17",
		"name":"Corvallis",
		"centroid_lat":"44.7564901226073",
		"centroid_lng":"-123.285386564666",
		"cum_cases_start":"27",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97333": {
		"pop":22579,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Corvallis",
		"centroid_lat":"44.6675103833502",
		"centroid_lng":"-123.303475643778",
		"cum_cases_start":"12",
		"cum_cases_end":"411",
		"data": [
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 4},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 12},
			{m: new Date(2020, 10, 15), cases: 26},
			{m: new Date(2020, 10, 22), cases: 30},
			{m: new Date(2020, 10, 29), cases: 35},
			{m: new Date(2020, 11, 6), cases: 20},
			{m: new Date(2020, 11, 13), cases: 40},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 20},
			{m: new Date(2021, 0, 3), cases: 29},
			{m: new Date(2021, 0, 10), cases: 50},
			{m: new Date(2021, 0, 17), cases: 30}
		]
	},
	"97338": {
		"pop":21934,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"Dallas",
		"centroid_lat":"45.1256880377315",
		"centroid_lng":"-123.336042685711",
		"cum_cases_start":"11",
		"cum_cases_end":"526",
		"data": [
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 18},
			{m: new Date(2020, 10, 22), cases: 27},
			{m: new Date(2020, 10, 29), cases: 46},
			{m: new Date(2020, 11, 6), cases: 51},
			{m: new Date(2020, 11, 13), cases: 60},
			{m: new Date(2020, 11, 20), cases: 45},
			{m: new Date(2020, 11, 27), cases: 41},
			{m: new Date(2021, 0, 3), cases: 49},
			{m: new Date(2021, 0, 10), cases: 54},
			{m: new Date(2021, 0, 17), cases: 42}
		]
	},
	"97341": {
		"pop":2620,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Depoe Bay",
		"centroid_lat":"44.998137752253",
		"centroid_lng":"-124.030394956447",
		"cum_cases_start":"13",
		"cum_cases_end":"23",
		"data": [
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97347": {
		"pop":2034,
		"first_date":"10/18",
		"last_date":"1/17",
		"name":"Grand Ronde",
		"centroid_lat":"45.2872285265915",
		"centroid_lng":"-123.687293105052",
		"cum_cases_start":"10",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 8},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97348": {
		"pop":1815,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Halsey",
		"centroid_lat":"44.5757441386269",
		"centroid_lng":"-123.129674223864",
		"cum_cases_start":"25",
		"cum_cases_end":"42",
		"data": [
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97351": {
		"pop":11515,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Independence",
		"centroid_lat":"45.0339812458391",
		"centroid_lng":"-123.17412174677",
		"cum_cases_start":"21",
		"cum_cases_end":"456",
		"data": [
			{m: new Date(2020, 5, 14), cases: 10},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 14},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 21},
			{m: new Date(2020, 10, 15), cases: 35},
			{m: new Date(2020, 10, 22), cases: 45},
			{m: new Date(2020, 10, 29), cases: 56},
			{m: new Date(2020, 11, 6), cases: 30},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 17},
			{m: new Date(2021, 0, 10), cases: 55},
			{m: new Date(2021, 0, 17), cases: 20}
		]
	},
	"97352": {
		"pop":6677,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Jefferson",
		"centroid_lat":"44.9439451142472",
		"centroid_lng":"-123.027579471642",
		"cum_cases_start":"11",
		"cum_cases_end":"177",
		"data": [
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 13},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 26},
			{m: new Date(2020, 11, 13), cases: 15},
			{m: new Date(2020, 11, 20), cases: 13},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 16},
			{m: new Date(2021, 0, 10), cases: 15},
			{m: new Date(2021, 0, 17), cases: 13}
		]
	},
	"97355": {
		"pop":31285,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Lebanon",
		"centroid_lat":"44.7189484645898",
		"centroid_lng":"-122.827389979406",
		"cum_cases_start":"37",
		"cum_cases_end":"757",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 34},
			{m: new Date(2020, 9, 18), cases: 18},
			{m: new Date(2020, 9, 25), cases: 19},
			{m: new Date(2020, 10, 1), cases: 37},
			{m: new Date(2020, 10, 8), cases: 40},
			{m: new Date(2020, 10, 15), cases: 25},
			{m: new Date(2020, 10, 22), cases: 37},
			{m: new Date(2020, 10, 29), cases: 79},
			{m: new Date(2020, 11, 6), cases: 70},
			{m: new Date(2020, 11, 13), cases: 84},
			{m: new Date(2020, 11, 20), cases: 60},
			{m: new Date(2020, 11, 27), cases: 27},
			{m: new Date(2021, 0, 3), cases: 46},
			{m: new Date(2021, 0, 10), cases: 35},
			{m: new Date(2021, 0, 17), cases: 25}
		]
	},
	"97358": {
		"pop":2960,
		"first_date":"11/22",
		"last_date":"1/17",
		"name":"Lyons",
		"centroid_lat":"44.9727092128842",
		"centroid_lng":"-122.558946268582",
		"cum_cases_start":"12",
		"cum_cases_end":"53",
		"data": [
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97360": {
		"pop":2520,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Mill City",
		"centroid_lat":"44.9758092035065",
		"centroid_lng":"-122.468014597528",
		"cum_cases_start":"11",
		"cum_cases_end":"42",
		"data": [
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97361": {
		"pop":12611,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Monmouth",
		"centroid_lat":"44.9656870698341",
		"centroid_lng":"-123.331418104414",
		"cum_cases_start":"13",
		"cum_cases_end":"336",
		"data": [
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 12},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 7},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 14},
			{m: new Date(2020, 10, 22), cases: 31},
			{m: new Date(2020, 10, 29), cases: 35},
			{m: new Date(2020, 11, 6), cases: 19},
			{m: new Date(2020, 11, 13), cases: 16},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 14},
			{m: new Date(2021, 0, 3), cases: 24},
			{m: new Date(2021, 0, 10), cases: 43},
			{m: new Date(2021, 0, 17), cases: 22}
		]
	},
	"97362": {
		"pop":5034,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Mount Angel",
		"centroid_lat":"45.263014649253",
		"centroid_lng":"-122.771796469686",
		"cum_cases_start":"14",
		"cum_cases_end":"209",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 2},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 0},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 3},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 17},
			{m: new Date(2020, 10, 22), cases: 8},
			{m: new Date(2020, 10, 29), cases: 32},
			{m: new Date(2020, 11, 6), cases: 13},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 17},
			{m: new Date(2021, 0, 17), cases: 13}
		]
	},
	"97365": {
		"pop":11131,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Newport",
		"centroid_lat":"44.862540867825",
		"centroid_lng":"-124.024608550087",
		"cum_cases_start":"187",
		"cum_cases_end":"438",
		"data": [
			{m: new Date(2020, 5, 14), cases: 43},
			{m: new Date(2020, 5, 21), cases: 59},
			{m: new Date(2020, 5, 28), cases: 23},
			{m: new Date(2020, 6, 5), cases: 29},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 8},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 15},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97366": {
		"pop":1514,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"South Beach",
		"centroid_lat":"44.7695957409229",
		"centroid_lng":"-124.045628777343",
		"cum_cases_start":"10",
		"cum_cases_end":"16",
		"data": [
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97367": {
		"pop":11088,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Lincoln City",
		"centroid_lat":"45.127998685568",
		"centroid_lng":"-123.880505180046",
		"cum_cases_start":"15",
		"cum_cases_end":"204",
		"data": [
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 7},
			{m: new Date(2020, 7, 9), cases: 19},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 12},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 11},
			{m: new Date(2020, 10, 29), cases: 8},
			{m: new Date(2020, 11, 6), cases: 18},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 9},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97368": {
		"pop":3816,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Otis",
		"centroid_lat":"45.2073552529477",
		"centroid_lng":"-123.908676006058",
		"cum_cases_start":"23",
		"cum_cases_end":"32",
		"data": [
			{m: new Date(2020, 11, 6), cases: 9},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97370": {
		"pop":9193,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Philomath",
		"centroid_lat":"44.7709329797755",
		"centroid_lng":"-123.458398085892",
		"cum_cases_start":"12",
		"cum_cases_end":"166",
		"data": [
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 18},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 16}
		]
	},
	"97374": {
		"pop":5641,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Scio",
		"centroid_lat":"44.8770363939417",
		"centroid_lng":"-122.735231840368",
		"cum_cases_start":"10",
		"cum_cases_end":"133",
		"data": [
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 13},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 20},
			{m: new Date(2020, 11, 20), cases: 13},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 16},
			{m: new Date(2021, 0, 10), cases: 13},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97375": {
		"pop":1227,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"Scotts Mills",
		"centroid_lat":"45.171802398908",
		"centroid_lng":"-122.610059397408",
		"cum_cases_start":"10",
		"cum_cases_end":"27",
		"data": [
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97378": {
		"pop":9474,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Sheridan",
		"centroid_lat":"45.3051677077163",
		"centroid_lng":"-123.430552534051",
		"cum_cases_start":"10",
		"cum_cases_end":"208",
		"data": [
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 27},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 16},
			{m: new Date(2021, 0, 3), cases: 42},
			{m: new Date(2021, 0, 10), cases: 17},
			{m: new Date(2021, 0, 17), cases: 18}
		]
	},
	"97380": {
		"pop":2629,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Siletz",
		"centroid_lat":"44.9952578861795",
		"centroid_lng":"-123.873140262952",
		"cum_cases_start":"10",
		"cum_cases_end":"54",
		"data": [
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 21},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97381": {
		"pop":16663,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Silverton",
		"centroid_lat":"45.128292740661",
		"centroid_lng":"-122.664073824021",
		"cum_cases_start":"33",
		"cum_cases_end":"433",
		"data": [
			{m: new Date(2020, 4, 16), cases: 4},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 5},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 4},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 10},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 7},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 15},
			{m: new Date(2020, 10, 15), cases: 28},
			{m: new Date(2020, 10, 22), cases: 31},
			{m: new Date(2020, 10, 29), cases: 22},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 23},
			{m: new Date(2020, 11, 20), cases: 22},
			{m: new Date(2020, 11, 27), cases: 23},
			{m: new Date(2021, 0, 3), cases: 29},
			{m: new Date(2021, 0, 10), cases: 26},
			{m: new Date(2021, 0, 17), cases: 32}
		]
	},
	"97383": {
		"pop":10344,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Stayton",
		"centroid_lat":"44.995684341161",
		"centroid_lng":"-122.712506334752",
		"cum_cases_start":"16",
		"cum_cases_end":"315",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 4},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 2},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 9},
			{m: new Date(2020, 9, 25), cases: 16},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 9},
			{m: new Date(2020, 10, 22), cases: 26},
			{m: new Date(2020, 10, 29), cases: 28},
			{m: new Date(2020, 11, 6), cases: 22},
			{m: new Date(2020, 11, 13), cases: 19},
			{m: new Date(2020, 11, 20), cases: 40},
			{m: new Date(2020, 11, 27), cases: 16},
			{m: new Date(2021, 0, 3), cases: 28},
			{m: new Date(2021, 0, 10), cases: 17},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97385": {
		"pop":3527,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Sublimity",
		"centroid_lat":"45.0621423298474",
		"centroid_lng":"-122.742818816947",
		"cum_cases_start":"14",
		"cum_cases_end":"98",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97386": {
		"pop":14564,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Sweet Home",
		"centroid_lat":"44.5577268449163",
		"centroid_lng":"-122.741933990991",
		"cum_cases_start":"13",
		"cum_cases_end":"234",
		"data": [
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 9},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 14},
			{m: new Date(2020, 10, 29), cases: 32},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 17},
			{m: new Date(2020, 11, 20), cases: 14},
			{m: new Date(2020, 11, 27), cases: 21},
			{m: new Date(2021, 0, 3), cases: 17},
			{m: new Date(2021, 0, 10), cases: 24},
			{m: new Date(2021, 0, 17), cases: 17}
		]
	},
	"97389": {
		"pop":1775,
		"first_date":"10/11",
		"last_date":"1/17",
		"name":"Tangent",
		"centroid_lat":"44.7239881951004",
		"centroid_lng":"-123.091829173871",
		"cum_cases_start":"14",
		"cum_cases_end":"54",
		"data": [
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 8},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97391": {
		"pop":6040,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Toledo",
		"centroid_lat":"44.8109534217033",
		"centroid_lng":"-123.918367567975",
		"cum_cases_start":"14",
		"cum_cases_end":"93",
		"data": [
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97392": {
		"pop":5381,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Turner",
		"centroid_lat":"44.9829023540815",
		"centroid_lng":"-122.941141473033",
		"cum_cases_start":"11",
		"cum_cases_end":"163",
		"data": [
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 5},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 7},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 8},
			{m: new Date(2020, 10, 29), cases: 23},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97394": {
		"pop":5099,
		"first_date":"11/1",
		"last_date":"1/17",
		"name":"Waldport",
		"centroid_lat":"44.5779066028232",
		"centroid_lng":"-123.989984365666",
		"cum_cases_start":"10",
		"cum_cases_end":"54",
		"data": [
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97396": {
		"pop":3688,
		"first_date":"11/1",
		"last_date":"1/17",
		"name":"Willamina",
		"centroid_lat":"45.3213201390022",
		"centroid_lng":"-123.572993028618",
		"cum_cases_start":"10",
		"cum_cases_end":"58",
		"data": [
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97401": {
		"pop":45841,
		"first_date":"5/24",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.25957433884",
		"centroid_lng":"-123.081539310165",
		"cum_cases_start":"11",
		"cum_cases_end":"1237",
		"data": [
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 18},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 15},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 9},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 9},
			{m: new Date(2020, 8, 20), cases: 33},
			{m: new Date(2020, 8, 27), cases: 90},
			{m: new Date(2020, 9, 4), cases: 61},
			{m: new Date(2020, 9, 11), cases: 86},
			{m: new Date(2020, 9, 18), cases: 72},
			{m: new Date(2020, 9, 25), cases: 48},
			{m: new Date(2020, 10, 1), cases: 31},
			{m: new Date(2020, 10, 8), cases: 45},
			{m: new Date(2020, 10, 15), cases: 50},
			{m: new Date(2020, 10, 22), cases: 74},
			{m: new Date(2020, 10, 29), cases: 75},
			{m: new Date(2020, 11, 6), cases: 76},
			{m: new Date(2020, 11, 13), cases: 68},
			{m: new Date(2020, 11, 20), cases: 81},
			{m: new Date(2020, 11, 27), cases: 35},
			{m: new Date(2021, 0, 3), cases: 56},
			{m: new Date(2021, 0, 10), cases: 63},
			{m: new Date(2021, 0, 17), cases: 70}
		]
	},
	"97402": {
		"pop":54883,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.2368314668921",
		"centroid_lng":"-123.239742381216",
		"cum_cases_start":"20",
		"cum_cases_end":"1343",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 21},
			{m: new Date(2020, 6, 12), cases: 9},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 11},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 8},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 26},
			{m: new Date(2020, 8, 13), cases: 13},
			{m: new Date(2020, 8, 20), cases: 14},
			{m: new Date(2020, 8, 27), cases: 33},
			{m: new Date(2020, 9, 4), cases: 31},
			{m: new Date(2020, 9, 11), cases: 39},
			{m: new Date(2020, 9, 18), cases: 43},
			{m: new Date(2020, 9, 25), cases: 34},
			{m: new Date(2020, 10, 1), cases: 40},
			{m: new Date(2020, 10, 8), cases: 55},
			{m: new Date(2020, 10, 15), cases: 74},
			{m: new Date(2020, 10, 22), cases: 100},
			{m: new Date(2020, 10, 29), cases: 113},
			{m: new Date(2020, 11, 6), cases: 118},
			{m: new Date(2020, 11, 13), cases: 120},
			{m: new Date(2020, 11, 20), cases: 84},
			{m: new Date(2020, 11, 27), cases: 55},
			{m: new Date(2021, 0, 3), cases: 84},
			{m: new Date(2021, 0, 10), cases: 84},
			{m: new Date(2021, 0, 17), cases: 70}
		]
	},
	"97403": {
		"pop":12701,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.2281976033732",
		"centroid_lng":"-123.05163213606",
		"cum_cases_start":"15",
		"cum_cases_end":"403",
		"data": [
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 20},
			{m: new Date(2020, 9, 11), cases: 41},
			{m: new Date(2020, 9, 18), cases: 33},
			{m: new Date(2020, 9, 25), cases: 24},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 9},
			{m: new Date(2020, 10, 22), cases: 12},
			{m: new Date(2020, 10, 29), cases: 11},
			{m: new Date(2020, 11, 6), cases: 21},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 19},
			{m: new Date(2021, 0, 10), cases: 37},
			{m: new Date(2021, 0, 17), cases: 80}
		]
	},
	"97404": {
		"pop":35582,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.3029446456943",
		"centroid_lng":"-123.133268394988",
		"cum_cases_start":"18",
		"cum_cases_end":"682",
		"data": [
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 14},
			{m: new Date(2020, 8, 20), cases: 15},
			{m: new Date(2020, 8, 27), cases: 16},
			{m: new Date(2020, 9, 4), cases: 28},
			{m: new Date(2020, 9, 11), cases: 16},
			{m: new Date(2020, 9, 18), cases: 24},
			{m: new Date(2020, 9, 25), cases: 30},
			{m: new Date(2020, 10, 1), cases: 20},
			{m: new Date(2020, 10, 8), cases: 29},
			{m: new Date(2020, 10, 15), cases: 35},
			{m: new Date(2020, 10, 22), cases: 39},
			{m: new Date(2020, 10, 29), cases: 39},
			{m: new Date(2020, 11, 6), cases: 55},
			{m: new Date(2020, 11, 13), cases: 44},
			{m: new Date(2020, 11, 20), cases: 48},
			{m: new Date(2020, 11, 27), cases: 33},
			{m: new Date(2021, 0, 3), cases: 47},
			{m: new Date(2021, 0, 10), cases: 57},
			{m: new Date(2021, 0, 17), cases: 32}
		]
	},
	"97405": {
		"pop":47657,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.1529118495502",
		"centroid_lng":"-123.146718519359",
		"cum_cases_start":"10",
		"cum_cases_end":"563",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 19},
			{m: new Date(2020, 9, 4), cases: 11},
			{m: new Date(2020, 9, 11), cases: 24},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 9},
			{m: new Date(2020, 10, 1), cases: 13},
			{m: new Date(2020, 10, 8), cases: 28},
			{m: new Date(2020, 10, 15), cases: 41},
			{m: new Date(2020, 10, 22), cases: 43},
			{m: new Date(2020, 10, 29), cases: 38},
			{m: new Date(2020, 11, 6), cases: 43},
			{m: new Date(2020, 11, 13), cases: 59},
			{m: new Date(2020, 11, 20), cases: 32},
			{m: new Date(2020, 11, 27), cases: 21},
			{m: new Date(2021, 0, 3), cases: 26},
			{m: new Date(2021, 0, 10), cases: 34},
			{m: new Date(2021, 0, 17), cases: 44}
		]
	},
	"97408": {
		"pop":14306,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Eugene",
		"centroid_lat":"44.3410231771568",
		"centroid_lng":"-123.062438141968",
		"cum_cases_start":"18",
		"cum_cases_end":"267",
		"data": [
			{m: new Date(2020, 6, 19), cases: 7},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 7},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 12},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 19},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 25},
			{m: new Date(2020, 11, 13), cases: 13},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 27},
			{m: new Date(2021, 0, 10), cases: 19},
			{m: new Date(2021, 0, 17), cases: 14}
		]
	},
	"97411": {
		"pop":7906,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Bandon",
		"centroid_lat":"43.2715892607516",
		"centroid_lng":"-124.364408461485",
		"cum_cases_start":"11",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97415": {
		"pop":15615,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Brookings",
		"centroid_lat":"42.4060440361739",
		"centroid_lng":"-124.094243494477",
		"cum_cases_start":"11",
		"cum_cases_end":"248",
		"data": [
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 5},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 16},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 26},
			{m: new Date(2020, 11, 13), cases: 38},
			{m: new Date(2020, 11, 20), cases: 23},
			{m: new Date(2020, 11, 27), cases: 21},
			{m: new Date(2021, 0, 3), cases: 18},
			{m: new Date(2021, 0, 10), cases: 20},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97417": {
		"pop":2848,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Canyonville",
		"centroid_lat":"43.1421280026974",
		"centroid_lng":"-123.223052690537",
		"cum_cases_start":"38",
		"cum_cases_end":"69",
		"data": [
			{m: new Date(2020, 10, 29), cases: 27},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97419": {
		"pop":1186,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Cheshire",
		"centroid_lat":"44.3702629527467",
		"centroid_lng":"-123.407253565678",
		"cum_cases_start":"12",
		"cum_cases_end":"29",
		"data": [
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97420": {
		"pop":28531,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Coos Bay",
		"centroid_lat":"43.5265003010719",
		"centroid_lng":"-124.151328948122",
		"cum_cases_start":"23",
		"cum_cases_end":"454",
		"data": [
			{m: new Date(2020, 6, 19), cases: 7},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 11},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 10},
			{m: new Date(2020, 9, 4), cases: 13},
			{m: new Date(2020, 9, 11), cases: 17},
			{m: new Date(2020, 9, 18), cases: 22},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 10},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 26},
			{m: new Date(2020, 10, 22), cases: 24},
			{m: new Date(2020, 10, 29), cases: 26},
			{m: new Date(2020, 11, 6), cases: 37},
			{m: new Date(2020, 11, 13), cases: 34},
			{m: new Date(2020, 11, 20), cases: 33},
			{m: new Date(2020, 11, 27), cases: 21},
			{m: new Date(2021, 0, 3), cases: 40},
			{m: new Date(2021, 0, 10), cases: 47},
			{m: new Date(2021, 0, 17), cases: 18}
		]
	},
	"97423": {
		"pop":6854,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Coquille",
		"centroid_lat":"43.3784659479984",
		"centroid_lng":"-124.170924824402",
		"cum_cases_start":"13",
		"cum_cases_end":"62",
		"data": [
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 9},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97424": {
		"pop":19434,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Cottage Grove",
		"centroid_lat":"43.8952081255463",
		"centroid_lng":"-123.003970971252",
		"cum_cases_start":"11",
		"cum_cases_end":"288",
		"data": [
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 10},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 6},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 8},
			{m: new Date(2020, 10, 29), cases: 23},
			{m: new Date(2020, 11, 6), cases: 18},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 29},
			{m: new Date(2020, 11, 27), cases: 20},
			{m: new Date(2021, 0, 3), cases: 14},
			{m: new Date(2021, 0, 10), cases: 42},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97426": {
		"pop":10610,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Creswell",
		"centroid_lat":"44.0988802175279",
		"centroid_lng":"-123.027978733467",
		"cum_cases_start":"12",
		"cum_cases_end":"217",
		"data": [
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 29},
			{m: new Date(2020, 11, 6), cases: 38},
			{m: new Date(2020, 11, 13), cases: 29},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 13},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 15},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97431": {
		"pop":3005,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Dexter",
		"centroid_lat":"44.0448495450136",
		"centroid_lng":"-122.79209815905",
		"cum_cases_start":"16",
		"cum_cases_end":"34",
		"data": [
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97435": {
		"pop":2360,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Drain",
		"centroid_lat":"43.954757845345",
		"centroid_lng":"-123.463417421571",
		"cum_cases_start":"11",
		"cum_cases_end":"26",
		"data": [
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97437": {
		"pop":3035,
		"first_date":"11/22",
		"last_date":"1/17",
		"name":"Elmira",
		"centroid_lat":"44.2891365296548",
		"centroid_lng":"-123.390994333163",
		"cum_cases_start":"12",
		"cum_cases_end":"31",
		"data": [
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97438": {
		"pop":1413,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Fall Creek",
		"centroid_lat":"44.1557202611379",
		"centroid_lng":"-122.558173551754",
		"cum_cases_start":"10",
		"cum_cases_end":"20",
		"data": [
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97439": {
		"pop":15740,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Florence",
		"centroid_lat":"44.2492168183506",
		"centroid_lng":"-124.043249805869",
		"cum_cases_start":"14",
		"cum_cases_end":"138",
		"data": [
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 12},
			{m: new Date(2021, 0, 3), cases: 28},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 18}
		]
	},
	"97442": {
		"pop":2491,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Glendale",
		"centroid_lat":"43.0287903554712",
		"centroid_lng":"-123.544028011358",
		"cum_cases_start":"11",
		"cum_cases_end":"14",
		"data": [
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97443": {
		"pop":2614,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Glide",
		"centroid_lat":"43.5089301838494",
		"centroid_lng":"-122.57357989075",
		"cum_cases_start":"11",
		"cum_cases_end":"23",
		"data": [
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97444": {
		"pop":5744,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Gold Beach",
		"centroid_lat":"42.6073006552044",
		"centroid_lng":"-124.360542901821",
		"cum_cases_start":"19",
		"cum_cases_end":"37",
		"data": [
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97446": {
		"pop":5291,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"Harrisburg",
		"centroid_lat":"44.458556181086",
		"centroid_lng":"-123.063822644421",
		"cum_cases_start":"14",
		"cum_cases_end":"149",
		"data": [
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 9},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 26},
			{m: new Date(2020, 10, 29), cases: 20},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 11},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 5}
		]
	},
	"97448": {
		"pop":13752,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Junction City",
		"centroid_lat":"44.3982052881128",
		"centroid_lng":"-123.27437122506",
		"cum_cases_start":"10",
		"cum_cases_end":"342",
		"data": [
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 19},
			{m: new Date(2020, 10, 22), cases: 42},
			{m: new Date(2020, 10, 29), cases: 36},
			{m: new Date(2020, 11, 6), cases: 26},
			{m: new Date(2020, 11, 13), cases: 29},
			{m: new Date(2020, 11, 20), cases: 22},
			{m: new Date(2020, 11, 27), cases: 17},
			{m: new Date(2021, 0, 3), cases: 28},
			{m: new Date(2021, 0, 10), cases: 32},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97449": {
		"pop":2029,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Lakeside",
		"centroid_lat":"43.7730240675074",
		"centroid_lng":"-124.102766624114",
		"cum_cases_start":"10",
		"cum_cases_end":"11",
		"data": [
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97452": {
		"pop":1661,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Lowell",
		"centroid_lat":"44.0681039057288",
		"centroid_lng":"-122.678166097948",
		"cum_cases_start":"10",
		"cum_cases_end":"23",
		"data": [
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97454": {
		"pop":1527,
		"first_date":"12/6",
		"last_date":"1/17",
		"name":"Marcola",
		"centroid_lat":"44.4136587149799",
		"centroid_lng":"-122.782685493143",
		"cum_cases_start":"15",
		"cum_cases_end":"21",
		"data": [
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97455": {
		"pop":2332,
		"first_date":"10/25",
		"last_date":"1/17",
		"name":"Pleasant Hill",
		"centroid_lat":"44.1580131169609",
		"centroid_lng":"-122.91561663772",
		"cum_cases_start":"17",
		"cum_cases_end":"49",
		"data": [
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 6}
		]
	},
	"97456": {
		"pop":3122,
		"first_date":"10/11",
		"last_date":"1/17",
		"name":"Monroe",
		"centroid_lat":"44.5398381245949",
		"centroid_lng":"-123.36285681973",
		"cum_cases_start":"11",
		"cum_cases_end":"42",
		"data": [
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97457": {
		"pop":10759,
		"first_date":"9/13",
		"last_date":"1/17",
		"name":"Myrtle Creek",
		"centroid_lat":"43.2601403274343",
		"centroid_lng":"-123.199938451957",
		"cum_cases_start":"15",
		"cum_cases_end":"155",
		"data": [
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 15},
			{m: new Date(2020, 10, 29), cases: 11},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 15},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97458": {
		"pop":4774,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Myrtle Point",
		"centroid_lat":"43.2768261031162",
		"centroid_lng":"-123.949196256672",
		"cum_cases_start":"12",
		"cum_cases_end":"32",
		"data": [
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97459": {
		"pop":14881,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"North Bend",
		"centroid_lat":"43.6364475081332",
		"centroid_lng":"-123.998508603645",
		"cum_cases_start":"26",
		"cum_cases_end":"192",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 5},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 11},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 9},
			{m: new Date(2020, 10, 29), cases: 12},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 10},
			{m: new Date(2021, 0, 10), cases: 24},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97462": {
		"pop":4068,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Oakland",
		"centroid_lat":"43.6858065100395",
		"centroid_lng":"-123.396565081759",
		"cum_cases_start":"11",
		"cum_cases_end":"75",
		"data": [
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 4},
			{m: new Date(2020, 10, 29), cases: 8},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97463": {
		"pop":4347,
		"first_date":"10/11",
		"last_date":"1/17",
		"name":"Oakridge",
		"centroid_lat":"43.8994878960761",
		"centroid_lng":"-122.30764020122",
		"cum_cases_start":"12",
		"cum_cases_end":"64",
		"data": [
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97467": {
		"pop":5617,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Reedsport",
		"centroid_lat":"43.9071257199241",
		"centroid_lng":"-123.87790932584",
		"cum_cases_start":"29",
		"cum_cases_end":"70",
		"data": [
			{m: new Date(2020, 10, 15), cases: 17},
			{m: new Date(2020, 10, 22), cases: 19},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97469": {
		"pop":2704,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Riddle",
		"centroid_lat":"43.1278250280141",
		"centroid_lng":"-123.416968450023",
		"cum_cases_start":"26",
		"cum_cases_end":"35",
		"data": [
			{m: new Date(2020, 10, 29), cases: 11},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97470": {
		"pop":20837,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Roseburg",
		"centroid_lat":"43.4204899545749",
		"centroid_lng":"-123.239957406729",
		"cum_cases_start":"14",
		"cum_cases_end":"322",
		"data": [
			{m: new Date(2020, 6, 12), cases: 2},
			{m: new Date(2020, 6, 19), cases: 6},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 8},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 8},
			{m: new Date(2020, 9, 18), cases: 10},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 31},
			{m: new Date(2020, 10, 15), cases: 32},
			{m: new Date(2020, 10, 22), cases: 44},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 19},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 23},
			{m: new Date(2021, 0, 10), cases: 19},
			{m: new Date(2021, 0, 17), cases: 21}
		]
	},
	"97471": {
		"pop":30833,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Roseburg",
		"centroid_lat":"43.4165231262448",
		"centroid_lng":"-123.511638946365",
		"cum_cases_start":"13",
		"cum_cases_end":"464",
		"data": [
			{m: new Date(2020, 6, 12), cases: 2},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 8},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 11},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 7},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 8},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 11},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 22},
			{m: new Date(2020, 10, 15), cases: 40},
			{m: new Date(2020, 10, 22), cases: 65},
			{m: new Date(2020, 10, 29), cases: 47},
			{m: new Date(2020, 11, 6), cases: 40},
			{m: new Date(2020, 11, 13), cases: 27},
			{m: new Date(2020, 11, 20), cases: 32},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 22},
			{m: new Date(2021, 0, 10), cases: 29},
			{m: new Date(2021, 0, 17), cases: 33}
		]
	},
	"97477": {
		"pop":38563,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Springfield",
		"centroid_lat":"44.2509099019109",
		"centroid_lng":"-123.010355633536",
		"cum_cases_start":"11",
		"cum_cases_end":"1057",
		"data": [
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 5},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 9},
			{m: new Date(2020, 6, 26), cases: 11},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 10},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 8},
			{m: new Date(2020, 8, 13), cases: 9},
			{m: new Date(2020, 8, 20), cases: 14},
			{m: new Date(2020, 8, 27), cases: 17},
			{m: new Date(2020, 9, 4), cases: 24},
			{m: new Date(2020, 9, 11), cases: 20},
			{m: new Date(2020, 9, 18), cases: 18},
			{m: new Date(2020, 9, 25), cases: 22},
			{m: new Date(2020, 10, 1), cases: 17},
			{m: new Date(2020, 10, 8), cases: 40},
			{m: new Date(2020, 10, 15), cases: 51},
			{m: new Date(2020, 10, 22), cases: 83},
			{m: new Date(2020, 10, 29), cases: 72},
			{m: new Date(2020, 11, 6), cases: 88},
			{m: new Date(2020, 11, 13), cases: 96},
			{m: new Date(2020, 11, 20), cases: 110},
			{m: new Date(2020, 11, 27), cases: 87},
			{m: new Date(2021, 0, 3), cases: 63},
			{m: new Date(2021, 0, 10), cases: 99},
			{m: new Date(2021, 0, 17), cases: 44}
		]
	},
	"97478": {
		"pop":40114,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Springfield",
		"centroid_lat":"44.2824018744655",
		"centroid_lng":"-122.817569546521",
		"cum_cases_start":"19",
		"cum_cases_end":"1008",
		"data": [
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 6},
			{m: new Date(2020, 7, 2), cases: 12},
			{m: new Date(2020, 7, 9), cases: 21},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 13},
			{m: new Date(2020, 8, 20), cases: 10},
			{m: new Date(2020, 8, 27), cases: 15},
			{m: new Date(2020, 9, 4), cases: 20},
			{m: new Date(2020, 9, 11), cases: 21},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 27},
			{m: new Date(2020, 10, 1), cases: 22},
			{m: new Date(2020, 10, 8), cases: 17},
			{m: new Date(2020, 10, 15), cases: 45},
			{m: new Date(2020, 10, 22), cases: 86},
			{m: new Date(2020, 10, 29), cases: 81},
			{m: new Date(2020, 11, 6), cases: 89},
			{m: new Date(2020, 11, 13), cases: 119},
			{m: new Date(2020, 11, 20), cases: 81},
			{m: new Date(2020, 11, 27), cases: 39},
			{m: new Date(2021, 0, 3), cases: 90},
			{m: new Date(2021, 0, 10), cases: 51},
			{m: new Date(2021, 0, 17), cases: 50}
		]
	},
	"97479": {
		"pop":10112,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Sutherlin",
		"centroid_lat":"43.6218936093199",
		"centroid_lng":"-123.140464665088",
		"cum_cases_start":"17",
		"cum_cases_end":"214",
		"data": [
			{m: new Date(2020, 6, 26), cases: 4},
			{m: new Date(2020, 7, 2), cases: 18},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 18},
			{m: new Date(2020, 10, 15), cases: 16},
			{m: new Date(2020, 10, 22), cases: 15},
			{m: new Date(2020, 10, 29), cases: 10},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 29},
			{m: new Date(2021, 0, 10), cases: 24},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97487": {
		"pop":9115,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Veneta",
		"centroid_lat":"44.1327493574749",
		"centroid_lng":"-123.431206128509",
		"cum_cases_start":"10",
		"cum_cases_end":"148",
		"data": [
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 7},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 5},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 12},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 12},
			{m: new Date(2020, 11, 27), cases: 11},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 11}
		]
	},
	"97488": {
		"pop":1150,
		"first_date":"12/27",
		"last_date":"1/17",
		"name":"Vida",
		"centroid_lat":"44.3220279466403",
		"centroid_lng":"-122.424368232752",
		"cum_cases_start":"12",
		"cum_cases_end":"14",
		"data": [
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97495": {
		"pop":1585,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Winchester",
		"centroid_lat":"43.4768285232594",
		"centroid_lng":"-123.323650928161",
		"cum_cases_start":"12",
		"cum_cases_end":"25",
		"data": [
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97496": {
		"pop":8434,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Winston",
		"centroid_lat":"43.2435793018245",
		"centroid_lng":"-123.495730251833",
		"cum_cases_start":"10",
		"cum_cases_end":"85",
		"data": [
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 8},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97498": {
		"pop":1977,
		"first_date":"1/3",
		"last_date":"1/17",
		"name":"Yachats",
		"centroid_lat":"44.4464321577291",
		"centroid_lng":"-124.035590731665",
		"cum_cases_start":"12",
		"cum_cases_end":"14",
		"data": [
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97499": {
		"pop":2037,
		"first_date":"12/20",
		"last_date":"1/17",
		"name":"Yoncalla",
		"centroid_lat":"43.8000560057455",
		"centroid_lng":"-123.279877044739",
		"cum_cases_start":"14",
		"cum_cases_end":"30",
		"data": [
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97501": {
		"pop":45655,
		"first_date":"6/7",
		"last_date":"1/17",
		"name":"Medford",
		"centroid_lat":"42.4793590691143",
		"centroid_lng":"-122.893345489459",
		"cum_cases_start":"15",
		"cum_cases_end":"2071",
		"data": [
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 7},
			{m: new Date(2020, 6, 19), cases: 20},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 45},
			{m: new Date(2020, 7, 9), cases: 30},
			{m: new Date(2020, 7, 16), cases: 35},
			{m: new Date(2020, 7, 23), cases: 69},
			{m: new Date(2020, 7, 30), cases: 33},
			{m: new Date(2020, 8, 7), cases: 30},
			{m: new Date(2020, 8, 13), cases: 21},
			{m: new Date(2020, 8, 20), cases: 28},
			{m: new Date(2020, 8, 27), cases: 30},
			{m: new Date(2020, 9, 4), cases: 34},
			{m: new Date(2020, 9, 11), cases: 39},
			{m: new Date(2020, 9, 18), cases: 50},
			{m: new Date(2020, 9, 25), cases: 57},
			{m: new Date(2020, 10, 1), cases: 75},
			{m: new Date(2020, 10, 8), cases: 120},
			{m: new Date(2020, 10, 15), cases: 181},
			{m: new Date(2020, 10, 22), cases: 161},
			{m: new Date(2020, 10, 29), cases: 192},
			{m: new Date(2020, 11, 6), cases: 138},
			{m: new Date(2020, 11, 13), cases: 134},
			{m: new Date(2020, 11, 20), cases: 118},
			{m: new Date(2020, 11, 27), cases: 78},
			{m: new Date(2021, 0, 3), cases: 98},
			{m: new Date(2021, 0, 10), cases: 122},
			{m: new Date(2021, 0, 17), cases: 72}
		]
	},
	"97502": {
		"pop":29656,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Central Point",
		"centroid_lat":"42.5995033738818",
		"centroid_lng":"-122.946921721016",
		"cum_cases_start":"13",
		"cum_cases_end":"968",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 1},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 9},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 17},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 12},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 15},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 23},
			{m: new Date(2020, 10, 1), cases: 36},
			{m: new Date(2020, 10, 8), cases: 68},
			{m: new Date(2020, 10, 15), cases: 86},
			{m: new Date(2020, 10, 22), cases: 72},
			{m: new Date(2020, 10, 29), cases: 76},
			{m: new Date(2020, 11, 6), cases: 83},
			{m: new Date(2020, 11, 13), cases: 76},
			{m: new Date(2020, 11, 20), cases: 61},
			{m: new Date(2020, 11, 27), cases: 42},
			{m: new Date(2021, 0, 3), cases: 74},
			{m: new Date(2021, 0, 10), cases: 67},
			{m: new Date(2021, 0, 17), cases: 46}
		]
	},
	"97503": {
		"pop":12041,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"White City",
		"centroid_lat":"42.7405342957649",
		"centroid_lng":"-122.907136813192",
		"cum_cases_start":"10",
		"cum_cases_end":"583",
		"data": [
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 6},
			{m: new Date(2020, 6, 19), cases: 10},
			{m: new Date(2020, 6, 26), cases: 11},
			{m: new Date(2020, 7, 2), cases: 14},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 21},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 14},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 11},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 13},
			{m: new Date(2020, 9, 4), cases: 17},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 19},
			{m: new Date(2020, 10, 1), cases: 22},
			{m: new Date(2020, 10, 8), cases: 44},
			{m: new Date(2020, 10, 15), cases: 32},
			{m: new Date(2020, 10, 22), cases: 34},
			{m: new Date(2020, 10, 29), cases: 44},
			{m: new Date(2020, 11, 6), cases: 49},
			{m: new Date(2020, 11, 13), cases: 40},
			{m: new Date(2020, 11, 20), cases: 26},
			{m: new Date(2020, 11, 27), cases: 19},
			{m: new Date(2021, 0, 3), cases: 30},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 14}
		]
	},
	"97504": {
		"pop":49028,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Medford",
		"centroid_lat":"42.5270281368315",
		"centroid_lng":"-122.796600988628",
		"cum_cases_start":"12",
		"cum_cases_end":"1683",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 2},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 2},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 12},
			{m: new Date(2020, 7, 9), cases: 19},
			{m: new Date(2020, 7, 16), cases: 26},
			{m: new Date(2020, 7, 23), cases: 21},
			{m: new Date(2020, 7, 30), cases: 12},
			{m: new Date(2020, 8, 7), cases: 17},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 19},
			{m: new Date(2020, 8, 27), cases: 29},
			{m: new Date(2020, 9, 4), cases: 30},
			{m: new Date(2020, 9, 11), cases: 36},
			{m: new Date(2020, 9, 18), cases: 27},
			{m: new Date(2020, 9, 25), cases: 32},
			{m: new Date(2020, 10, 1), cases: 55},
			{m: new Date(2020, 10, 8), cases: 123},
			{m: new Date(2020, 10, 15), cases: 110},
			{m: new Date(2020, 10, 22), cases: 151},
			{m: new Date(2020, 10, 29), cases: 124},
			{m: new Date(2020, 11, 6), cases: 119},
			{m: new Date(2020, 11, 13), cases: 93},
			{m: new Date(2020, 11, 20), cases: 109},
			{m: new Date(2020, 11, 27), cases: 83},
			{m: new Date(2021, 0, 3), cases: 121},
			{m: new Date(2021, 0, 10), cases: 153},
			{m: new Date(2021, 0, 17), cases: 102}
		]
	},
	"97520": {
		"pop":27164,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Ashland",
		"centroid_lat":"42.3669823961866",
		"centroid_lng":"-122.544578820278",
		"cum_cases_start":"10",
		"cum_cases_end":"436",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 1},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 3},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 7},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 7},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 18},
			{m: new Date(2020, 10, 8), cases: 19},
			{m: new Date(2020, 10, 15), cases: 27},
			{m: new Date(2020, 10, 22), cases: 33},
			{m: new Date(2020, 10, 29), cases: 33},
			{m: new Date(2020, 11, 6), cases: 40},
			{m: new Date(2020, 11, 13), cases: 45},
			{m: new Date(2020, 11, 20), cases: 27},
			{m: new Date(2020, 11, 27), cases: 16},
			{m: new Date(2021, 0, 3), cases: 25},
			{m: new Date(2021, 0, 10), cases: 30},
			{m: new Date(2021, 0, 17), cases: 27}
		]
	},
	"97523": {
		"pop":7719,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Cave Junction",
		"centroid_lat":"42.3073796480991",
		"centroid_lng":"-123.569558624636",
		"cum_cases_start":"11",
		"cum_cases_end":"87",
		"data": [
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 7},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 7},
			{m: new Date(2020, 11, 13), cases: 6},
			{m: new Date(2020, 11, 20), cases: 8},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 19},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97524": {
		"pop":15986,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Eagle Point",
		"centroid_lat":"42.6792084430134",
		"centroid_lng":"-122.704951468706",
		"cum_cases_start":"16",
		"cum_cases_end":"385",
		"data": [
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 5},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 21},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 16},
			{m: new Date(2020, 10, 8), cases: 24},
			{m: new Date(2020, 10, 15), cases: 22},
			{m: new Date(2020, 10, 22), cases: 29},
			{m: new Date(2020, 10, 29), cases: 35},
			{m: new Date(2020, 11, 6), cases: 44},
			{m: new Date(2020, 11, 13), cases: 28},
			{m: new Date(2020, 11, 20), cases: 19},
			{m: new Date(2020, 11, 27), cases: 18},
			{m: new Date(2021, 0, 3), cases: 17},
			{m: new Date(2021, 0, 10), cases: 22},
			{m: new Date(2021, 0, 17), cases: 13}
		]
	},
	"97525": {
		"pop":5268,
		"first_date":"8/23",
		"last_date":"1/17",
		"name":"Gold Hill",
		"centroid_lat":"42.6359455700491",
		"centroid_lng":"-123.081103225125",
		"cum_cases_start":"13",
		"cum_cases_end":"101",
		"data": [
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 13},
			{m: new Date(2020, 11, 6), cases: 10},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97526": {
		"pop":36281,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Grants Pass",
		"centroid_lat":"42.7731795676314",
		"centroid_lng":"-123.453547529408",
		"cum_cases_start":"12",
		"cum_cases_end":"760",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 10},
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 4},
			{m: new Date(2020, 6, 26), cases: 7},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 12},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 5},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 7},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 10},
			{m: new Date(2020, 10, 15), cases: 14},
			{m: new Date(2020, 10, 22), cases: 33},
			{m: new Date(2020, 10, 29), cases: 57},
			{m: new Date(2020, 11, 6), cases: 59},
			{m: new Date(2020, 11, 13), cases: 77},
			{m: new Date(2020, 11, 20), cases: 60},
			{m: new Date(2020, 11, 27), cases: 75},
			{m: new Date(2021, 0, 3), cases: 77},
			{m: new Date(2021, 0, 10), cases: 117},
			{m: new Date(2021, 0, 17), cases: 67}
		]
	},
	"97527": {
		"pop":34900,
		"first_date":"7/12",
		"last_date":"1/17",
		"name":"Grants Pass",
		"centroid_lat":"42.5704515978213",
		"centroid_lng":"-123.383098343653",
		"cum_cases_start":"14",
		"cum_cases_end":"727",
		"data": [
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 6},
			{m: new Date(2020, 7, 16), cases: 17},
			{m: new Date(2020, 7, 23), cases: 8},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 9},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 3},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 11},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 13},
			{m: new Date(2020, 10, 15), cases: 14},
			{m: new Date(2020, 10, 22), cases: 36},
			{m: new Date(2020, 10, 29), cases: 48},
			{m: new Date(2020, 11, 6), cases: 59},
			{m: new Date(2020, 11, 13), cases: 68},
			{m: new Date(2020, 11, 20), cases: 58},
			{m: new Date(2020, 11, 27), cases: 50},
			{m: new Date(2021, 0, 3), cases: 86},
			{m: new Date(2021, 0, 10), cases: 112},
			{m: new Date(2021, 0, 17), cases: 74}
		]
	},
	"97530": {
		"pop":7965,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Jacksonville",
		"centroid_lat":"42.34629346561",
		"centroid_lng":"-123.061280284672",
		"cum_cases_start":"13",
		"cum_cases_end":"165",
		"data": [
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 14},
			{m: new Date(2020, 10, 15), cases: 17},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 13},
			{m: new Date(2020, 11, 13), cases: 14},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 9},
			{m: new Date(2021, 0, 3), cases: 17},
			{m: new Date(2021, 0, 10), cases: 7},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97532": {
		"pop":2674,
		"first_date":"11/22",
		"last_date":"1/17",
		"name":"Merlin",
		"centroid_lat":"42.7110455567608",
		"centroid_lng":"-123.740002146104",
		"cum_cases_start":"14",
		"cum_cases_end":"45",
		"data": [
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97535": {
		"pop":5815,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Phoenix",
		"centroid_lat":"42.4627150880984",
		"centroid_lng":"-122.812777512942",
		"cum_cases_start":"16",
		"cum_cases_end":"124",
		"data": [
			{m: new Date(2020, 7, 30), cases: 5},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 10},
			{m: new Date(2020, 10, 15), cases: 12},
			{m: new Date(2020, 10, 22), cases: 15},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 6},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 6},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 8},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97537": {
		"pop":7431,
		"first_date":"8/30",
		"last_date":"1/17",
		"name":"Rogue River",
		"centroid_lat":"42.8018160299674",
		"centroid_lng":"-123.121969796645",
		"cum_cases_start":"11",
		"cum_cases_end":"125",
		"data": [
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 6},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 11},
			{m: new Date(2020, 11, 6), cases: 12},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 15},
			{m: new Date(2020, 11, 27), cases: 13},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 6}
		]
	},
	"97538": {
		"pop":2720,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Selma",
		"centroid_lat":"42.4787567473624",
		"centroid_lng":"-123.676499491593",
		"cum_cases_start":"15",
		"cum_cases_end":"27",
		"data": [
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 2},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97539": {
		"pop":3838,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Shady Cove",
		"centroid_lat":"42.8136772164986",
		"centroid_lng":"-122.814914557291",
		"cum_cases_start":"15",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97540": {
		"pop":9456,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Talent",
		"centroid_lat":"42.4029283649153",
		"centroid_lng":"-122.800230374635",
		"cum_cases_start":"14",
		"cum_cases_end":"189",
		"data": [
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 9},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 4},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 3},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 8},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 12},
			{m: new Date(2020, 10, 29), cases: 10},
			{m: new Date(2020, 11, 6), cases: 15},
			{m: new Date(2020, 11, 13), cases: 11},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	},
	"97541": {
		"pop":1483,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Trail",
		"centroid_lat":"42.9235881726112",
		"centroid_lng":"-122.782827588211",
		"cum_cases_start":"14",
		"cum_cases_end":"22",
		"data": [
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97544": {
		"pop":2313,
		"first_date":"1/10",
		"last_date":"1/17",
		"name":"Williams",
		"centroid_lat":"42.3756934019012",
		"centroid_lng":"-123.307312960589",
		"cum_cases_start":"13",
		"cum_cases_end":"14",
		"data": [
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97601": {
		"pop":23582,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Klamath Falls",
		"centroid_lat":"42.5325245104142",
		"centroid_lng":"-122.068745749212",
		"cum_cases_start":"14",
		"cum_cases_end":"779",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 21},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 2},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 21},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 9},
			{m: new Date(2020, 9, 11), cases: 9},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 8},
			{m: new Date(2020, 10, 8), cases: 10},
			{m: new Date(2020, 10, 15), cases: 21},
			{m: new Date(2020, 10, 22), cases: 42},
			{m: new Date(2020, 10, 29), cases: 82},
			{m: new Date(2020, 11, 6), cases: 108},
			{m: new Date(2020, 11, 13), cases: 60},
			{m: new Date(2020, 11, 20), cases: 82},
			{m: new Date(2020, 11, 27), cases: 44},
			{m: new Date(2021, 0, 3), cases: 61},
			{m: new Date(2021, 0, 10), cases: 84},
			{m: new Date(2021, 0, 17), cases: 36}
		]
	},
	"97603": {
		"pop":31146,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Klamath Falls",
		"centroid_lat":"42.3320831299009",
		"centroid_lng":"-121.717704575627",
		"cum_cases_start":"18",
		"cum_cases_end":"1287",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 1},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 10},
			{m: new Date(2020, 5, 28), cases: 9},
			{m: new Date(2020, 6, 5), cases: 6},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 10},
			{m: new Date(2020, 6, 26), cases: 7},
			{m: new Date(2020, 7, 2), cases: 6},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 5},
			{m: new Date(2020, 7, 30), cases: 7},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 4},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 65},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 8},
			{m: new Date(2020, 10, 1), cases: 10},
			{m: new Date(2020, 10, 8), cases: 22},
			{m: new Date(2020, 10, 15), cases: 21},
			{m: new Date(2020, 10, 22), cases: 84},
			{m: new Date(2020, 10, 29), cases: 132},
			{m: new Date(2020, 11, 6), cases: 141},
			{m: new Date(2020, 11, 13), cases: 128},
			{m: new Date(2020, 11, 20), cases: 125},
			{m: new Date(2020, 11, 27), cases: 98},
			{m: new Date(2021, 0, 3), cases: 107},
			{m: new Date(2021, 0, 10), cases: 149},
			{m: new Date(2021, 0, 17), cases: 80}
		]
	},
	"97623": {
		"pop":2464,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Bonanza",
		"centroid_lat":"42.3972475662832",
		"centroid_lng":"-121.178231890407",
		"cum_cases_start":"11",
		"cum_cases_end":"37",
		"data": [
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 6},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97624": {
		"pop":4413,
		"first_date":"9/13",
		"last_date":"1/17",
		"name":"Chiloquin",
		"centroid_lat":"42.931648223437",
		"centroid_lng":"-121.639354806927",
		"cum_cases_start":"10",
		"cum_cases_end":"97",
		"data": [
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 8},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 10},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 13},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97630": {
		"pop":5292,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Lakeview",
		"centroid_lat":"42.4419806898109",
		"centroid_lng":"-120.547987799345",
		"cum_cases_start":"18",
		"cum_cases_end":"190",
		"data": [
			{m: new Date(2020, 6, 5), cases: 4},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 2},
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 34},
			{m: new Date(2020, 10, 29), cases: 35},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 18},
			{m: new Date(2020, 11, 20), cases: 7},
			{m: new Date(2020, 11, 27), cases: 7},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 16},
			{m: new Date(2021, 0, 17), cases: 9}
		]
	},
	"97632": {
		"pop":1457,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Malin",
		"centroid_lat":"42.2308006521891",
		"centroid_lng":"-121.431263875007",
		"cum_cases_start":"10",
		"cum_cases_end":"71",
		"data": [
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 4},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 23},
			{m: new Date(2020, 11, 13), cases: 5},
			{m: new Date(2020, 11, 20), cases: 5},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97633": {
		"pop":1308,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Merrill",
		"centroid_lat":"42.2234658030261",
		"centroid_lng":"-121.547186334464",
		"cum_cases_start":"11",
		"cum_cases_end":"68",
		"data": [
			{m: new Date(2020, 7, 2), cases: 1},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 10},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 14},
			{m: new Date(2020, 11, 13), cases: 4},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 5},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97641": {
		"pop":1261,
		"first_date":"11/8",
		"last_date":"1/17",
		"name":"Christmas Valley",
		"centroid_lat":"43.5461767365723",
		"centroid_lng":"-120.467479456454",
		"cum_cases_start":"10",
		"cum_cases_end":"26",
		"data": [
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97701": {
		"pop":40102,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Bend",
		"centroid_lat":"44.2119796476034",
		"centroid_lng":"-121.049309628877",
		"cum_cases_start":"35",
		"cum_cases_end":"1149",
		"data": [
			{m: new Date(2020, 4, 16), cases: 2},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 7},
			{m: new Date(2020, 6, 5), cases: 15},
			{m: new Date(2020, 6, 12), cases: 9},
			{m: new Date(2020, 6, 19), cases: 42},
			{m: new Date(2020, 6, 26), cases: 32},
			{m: new Date(2020, 7, 2), cases: 19},
			{m: new Date(2020, 7, 9), cases: 28},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 8},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 17},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 26},
			{m: new Date(2020, 9, 18), cases: 11},
			{m: new Date(2020, 9, 25), cases: 21},
			{m: new Date(2020, 10, 1), cases: 37},
			{m: new Date(2020, 10, 8), cases: 54},
			{m: new Date(2020, 10, 15), cases: 49},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 119},
			{m: new Date(2020, 11, 6), cases: 99},
			{m: new Date(2020, 11, 13), cases: 81},
			{m: new Date(2020, 11, 20), cases: 69},
			{m: new Date(2020, 11, 27), cases: 53},
			{m: new Date(2021, 0, 3), cases: 83},
			{m: new Date(2021, 0, 10), cases: 96},
			{m: new Date(2021, 0, 17), cases: 55}
		]
	},
	"97702": {
		"pop":49732,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Bend",
		"centroid_lat":"44.1654727866849",
		"centroid_lng":"-121.238243397751",
		"cum_cases_start":"25",
		"cum_cases_end":"1372",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 10},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 1},
			{m: new Date(2020, 5, 21), cases: 3},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 12},
			{m: new Date(2020, 6, 12), cases: 18},
			{m: new Date(2020, 6, 19), cases: 28},
			{m: new Date(2020, 6, 26), cases: 25},
			{m: new Date(2020, 7, 2), cases: 21},
			{m: new Date(2020, 7, 9), cases: 18},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 31},
			{m: new Date(2020, 8, 20), cases: 22},
			{m: new Date(2020, 8, 27), cases: 24},
			{m: new Date(2020, 9, 4), cases: 16},
			{m: new Date(2020, 9, 11), cases: 21},
			{m: new Date(2020, 9, 18), cases: 16},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 47},
			{m: new Date(2020, 10, 8), cases: 47},
			{m: new Date(2020, 10, 15), cases: 57},
			{m: new Date(2020, 10, 22), cases: 77},
			{m: new Date(2020, 10, 29), cases: 144},
			{m: new Date(2020, 11, 6), cases: 99},
			{m: new Date(2020, 11, 13), cases: 91},
			{m: new Date(2020, 11, 20), cases: 73},
			{m: new Date(2020, 11, 27), cases: 60},
			{m: new Date(2021, 0, 3), cases: 114},
			{m: new Date(2021, 0, 10), cases: 128},
			{m: new Date(2021, 0, 17), cases: 96}
		]
	},
	"97703": {
		"pop":30996,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Bend",
		"centroid_lat":"44.3075835248662",
		"centroid_lng":"-121.429435455706",
		"cum_cases_start":"14",
		"cum_cases_end":"636",
		"data": [
			{m: new Date(2020, 4, 16), cases: 1},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 0},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 2},
			{m: new Date(2020, 5, 28), cases: 6},
			{m: new Date(2020, 6, 5), cases: 9},
			{m: new Date(2020, 6, 12), cases: 11},
			{m: new Date(2020, 6, 19), cases: 9},
			{m: new Date(2020, 6, 26), cases: 15},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 3},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 11},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 14},
			{m: new Date(2020, 9, 11), cases: 10},
			{m: new Date(2020, 9, 18), cases: 20},
			{m: new Date(2020, 9, 25), cases: 12},
			{m: new Date(2020, 10, 1), cases: 24},
			{m: new Date(2020, 10, 8), cases: 34},
			{m: new Date(2020, 10, 15), cases: 33},
			{m: new Date(2020, 10, 22), cases: 38},
			{m: new Date(2020, 10, 29), cases: 66},
			{m: new Date(2020, 11, 6), cases: 72},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 41},
			{m: new Date(2020, 11, 27), cases: 26},
			{m: new Date(2021, 0, 3), cases: 28},
			{m: new Date(2021, 0, 10), cases: 52},
			{m: new Date(2021, 0, 17), cases: 25}
		]
	},
	"97707": {
		"pop":7110,
		"first_date":"10/11",
		"last_date":"1/17",
		"name":"Bend",
		"centroid_lat":"44.1333282758248",
		"centroid_lng":"-121.580996167598",
		"cum_cases_start":"12",
		"cum_cases_end":"97",
		"data": [
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 4},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 13},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 9},
			{m: new Date(2020, 11, 20), cases: 12},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 8},
			{m: new Date(2021, 0, 10), cases: 5},
			{m: new Date(2021, 0, 17), cases: 9}
		]
	},
	"97720": {
		"pop":4561,
		"first_date":"11/1",
		"last_date":"1/17",
		"name":"Burns",
		"centroid_lat":"43.7842001475195",
		"centroid_lng":"-118.846673894646",
		"cum_cases_start":"24",
		"cum_cases_end":"110",
		"data": [
			{m: new Date(2020, 10, 1), cases: 13},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 16},
			{m: new Date(2020, 10, 29), cases: 9},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 8},
			{m: new Date(2021, 0, 17), cases: 12}
		]
	},
	"97734": {
		"pop":3262,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Culver",
		"centroid_lat":"44.6845870407851",
		"centroid_lng":"-121.231527649395",
		"cum_cases_start":"10",
		"cum_cases_end":"97",
		"data": [
			{m: new Date(2020, 6, 5), cases: 0},
			{m: new Date(2020, 6, 12), cases: 1},
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 2},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 6},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 9},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 11},
			{m: new Date(2020, 11, 13), cases: 8},
			{m: new Date(2020, 11, 20), cases: 6},
			{m: new Date(2020, 11, 27), cases: 4},
			{m: new Date(2021, 0, 3), cases: 10},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97738": {
		"pop":2093,
		"first_date":"11/1",
		"last_date":"1/17",
		"name":"Hines",
		"centroid_lat":"43.8983980172344",
		"centroid_lng":"-119.320424575215",
		"cum_cases_start":"12",
		"cum_cases_end":"52",
		"data": [
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 11},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 3},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97739": {
		"pop":13577,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"La Pine",
		"centroid_lat":"43.931916410704",
		"centroid_lng":"-121.459308359427",
		"cum_cases_start":"13",
		"cum_cases_end":"189",
		"data": [
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 4},
			{m: new Date(2020, 10, 29), cases: 20},
			{m: new Date(2020, 11, 6), cases: 12},
			{m: new Date(2020, 11, 13), cases: 23},
			{m: new Date(2020, 11, 20), cases: 33},
			{m: new Date(2020, 11, 27), cases: 22},
			{m: new Date(2021, 0, 3), cases: 23},
			{m: new Date(2021, 0, 10), cases: 9},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97741": {
		"pop":13864,
		"first_date":"6/14",
		"last_date":"1/17",
		"name":"Madras",
		"centroid_lat":"44.8630258391262",
		"centroid_lng":"-121.063193185915",
		"cum_cases_start":"19",
		"cum_cases_end":"839",
		"data": [
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 8},
			{m: new Date(2020, 6, 5), cases: 16},
			{m: new Date(2020, 6, 12), cases: 9},
			{m: new Date(2020, 6, 19), cases: 10},
			{m: new Date(2020, 6, 26), cases: 18},
			{m: new Date(2020, 7, 2), cases: 13},
			{m: new Date(2020, 7, 9), cases: 25},
			{m: new Date(2020, 7, 16), cases: 24},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 7},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 7},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 15},
			{m: new Date(2020, 10, 15), cases: 15},
			{m: new Date(2020, 10, 22), cases: 28},
			{m: new Date(2020, 10, 29), cases: 37},
			{m: new Date(2020, 11, 6), cases: 75},
			{m: new Date(2020, 11, 13), cases: 79},
			{m: new Date(2020, 11, 20), cases: 96},
			{m: new Date(2020, 11, 27), cases: 52},
			{m: new Date(2021, 0, 3), cases: 141},
			{m: new Date(2021, 0, 10), cases: 51},
			{m: new Date(2021, 0, 17), cases: 34}
		]
	},
	"97753": {
		"pop":2459,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"Powell Butte",
		"centroid_lat":"44.4398621476445",
		"centroid_lng":"-121.0126483282",
		"cum_cases_start":"12",
		"cum_cases_end":"37",
		"data": [
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 6}
		]
	},
	"97754": {
		"pop":20532,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Prineville",
		"centroid_lat":"44.3793749685003",
		"centroid_lng":"-120.558717584314",
		"cum_cases_start":"13",
		"cum_cases_end":"579",
		"data": [
			{m: new Date(2020, 6, 5), cases: 3},
			{m: new Date(2020, 6, 12), cases: 5},
			{m: new Date(2020, 6, 19), cases: 9},
			{m: new Date(2020, 6, 26), cases: 3},
			{m: new Date(2020, 7, 2), cases: 9},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 4},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 2},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 12},
			{m: new Date(2020, 9, 25), cases: 23},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 18},
			{m: new Date(2020, 10, 15), cases: 26},
			{m: new Date(2020, 10, 22), cases: 27},
			{m: new Date(2020, 10, 29), cases: 41},
			{m: new Date(2020, 11, 6), cases: 59},
			{m: new Date(2020, 11, 13), cases: 54},
			{m: new Date(2020, 11, 20), cases: 42},
			{m: new Date(2020, 11, 27), cases: 36},
			{m: new Date(2021, 0, 3), cases: 46},
			{m: new Date(2021, 0, 10), cases: 69},
			{m: new Date(2021, 0, 17), cases: 51}
		]
	},
	"97756": {
		"pop":40200,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Redmond",
		"centroid_lat":"44.4736517877595",
		"centroid_lng":"-121.216418350987",
		"cum_cases_start":"18",
		"cum_cases_end":"1285",
		"data": [
			{m: new Date(2020, 4, 16), cases: 8},
			{m: new Date(2020, 4, 24), cases: 9},
			{m: new Date(2020, 4, 31), cases: 5},
			{m: new Date(2020, 5, 7), cases: 6},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 0},
			{m: new Date(2020, 5, 28), cases: 3},
			{m: new Date(2020, 6, 5), cases: 7},
			{m: new Date(2020, 6, 12), cases: 3},
			{m: new Date(2020, 6, 19), cases: 15},
			{m: new Date(2020, 6, 26), cases: 17},
			{m: new Date(2020, 7, 2), cases: 10},
			{m: new Date(2020, 7, 9), cases: 16},
			{m: new Date(2020, 7, 16), cases: 8},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 7},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 14},
			{m: new Date(2020, 9, 4), cases: 20},
			{m: new Date(2020, 9, 11), cases: 12},
			{m: new Date(2020, 9, 18), cases: 13},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 31},
			{m: new Date(2020, 10, 8), cases: 33},
			{m: new Date(2020, 10, 15), cases: 34},
			{m: new Date(2020, 10, 22), cases: 68},
			{m: new Date(2020, 10, 29), cases: 161},
			{m: new Date(2020, 11, 6), cases: 117},
			{m: new Date(2020, 11, 13), cases: 120},
			{m: new Date(2020, 11, 20), cases: 75},
			{m: new Date(2020, 11, 27), cases: 84},
			{m: new Date(2021, 0, 3), cases: 84},
			{m: new Date(2021, 0, 10), cases: 127},
			{m: new Date(2021, 0, 17), cases: 126}
		]
	},
	"97759": {
		"pop":7793,
		"first_date":"8/2",
		"last_date":"1/17",
		"name":"Sisters",
		"centroid_lat":"44.4757813999642",
		"centroid_lng":"-121.616478044346",
		"cum_cases_start":"16",
		"cum_cases_end":"161",
		"data": [
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 3},
			{m: new Date(2020, 9, 4), cases: 3},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 6},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 10},
			{m: new Date(2020, 10, 22), cases: 17},
			{m: new Date(2020, 10, 29), cases: 14},
			{m: new Date(2020, 11, 6), cases: 17},
			{m: new Date(2020, 11, 13), cases: 12},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 7},
			{m: new Date(2021, 0, 10), cases: 11},
			{m: new Date(2021, 0, 17), cases: 15}
		]
	},
	"97760": {
		"pop":8261,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Terrebonne",
		"centroid_lat":"44.5690284589727",
		"centroid_lng":"-121.248189636701",
		"cum_cases_start":"13",
		"cum_cases_end":"182",
		"data": [
			{m: new Date(2020, 6, 19), cases: 2},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 1},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 5},
			{m: new Date(2020, 10, 22), cases: 8},
			{m: new Date(2020, 10, 29), cases: 28},
			{m: new Date(2020, 11, 6), cases: 20},
			{m: new Date(2020, 11, 13), cases: 23},
			{m: new Date(2020, 11, 20), cases: 15},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97761": {
		"pop":3045,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Warm Springs",
		"centroid_lat":"44.9393274007377",
		"centroid_lng":"-121.462606129329",
		"cum_cases_start":"17",
		"cum_cases_end":"666",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 14},
			{m: new Date(2020, 5, 7), cases: 8},
			{m: new Date(2020, 5, 14), cases: 5},
			{m: new Date(2020, 5, 21), cases: 6},
			{m: new Date(2020, 5, 28), cases: 10},
			{m: new Date(2020, 6, 5), cases: 18},
			{m: new Date(2020, 6, 12), cases: 21},
			{m: new Date(2020, 6, 19), cases: 26},
			{m: new Date(2020, 6, 26), cases: 37},
			{m: new Date(2020, 7, 2), cases: 24},
			{m: new Date(2020, 7, 9), cases: 35},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 24},
			{m: new Date(2020, 7, 30), cases: 6},
			{m: new Date(2020, 8, 7), cases: 14},
			{m: new Date(2020, 8, 13), cases: 7},
			{m: new Date(2020, 8, 20), cases: 20},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 10},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 27},
			{m: new Date(2020, 10, 22), cases: 40},
			{m: new Date(2020, 10, 29), cases: 47},
			{m: new Date(2020, 11, 6), cases: 55},
			{m: new Date(2020, 11, 13), cases: 49},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 15},
			{m: new Date(2021, 0, 3), cases: 11},
			{m: new Date(2021, 0, 10), cases: 29},
			{m: new Date(2021, 0, 17), cases: 22}
		]
	},
	"97801": {
		"pop":21972,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Pendleton",
		"centroid_lat":"45.8098325588305",
		"centroid_lng":"-118.658785558127",
		"cum_cases_start":"35",
		"cum_cases_end":"1428",
		"data": [
			{m: new Date(2020, 5, 28), cases: 22},
			{m: new Date(2020, 6, 5), cases: 55},
			{m: new Date(2020, 6, 12), cases: 55},
			{m: new Date(2020, 6, 19), cases: 47},
			{m: new Date(2020, 6, 26), cases: 86},
			{m: new Date(2020, 7, 2), cases: 72},
			{m: new Date(2020, 7, 9), cases: 85},
			{m: new Date(2020, 7, 16), cases: 25},
			{m: new Date(2020, 7, 23), cases: 18},
			{m: new Date(2020, 7, 30), cases: 40},
			{m: new Date(2020, 8, 7), cases: 31},
			{m: new Date(2020, 8, 13), cases: 5},
			{m: new Date(2020, 8, 20), cases: 18},
			{m: new Date(2020, 8, 27), cases: 32},
			{m: new Date(2020, 9, 4), cases: 56},
			{m: new Date(2020, 9, 11), cases: 43},
			{m: new Date(2020, 9, 18), cases: 41},
			{m: new Date(2020, 9, 25), cases: 34},
			{m: new Date(2020, 10, 1), cases: 33},
			{m: new Date(2020, 10, 8), cases: 40},
			{m: new Date(2020, 10, 15), cases: 62},
			{m: new Date(2020, 10, 22), cases: 86},
			{m: new Date(2020, 10, 29), cases: 83},
			{m: new Date(2020, 11, 6), cases: 66},
			{m: new Date(2020, 11, 13), cases: 47},
			{m: new Date(2020, 11, 20), cases: 39},
			{m: new Date(2020, 11, 27), cases: 32},
			{m: new Date(2021, 0, 3), cases: 55},
			{m: new Date(2021, 0, 10), cases: 58},
			{m: new Date(2021, 0, 17), cases: 49}
		]
	},
	"97813": {
		"pop":1321,
		"first_date":"9/20",
		"last_date":"1/17",
		"name":"Athena",
		"centroid_lat":"46.0781167268527",
		"centroid_lng":"-118.570839489484",
		"cum_cases_start":"10",
		"cum_cases_end":"50",
		"data": [
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 2},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 10},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97814": {
		"pop":12602,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Baker City",
		"centroid_lat":"44.97884210258",
		"centroid_lng":"-117.726587490474",
		"cum_cases_start":"11",
		"cum_cases_end":"463",
		"data": [
			{m: new Date(2020, 6, 19), cases: 1},
			{m: new Date(2020, 6, 26), cases: 8},
			{m: new Date(2020, 7, 2), cases: 11},
			{m: new Date(2020, 7, 9), cases: 7},
			{m: new Date(2020, 7, 16), cases: 13},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 4},
			{m: new Date(2020, 8, 7), cases: 16},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 4},
			{m: new Date(2020, 9, 4), cases: 6},
			{m: new Date(2020, 9, 11), cases: 9},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 6},
			{m: new Date(2020, 10, 1), cases: 7},
			{m: new Date(2020, 10, 8), cases: 30},
			{m: new Date(2020, 10, 15), cases: 24},
			{m: new Date(2020, 10, 22), cases: 30},
			{m: new Date(2020, 10, 29), cases: 22},
			{m: new Date(2020, 11, 6), cases: 35},
			{m: new Date(2020, 11, 13), cases: 34},
			{m: new Date(2020, 11, 20), cases: 34},
			{m: new Date(2020, 11, 27), cases: 41},
			{m: new Date(2021, 0, 3), cases: 38},
			{m: new Date(2021, 0, 10), cases: 32},
			{m: new Date(2021, 0, 17), cases: 27}
		]
	},
	"97818": {
		"pop":4645,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Boardman",
		"centroid_lat":"45.9507773002951",
		"centroid_lng":"-119.763449530866",
		"cum_cases_start":"11",
		"cum_cases_end":"609",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 0},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 4},
			{m: new Date(2020, 5, 28), cases: 12},
			{m: new Date(2020, 6, 5), cases: 22},
			{m: new Date(2020, 6, 12), cases: 33},
			{m: new Date(2020, 6, 19), cases: 27},
			{m: new Date(2020, 6, 26), cases: 43},
			{m: new Date(2020, 7, 2), cases: 41},
			{m: new Date(2020, 7, 9), cases: 53},
			{m: new Date(2020, 7, 16), cases: 30},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 14},
			{m: new Date(2020, 8, 7), cases: 14},
			{m: new Date(2020, 8, 13), cases: 16},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 14},
			{m: new Date(2020, 9, 4), cases: 12},
			{m: new Date(2020, 9, 11), cases: 5},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 2},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 8},
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 14},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 22},
			{m: new Date(2020, 11, 13), cases: 20},
			{m: new Date(2020, 11, 20), cases: 14},
			{m: new Date(2020, 11, 27), cases: 14},
			{m: new Date(2021, 0, 3), cases: 27},
			{m: new Date(2021, 0, 10), cases: 41},
			{m: new Date(2021, 0, 17), cases: 30}
		]
	},
	"97820": {
		"pop":1238,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Canyon City",
		"centroid_lat":"44.4619469202125",
		"centroid_lng":"-119.009901878008",
		"cum_cases_start":"19",
		"cum_cases_end":"27",
		"data": [
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 1},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97824": {
		"pop":1753,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Cove",
		"centroid_lat":"45.5217451686979",
		"centroid_lng":"-117.746345768245",
		"cum_cases_start":"10",
		"cum_cases_end":"50",
		"data": [
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 6},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 10},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97826": {
		"pop":1335,
		"first_date":"7/26",
		"last_date":"1/17",
		"name":"Echo",
		"centroid_lat":"45.8627725310744",
		"centroid_lng":"-119.241405466208",
		"cum_cases_start":"10",
		"cum_cases_end":"48",
		"data": [
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 4},
			{m: new Date(2020, 7, 16), cases: 1},
			{m: new Date(2020, 7, 23), cases: 2},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 1},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 3},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97827": {
		"pop":3301,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Elgin",
		"centroid_lat":"45.8477659891401",
		"centroid_lng":"-117.899333780747",
		"cum_cases_start":"10",
		"cum_cases_end":"60",
		"data": [
			{m: new Date(2020, 6, 19), cases: 0},
			{m: new Date(2020, 6, 26), cases: 1},
			{m: new Date(2020, 7, 2), cases: 0},
			{m: new Date(2020, 7, 9), cases: 2},
			{m: new Date(2020, 7, 16), cases: 0},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 1},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 4},
			{m: new Date(2020, 9, 18), cases: 3},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 1},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 4},
			{m: new Date(2020, 10, 29), cases: 4},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 3},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 4}
		]
	},
	"97828": {
		"pop":3322,
		"first_date":"9/13",
		"last_date":"1/17",
		"name":"Enterprise",
		"centroid_lat":"45.941913487779",
		"centroid_lng":"-117.384850341019",
		"cum_cases_start":"10",
		"cum_cases_end":"35",
		"data": [
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 2}
		]
	},
	"97836": {
		"pop":2020,
		"first_date":"8/9",
		"last_date":"1/17",
		"name":"Heppner",
		"centroid_lat":"45.4507386859705",
		"centroid_lng":"-119.460217423668",
		"cum_cases_start":"12",
		"cum_cases_end":"36",
		"data": [
			{m: new Date(2020, 7, 9), cases: 0},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 0},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 3},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 4},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97838": {
		"pop":26409,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Hermiston",
		"centroid_lat":"46.0402619310107",
		"centroid_lng":"-119.287823564479",
		"cum_cases_start":"49",
		"cum_cases_end":"2813",
		"data": [
			{m: new Date(2020, 4, 16), cases: 6},
			{m: new Date(2020, 4, 24), cases: 17},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 14},
			{m: new Date(2020, 5, 14), cases: 24},
			{m: new Date(2020, 5, 21), cases: 68},
			{m: new Date(2020, 5, 28), cases: 140},
			{m: new Date(2020, 6, 5), cases: 160},
			{m: new Date(2020, 6, 12), cases: 155},
			{m: new Date(2020, 6, 19), cases: 212},
			{m: new Date(2020, 6, 26), cases: 178},
			{m: new Date(2020, 7, 2), cases: 170},
			{m: new Date(2020, 7, 9), cases: 113},
			{m: new Date(2020, 7, 16), cases: 73},
			{m: new Date(2020, 7, 23), cases: 35},
			{m: new Date(2020, 7, 30), cases: 39},
			{m: new Date(2020, 8, 7), cases: 39},
			{m: new Date(2020, 8, 13), cases: 24},
			{m: new Date(2020, 8, 20), cases: 16},
			{m: new Date(2020, 8, 27), cases: 17},
			{m: new Date(2020, 9, 4), cases: 32},
			{m: new Date(2020, 9, 11), cases: 27},
			{m: new Date(2020, 9, 18), cases: 24},
			{m: new Date(2020, 9, 25), cases: 26},
			{m: new Date(2020, 10, 1), cases: 52},
			{m: new Date(2020, 10, 8), cases: 61},
			{m: new Date(2020, 10, 15), cases: 94},
			{m: new Date(2020, 10, 22), cases: 101},
			{m: new Date(2020, 10, 29), cases: 108},
			{m: new Date(2020, 11, 6), cases: 112},
			{m: new Date(2020, 11, 13), cases: 86},
			{m: new Date(2020, 11, 20), cases: 76},
			{m: new Date(2020, 11, 27), cases: 70},
			{m: new Date(2021, 0, 3), cases: 147},
			{m: new Date(2021, 0, 10), cases: 162},
			{m: new Date(2021, 0, 17), cases: 90}
		]
	},
	"97844": {
		"pop":4013,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Irrigon",
		"centroid_lat":"46.0555839718577",
		"centroid_lng":"-119.527266215114",
		"cum_cases_start":"25",
		"cum_cases_end":"278",
		"data": [
			{m: new Date(2020, 5, 28), cases: 13},
			{m: new Date(2020, 6, 5), cases: 22},
			{m: new Date(2020, 6, 12), cases: 13},
			{m: new Date(2020, 6, 19), cases: 11},
			{m: new Date(2020, 6, 26), cases: 12},
			{m: new Date(2020, 7, 2), cases: 5},
			{m: new Date(2020, 7, 9), cases: 14},
			{m: new Date(2020, 7, 16), cases: 7},
			{m: new Date(2020, 7, 23), cases: 6},
			{m: new Date(2020, 7, 30), cases: 3},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 2},
			{m: new Date(2020, 8, 20), cases: 6},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 4},
			{m: new Date(2020, 9, 25), cases: 4},
			{m: new Date(2020, 10, 1), cases: 5},
			{m: new Date(2020, 10, 8), cases: 9},
			{m: new Date(2020, 10, 15), cases: 6},
			{m: new Date(2020, 10, 22), cases: 12},
			{m: new Date(2020, 10, 29), cases: 13},
			{m: new Date(2020, 11, 6), cases: 16},
			{m: new Date(2020, 11, 13), cases: 19},
			{m: new Date(2020, 11, 20), cases: 9},
			{m: new Date(2020, 11, 27), cases: 10},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 12},
			{m: new Date(2021, 0, 17), cases: 11}
		]
	},
	"97845": {
		"pop":2620,
		"first_date":"11/15",
		"last_date":"1/17",
		"name":"John Day",
		"centroid_lat":"44.6238682486045",
		"centroid_lng":"-118.902269092398",
		"cum_cases_start":"36",
		"cum_cases_end":"89",
		"data": [
			{m: new Date(2020, 10, 15), cases: 8},
			{m: new Date(2020, 10, 22), cases: 27},
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 11}
		]
	},
	"97846": {
		"pop":2048,
		"first_date":"11/1",
		"last_date":"1/17",
		"name":"Joseph",
		"centroid_lat":"45.4763346568643",
		"centroid_lng":"-117.112059795206",
		"cum_cases_start":"12",
		"cum_cases_end":"19",
		"data": [
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 0},
			{m: new Date(2020, 10, 29), cases: 0},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 3},
			{m: new Date(2021, 0, 10), cases: 1},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97850": {
		"pop":17448,
		"first_date":"6/21",
		"last_date":"1/17",
		"name":"La Grande",
		"centroid_lat":"45.4244730787217",
		"centroid_lng":"-118.282861470569",
		"cum_cases_start":"230",
		"cum_cases_end":"856",
		"data": [
			{m: new Date(2020, 5, 21), cases: 135},
			{m: new Date(2020, 5, 28), cases: 54},
			{m: new Date(2020, 6, 5), cases: 24},
			{m: new Date(2020, 6, 12), cases: 8},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 10},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 6},
			{m: new Date(2020, 7, 16), cases: 5},
			{m: new Date(2020, 7, 23), cases: 10},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 2},
			{m: new Date(2020, 8, 27), cases: 7},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 1},
			{m: new Date(2020, 9, 18), cases: 2},
			{m: new Date(2020, 9, 25), cases: 10},
			{m: new Date(2020, 10, 1), cases: 22},
			{m: new Date(2020, 10, 8), cases: 45},
			{m: new Date(2020, 10, 15), cases: 51},
			{m: new Date(2020, 10, 22), cases: 63},
			{m: new Date(2020, 10, 29), cases: 65},
			{m: new Date(2020, 11, 6), cases: 40},
			{m: new Date(2020, 11, 13), cases: 36},
			{m: new Date(2020, 11, 20), cases: 27},
			{m: new Date(2020, 11, 27), cases: 9},
			{m: new Date(2021, 0, 3), cases: 13},
			{m: new Date(2021, 0, 10), cases: 46},
			{m: new Date(2021, 0, 17), cases: 40}
		]
	},
	"97862": {
		"pop":11565,
		"first_date":"5/24",
		"last_date":"1/17",
		"name":"Milton Freewater",
		"centroid_lat":"46.112719585887",
		"centroid_lng":"-118.253977631819",
		"cum_cases_start":"11",
		"cum_cases_end":"731",
		"data": [
			{m: new Date(2020, 4, 24), cases: 0},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 2},
			{m: new Date(2020, 5, 14), cases: 0},
			{m: new Date(2020, 5, 21), cases: 1},
			{m: new Date(2020, 5, 28), cases: 0},
			{m: new Date(2020, 6, 5), cases: 2},
			{m: new Date(2020, 6, 12), cases: 0},
			{m: new Date(2020, 6, 19), cases: 8},
			{m: new Date(2020, 6, 26), cases: 31},
			{m: new Date(2020, 7, 2), cases: 15},
			{m: new Date(2020, 7, 9), cases: 15},
			{m: new Date(2020, 7, 16), cases: 26},
			{m: new Date(2020, 7, 23), cases: 11},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 4},
			{m: new Date(2020, 8, 13), cases: 6},
			{m: new Date(2020, 8, 20), cases: 5},
			{m: new Date(2020, 8, 27), cases: 9},
			{m: new Date(2020, 9, 4), cases: 4},
			{m: new Date(2020, 9, 11), cases: 3},
			{m: new Date(2020, 9, 18), cases: 10},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 31},
			{m: new Date(2020, 10, 8), cases: 35},
			{m: new Date(2020, 10, 15), cases: 25},
			{m: new Date(2020, 10, 22), cases: 33},
			{m: new Date(2020, 10, 29), cases: 53},
			{m: new Date(2020, 11, 6), cases: 45},
			{m: new Date(2020, 11, 13), cases: 63},
			{m: new Date(2020, 11, 20), cases: 122},
			{m: new Date(2020, 11, 27), cases: 37},
			{m: new Date(2021, 0, 3), cases: 29},
			{m: new Date(2021, 0, 10), cases: 38},
			{m: new Date(2021, 0, 17), cases: 43}
		]
	},
	"97865": {
		"pop":1086,
		"first_date":"11/29",
		"last_date":"1/17",
		"name":"Mount Vernon",
		"centroid_lat":"44.6403598077415",
		"centroid_lng":"-119.269754193902",
		"cum_cases_start":"23",
		"cum_cases_end":"24",
		"data": [
			{m: new Date(2020, 10, 29), cases: 7},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97868": {
		"pop":2073,
		"first_date":"7/19",
		"last_date":"1/17",
		"name":"Pilot Rock",
		"centroid_lat":"45.5856759532164",
		"centroid_lng":"-118.89227238884",
		"cum_cases_start":"13",
		"cum_cases_end":"65",
		"data": [
			{m: new Date(2020, 6, 19), cases: 3},
			{m: new Date(2020, 6, 26), cases: 0},
			{m: new Date(2020, 7, 2), cases: 3},
			{m: new Date(2020, 7, 9), cases: 1},
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 1},
			{m: new Date(2020, 8, 7), cases: 1},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 1},
			{m: new Date(2020, 8, 27), cases: 0},
			{m: new Date(2020, 9, 4), cases: 2},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 3},
			{m: new Date(2020, 10, 1), cases: 4},
			{m: new Date(2020, 10, 8), cases: 5},
			{m: new Date(2020, 10, 15), cases: 2},
			{m: new Date(2020, 10, 22), cases: 5},
			{m: new Date(2020, 10, 29), cases: 1},
			{m: new Date(2020, 11, 6), cases: 4},
			{m: new Date(2020, 11, 13), cases: 1},
			{m: new Date(2020, 11, 20), cases: 1},
			{m: new Date(2020, 11, 27), cases: 2},
			{m: new Date(2021, 0, 3), cases: 5},
			{m: new Date(2021, 0, 10), cases: 6},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97869": {
		"pop":1064,
		"first_date":"12/13",
		"last_date":"1/17",
		"name":"Prairie City",
		"centroid_lat":"44.4440238040613",
		"centroid_lng":"-118.560902601751",
		"cum_cases_start":"20",
		"cum_cases_end":"23",
		"data": [
			{m: new Date(2020, 11, 13), cases: 2},
			{m: new Date(2020, 11, 20), cases: 2},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 0},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97875": {
		"pop":2677,
		"first_date":"6/28",
		"last_date":"1/17",
		"name":"Stanfield",
		"centroid_lat":"45.9949864124802",
		"centroid_lng":"-119.187548389064",
		"cum_cases_start":"16",
		"cum_cases_end":"277",
		"data": [
			{m: new Date(2020, 5, 28), cases: 4},
			{m: new Date(2020, 6, 5), cases: 8},
			{m: new Date(2020, 6, 12), cases: 20},
			{m: new Date(2020, 6, 19), cases: 22},
			{m: new Date(2020, 6, 26), cases: 15},
			{m: new Date(2020, 7, 2), cases: 12},
			{m: new Date(2020, 7, 9), cases: 10},
			{m: new Date(2020, 7, 16), cases: 10},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 9},
			{m: new Date(2020, 8, 7), cases: 2},
			{m: new Date(2020, 8, 13), cases: 4},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 1},
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 7},
			{m: new Date(2020, 10, 22), cases: 11},
			{m: new Date(2020, 10, 29), cases: 24},
			{m: new Date(2020, 11, 6), cases: 5},
			{m: new Date(2020, 11, 13), cases: 7},
			{m: new Date(2020, 11, 20), cases: 16},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 14},
			{m: new Date(2021, 0, 10), cases: 31},
			{m: new Date(2021, 0, 17), cases: 10}
		]
	},
	"97882": {
		"pop":8555,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Umatilla",
		"centroid_lat":"46.1041555457301",
		"centroid_lng":"-119.326268013375",
		"cum_cases_start":"17",
		"cum_cases_end":"1319",
		"data": [
			{m: new Date(2020, 4, 16), cases: 0},
			{m: new Date(2020, 4, 24), cases: 1},
			{m: new Date(2020, 4, 31), cases: 3},
			{m: new Date(2020, 5, 7), cases: 7},
			{m: new Date(2020, 5, 14), cases: 10},
			{m: new Date(2020, 5, 21), cases: 15},
			{m: new Date(2020, 5, 28), cases: 26},
			{m: new Date(2020, 6, 5), cases: 43},
			{m: new Date(2020, 6, 12), cases: 41},
			{m: new Date(2020, 6, 19), cases: 40},
			{m: new Date(2020, 6, 26), cases: 43},
			{m: new Date(2020, 7, 2), cases: 46},
			{m: new Date(2020, 7, 9), cases: 25},
			{m: new Date(2020, 7, 16), cases: 14},
			{m: new Date(2020, 7, 23), cases: 17},
			{m: new Date(2020, 7, 30), cases: 38},
			{m: new Date(2020, 8, 7), cases: 23},
			{m: new Date(2020, 8, 13), cases: 39},
			{m: new Date(2020, 8, 20), cases: 9},
			{m: new Date(2020, 8, 27), cases: 5},
			{m: new Date(2020, 9, 4), cases: 15},
			{m: new Date(2020, 9, 11), cases: 6},
			{m: new Date(2020, 9, 18), cases: 6},
			{m: new Date(2020, 9, 25), cases: 17},
			{m: new Date(2020, 10, 1), cases: 15},
			{m: new Date(2020, 10, 8), cases: 7},
			{m: new Date(2020, 10, 15), cases: 25},
			{m: new Date(2020, 10, 22), cases: 26},
			{m: new Date(2020, 10, 29), cases: 25},
			{m: new Date(2020, 11, 6), cases: 19},
			{m: new Date(2020, 11, 13), cases: 25},
			{m: new Date(2020, 11, 20), cases: 32},
			{m: new Date(2020, 11, 27), cases: 56},
			{m: new Date(2021, 0, 3), cases: 229},
			{m: new Date(2021, 0, 10), cases: 177},
			{m: new Date(2021, 0, 17), cases: 177}
		]
	},
	"97883": {
		"pop":2824,
		"first_date":"9/20",
		"last_date":"1/17",
		"name":"Union",
		"centroid_lat":"45.3351156986254",
		"centroid_lng":"-117.663624346778",
		"cum_cases_start":"10",
		"cum_cases_end":"61",
		"data": [
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 0},
			{m: new Date(2020, 10, 1), cases: 2},
			{m: new Date(2020, 10, 8), cases: 2},
			{m: new Date(2020, 10, 15), cases: 4},
			{m: new Date(2020, 10, 22), cases: 13},
			{m: new Date(2020, 10, 29), cases: 6},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 4},
			{m: new Date(2020, 11, 27), cases: 1},
			{m: new Date(2021, 0, 3), cases: 0},
			{m: new Date(2021, 0, 10), cases: 4},
			{m: new Date(2021, 0, 17), cases: 3}
		]
	},
	"97885": {
		"pop":1508,
		"first_date":"10/11",
		"last_date":"1/17",
		"name":"Wallowa",
		"centroid_lat":"45.8244198128089",
		"centroid_lng":"-117.570302336188",
		"cum_cases_start":"13",
		"cum_cases_end":"30",
		"data": [
			{m: new Date(2020, 9, 11), cases: 2},
			{m: new Date(2020, 9, 18), cases: 1},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 3},
			{m: new Date(2020, 10, 8), cases: 3},
			{m: new Date(2020, 10, 15), cases: 3},
			{m: new Date(2020, 10, 22), cases: 1},
			{m: new Date(2020, 10, 29), cases: 2},
			{m: new Date(2020, 11, 6), cases: 0},
			{m: new Date(2020, 11, 13), cases: 0},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 0},
			{m: new Date(2021, 0, 3), cases: 1},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 0}
		]
	},
	"97886": {
		"pop":1169,
		"first_date":"8/16",
		"last_date":"1/17",
		"name":"Weston",
		"centroid_lat":"45.9860334685409",
		"centroid_lng":"-118.280869749931",
		"cum_cases_start":"12",
		"cum_cases_end":"42",
		"data": [
			{m: new Date(2020, 7, 16), cases: 2},
			{m: new Date(2020, 7, 23), cases: 0},
			{m: new Date(2020, 7, 30), cases: 0},
			{m: new Date(2020, 8, 7), cases: 0},
			{m: new Date(2020, 8, 13), cases: 0},
			{m: new Date(2020, 8, 20), cases: 0},
			{m: new Date(2020, 8, 27), cases: 1},
			{m: new Date(2020, 9, 4), cases: 0},
			{m: new Date(2020, 9, 11), cases: 0},
			{m: new Date(2020, 9, 18), cases: 0},
			{m: new Date(2020, 9, 25), cases: 1},
			{m: new Date(2020, 10, 1), cases: 0},
			{m: new Date(2020, 10, 8), cases: 0},
			{m: new Date(2020, 10, 15), cases: 1},
			{m: new Date(2020, 10, 22), cases: 3},
			{m: new Date(2020, 10, 29), cases: 5},
			{m: new Date(2020, 11, 6), cases: 8},
			{m: new Date(2020, 11, 13), cases: 3},
			{m: new Date(2020, 11, 20), cases: 0},
			{m: new Date(2020, 11, 27), cases: 3},
			{m: new Date(2021, 0, 3), cases: 2},
			{m: new Date(2021, 0, 10), cases: 2},
			{m: new Date(2021, 0, 17), cases: 1}
		]
	},
	"97913": {
		"pop":5628,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Nyssa",
		"centroid_lat":"43.9978457983485",
		"centroid_lng":"-117.113828121944",
		"cum_cases_start":"35",
		"cum_cases_end":"522",
		"data": [
			{m: new Date(2020, 6, 5), cases: 16},
			{m: new Date(2020, 6, 12), cases: 21},
			{m: new Date(2020, 6, 19), cases: 17},
			{m: new Date(2020, 6, 26), cases: 21},
			{m: new Date(2020, 7, 2), cases: 19},
			{m: new Date(2020, 7, 9), cases: 18},
			{m: new Date(2020, 7, 16), cases: 12},
			{m: new Date(2020, 7, 23), cases: 17},
			{m: new Date(2020, 7, 30), cases: 20},
			{m: new Date(2020, 8, 7), cases: 11},
			{m: new Date(2020, 8, 13), cases: 18},
			{m: new Date(2020, 8, 20), cases: 36},
			{m: new Date(2020, 8, 27), cases: 22},
			{m: new Date(2020, 9, 4), cases: 11},
			{m: new Date(2020, 9, 11), cases: 13},
			{m: new Date(2020, 9, 18), cases: 14},
			{m: new Date(2020, 9, 25), cases: 15},
			{m: new Date(2020, 10, 1), cases: 17},
			{m: new Date(2020, 10, 8), cases: 19},
			{m: new Date(2020, 10, 15), cases: 20},
			{m: new Date(2020, 10, 22), cases: 29},
			{m: new Date(2020, 10, 29), cases: 30},
			{m: new Date(2020, 11, 6), cases: 12},
			{m: new Date(2020, 11, 13), cases: 18},
			{m: new Date(2020, 11, 20), cases: 14},
			{m: new Date(2020, 11, 27), cases: 8},
			{m: new Date(2021, 0, 3), cases: 12},
			{m: new Date(2021, 0, 10), cases: 15},
			{m: new Date(2021, 0, 17), cases: 8}
		]
	},
	"97914": {
		"pop":19388,
		"first_date":"5/16",
		"last_date":"1/17",
		"name":"Ontario",
		"centroid_lat":"44.288251217953",
		"centroid_lng":"-117.039537772472",
		"cum_cases_start":"15",
		"cum_cases_end":"2196",
		"data": [
			{m: new Date(2020, 4, 16), cases: 4},
			{m: new Date(2020, 4, 24), cases: 8},
			{m: new Date(2020, 4, 31), cases: 2},
			{m: new Date(2020, 5, 7), cases: 1},
			{m: new Date(2020, 5, 14), cases: 3},
			{m: new Date(2020, 5, 21), cases: 11},
			{m: new Date(2020, 5, 28), cases: 23},
			{m: new Date(2020, 6, 5), cases: 85},
			{m: new Date(2020, 6, 12), cases: 159},
			{m: new Date(2020, 6, 19), cases: 67},
			{m: new Date(2020, 6, 26), cases: 55},
			{m: new Date(2020, 7, 2), cases: 64},
			{m: new Date(2020, 7, 9), cases: 98},
			{m: new Date(2020, 7, 16), cases: 94},
			{m: new Date(2020, 7, 23), cases: 102},
			{m: new Date(2020, 7, 30), cases: 107},
			{m: new Date(2020, 8, 7), cases: 102},
			{m: new Date(2020, 8, 13), cases: 78},
			{m: new Date(2020, 8, 20), cases: 76},
			{m: new Date(2020, 8, 27), cases: 59},
			{m: new Date(2020, 9, 4), cases: 44},
			{m: new Date(2020, 9, 11), cases: 55},
			{m: new Date(2020, 9, 18), cases: 51},
			{m: new Date(2020, 9, 25), cases: 47},
			{m: new Date(2020, 10, 1), cases: 41},
			{m: new Date(2020, 10, 8), cases: 54},
			{m: new Date(2020, 10, 15), cases: 63},
			{m: new Date(2020, 10, 22), cases: 81},
			{m: new Date(2020, 10, 29), cases: 89},
			{m: new Date(2020, 11, 6), cases: 77},
			{m: new Date(2020, 11, 13), cases: 34},
			{m: new Date(2020, 11, 20), cases: 79},
			{m: new Date(2020, 11, 27), cases: 65},
			{m: new Date(2021, 0, 3), cases: 68},
			{m: new Date(2021, 0, 10), cases: 89},
			{m: new Date(2021, 0, 17), cases: 50}
		]
	},
	"97918": {
		"pop":4468,
		"first_date":"7/5",
		"last_date":"1/17",
		"name":"Vale",
		"centroid_lat":"44.2684052804009",
		"centroid_lng":"-117.304797661854",
		"cum_cases_start":"26",
		"cum_cases_end":"357",
		"data": [
			{m: new Date(2020, 6, 5), cases: 11},
			{m: new Date(2020, 6, 12), cases: 4},
			{m: new Date(2020, 6, 19), cases: 5},
			{m: new Date(2020, 6, 26), cases: 5},
			{m: new Date(2020, 7, 2), cases: 4},
			{m: new Date(2020, 7, 9), cases: 11},
			{m: new Date(2020, 7, 16), cases: 6},
			{m: new Date(2020, 7, 23), cases: 7},
			{m: new Date(2020, 7, 30), cases: 8},
			{m: new Date(2020, 8, 7), cases: 3},
			{m: new Date(2020, 8, 13), cases: 21},
			{m: new Date(2020, 8, 20), cases: 12},
			{m: new Date(2020, 8, 27), cases: 11},
			{m: new Date(2020, 9, 4), cases: 8},
			{m: new Date(2020, 9, 11), cases: 7},
			{m: new Date(2020, 9, 18), cases: 8},
			{m: new Date(2020, 9, 25), cases: 5},
			{m: new Date(2020, 10, 1), cases: 9},
			{m: new Date(2020, 10, 8), cases: 17},
			{m: new Date(2020, 10, 15), cases: 13},
			{m: new Date(2020, 10, 22), cases: 14},
			{m: new Date(2020, 10, 29), cases: 18},
			{m: new Date(2020, 11, 6), cases: 23},
			{m: new Date(2020, 11, 13), cases: 29},
			{m: new Date(2020, 11, 20), cases: 18},
			{m: new Date(2020, 11, 27), cases: 10},
			{m: new Date(2021, 0, 3), cases: 15},
			{m: new Date(2021, 0, 10), cases: 33},
			{m: new Date(2021, 0, 17), cases: 7}
		]
	}
}